import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import type * as VueCompositionApi from 'vue';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: any; output: any; }
  Timestamp: { input: any; output: any; }
};

export type AccountPaymentMetadata = {
  __typename: 'AccountPaymentMetadata';
  payment: Payment;
};

export enum ActionStatus {
  Accepted = 'accepted',
  Canceled = 'canceled',
  Pending = 'pending',
  Processing = 'processing',
  Rejected = 'rejected'
}

export enum ActionType {
  Downgrade = 'DOWNGRADE',
  None = 'NONE',
  Upgrade = 'UPGRADE'
}

export type AffiliateFileItem = {
  __typename: 'AffiliateFileItem';
  count: Scalars['Int']['output'];
  date: Scalars['Timestamp']['output'];
};

export type AffiliateFiles = {
  __typename: 'AffiliateFiles';
  format: Scalars['String']['output'];
  items: Array<AffiliateFileItem>;
  total: Scalars['Int']['output'];
};

export type AffiliateResponse = {
  __typename: 'AffiliateResponse';
  balanceOwed: Scalars['Int']['output'];
  balancePaid: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  conversionRate: Scalars['String']['output'];
  currencies: Array<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  revenue: Scalars['Int']['output'];
  subscriptions: AffiliateSubscriptions;
  totalHops: Scalars['Int']['output'];
  uniqueHops: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  users: AffiliateUsers;
};

export type AffiliateSubscriptionItem = {
  __typename: 'AffiliateSubscriptionItem';
  count: Scalars['Int']['output'];
  date: Scalars['Timestamp']['output'];
};

export type AffiliateSubscriptions = {
  __typename: 'AffiliateSubscriptions';
  format: Scalars['String']['output'];
  items: Array<AffiliateSubscriptionItem>;
  total: Scalars['Int']['output'];
};

export type AffiliateUserItem = {
  __typename: 'AffiliateUserItem';
  count: Scalars['Int']['output'];
  date: Scalars['Timestamp']['output'];
};

export type AffiliateUsers = {
  __typename: 'AffiliateUsers';
  format: Scalars['String']['output'];
  items: Array<AffiliateUserItem>;
  total: Scalars['Int']['output'];
};

export type AggregatedFileControllersResponse = {
  __typename: 'AggregatedFileControllersResponse';
  authors?: Maybe<FileAuthorsResponse>;
  owners?: Maybe<FileOwnersResponse>;
  privacy?: Maybe<FilePrivacyResponse>;
};

export type AgreementUploadResponse = {
  __typename: 'AgreementUploadResponse';
  content: Scalars['String']['output'];
  previewUrl: Scalars['String']['output'];
  uploadPresignedData: FileUploadResponse;
};

export type AgreementUrlResult = {
  __typename: 'AgreementUrlResult';
  url?: Maybe<Scalars['String']['output']>;
};

export type Analysis = {
  __typename: 'Analysis';
  attributes: Array<Attribute>;
  keyFrames?: Maybe<Array<Scalars['String']['output']>>;
  lyrics?: Maybe<Lyrics>;
  markers: Array<Maybe<Marker>>;
  sheetMusic?: Maybe<SheetMusic>;
  stems?: Maybe<Array<Stems>>;
  summary: Scalars['String']['output'];
};

export type AnalysisResponse = {
  __typename: 'AnalysisResponse';
  data?: Maybe<Analysis>;
  status: AnalysisStatus;
};

export enum AnalysisStatus {
  Created = 'CREATED',
  Processing = 'PROCESSING',
  Unsupported = 'UNSUPPORTED'
}

export type ArchivedFile = {
  __typename: 'ArchivedFile';
  archivedAt: Scalars['Timestamp']['output'];
  copyrightType?: Maybe<CopyrightType>;
  fileName: Scalars['String']['output'];
  friendlyType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  size: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transactions: Array<Transaction>;
  type: FileType;
};

export type ArchivedFilesResponse = {
  __typename: 'ArchivedFilesResponse';
  items: Array<ArchivedFile>;
  next?: Maybe<Array<Maybe<Scalars['Any']['output']>>>;
  total: Scalars['Int']['output'];
};

export enum ArchivedStatus {
  Archived = 'archived',
  LicenseArchived = 'licenseArchived',
  None = 'none'
}

export type AssetPreview = {
  __typename: 'AssetPreview';
  numberOfPages?: Maybe<Scalars['Int']['output']>;
  status: AssetPreviewStatus;
  type: AssetPreviewType;
  url: Scalars['String']['output'];
};

export enum AssetPreviewStatus {
  Processing = 'PROCESSING',
  Ready = 'READY'
}

export enum AssetPreviewType {
  Pages = 'PAGES',
  Static = 'STATIC',
  Stream = 'STREAM'
}

export type Attribute = {
  __typename: 'Attribute';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AuthResponse = {
  __typename: 'AuthResponse';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  user: User;
};

export type BasicFile = {
  __typename: 'BasicFile';
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  previewImageUrl?: Maybe<Scalars['String']['output']>;
  type: FileType;
  width?: Maybe<Scalars['Int']['output']>;
};

export type BasicUser = UserBase & {
  __typename: 'BasicUser';
  avatarUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type BatchActionResponse = {
  __typename: 'BatchActionResponse';
  asyncProcess?: Maybe<Scalars['Boolean']['output']>;
};

export type BatchFileUploadResponse = {
  __typename: 'BatchFileUploadResponse';
  uploads: Array<FileUploadResponse>;
};

export type BatchUploadFileInput = {
  copyrightOwnerId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  fileSize?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  recognizedOriginIds?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BatchUploadInput = {
  files: Array<BatchUploadFileInput>;
  parentFolderId: Scalars['String']['input'];
};

export type BillingAlert = {
  __typename: 'BillingAlert';
  date?: Maybe<Scalars['Timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  type: BillingAlertType;
};

export enum BillingAlertType {
  Canceled = 'canceled',
  Chargeback = 'chargeback',
  Downgrade = 'downgrade',
  Overdue = 'overdue',
  RequiresAction = 'requires_action',
  Upgrade = 'upgrade',
  UpgradeBundle = 'upgrade_bundle',
  WillCancel = 'will_cancel'
}

export type BillingCycle = {
  __typename: 'BillingCycle';
  billingCycleCallout?: Maybe<Scalars['String']['output']>;
  billingCycleDescription?: Maybe<Scalars['String']['output']>;
  billingCycleType: Scalars['String']['output'];
  plans: Array<Plan>;
};

export type BillingPlan = {
  __typename: 'BillingPlan';
  dateInfo?: Maybe<BillingPlanDateInfo>;
  description: Scalars['String']['output'];
  details: BillingPlanDetails;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  platform: PlatformType;
  prices: Array<BillingPrice>;
  status: PlanStatus;
  subscriptionCycle?: Maybe<PlanCycle>;
  type: PlanType;
};

export type BillingPlanDateInfo = {
  __typename: 'BillingPlanDateInfo';
  date?: Maybe<Scalars['Timestamp']['output']>;
  prefix: Scalars['String']['output'];
};

export type BillingPlanDetails = {
  __typename: 'BillingPlanDetails';
  callout?: Maybe<Scalars['String']['output']>;
  prices: Array<BillingPrice>;
  upcomingBilling?: Maybe<UpcomingBiling>;
};

export type BillingPrice = {
  __typename: 'BillingPrice';
  description: Scalars['String']['output'];
  details: BillingPriceDetail;
  type?: Maybe<BillingPriceType>;
};

export type BillingPriceDetail = {
  __typename: 'BillingPriceDetail';
  amount?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  localEquivalent?: Maybe<LocalEquivalent>;
  suffix?: Maybe<Scalars['String']['output']>;
};

export enum BillingPriceType {
  File = 'FILE',
  License = 'LICENSE',
  Overdue = 'OVERDUE',
  Subscription = 'SUBSCRIPTION'
}

export type BillingResponse = {
  __typename: 'BillingResponse';
  billingAlert?: Maybe<BillingAlert>;
  /** Only for downgrade */
  currentDetails?: Maybe<BillingPlanDetails>;
  invoices: InvoicesResponse;
  paymentMethod?: Maybe<PaymentMethod>;
  plan: BillingPlan;
  /** If downgrade - next plan */
  upcomingDetails: BillingPlanDetails;
  upsell?: Maybe<UpsellDetails>;
};

export type CanPurchaseResponse = {
  __typename: 'CanPurchaseResponse';
  validationMessage?: Maybe<Scalars['String']['output']>;
};

export type CancelSubResponse = {
  __typename: 'CancelSubResponse';
  paymentMethod?: Maybe<PaymentMethod>;
};

export type Card = {
  __typename: 'Card';
  last4: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CertificateUrlResult = {
  __typename: 'CertificateUrlResult';
  url?: Maybe<Scalars['String']['output']>;
};

export type Chain = {
  __typename: 'Chain';
  currency: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  testnet: Scalars['Boolean']['output'];
};

export type CombinedSearchResult = {
  __typename: 'CombinedSearchResult';
  files: Array<SearchFile>;
  items: Array<Item>;
  token?: Maybe<SearchFile>;
};

export type Config = {
  __typename: 'Config';
  contracts: ConfigContract;
  wallets: ConfigWallets;
};

export type ConfigContract = {
  __typename: 'ConfigContract';
  dacr: Contract;
  license: Contract;
};

export type ConfigWallets = {
  __typename: 'ConfigWallets';
  dacrAddress: Scalars['String']['output'];
  licenseAddress: Scalars['String']['output'];
};

export type ConnectWalletInput = {
  address: Scalars['String']['input'];
  forceConnect?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  signature: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ConnectWalletResponse = {
  __typename: 'ConnectWalletResponse';
  anyTokensToSync: Scalars['Boolean']['output'];
  anyTokensToTransfer: Scalars['Boolean']['output'];
  syncingTokens?: Maybe<Scalars['Boolean']['output']>;
  transferringTokens?: Maybe<Scalars['Boolean']['output']>;
  user: BasicUser;
};

export type Contract = {
  __typename: 'Contract';
  contractAddress: Scalars['String']['output'];
  royalty?: Maybe<Royalty>;
};

export type Copyright = Dacr | License;

export type CopyrightOwner = {
  __typename: 'CopyrightOwner';
  avatarUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isSelected: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: CopyrightOwnerType;
};

export type CopyrightOwnerNew = {
  __typename: 'CopyrightOwnerNew';
  avatarUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isSelected: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  owner: Entity;
  type: CopyrightOwnerType;
};

export enum CopyrightOwnerType {
  Account = 'ACCOUNT',
  Organization = 'ORGANIZATION',
  Personal = 'PERSONAL'
}

export type CopyrightOwnersResponse = {
  __typename: 'CopyrightOwnersResponse';
  items: Array<CopyrightOwner>;
  next?: Maybe<Array<Maybe<Scalars['Any']['output']>>>;
  total: Scalars['Int']['output'];
};

export type CopyrightOwnersResponseNew = {
  __typename: 'CopyrightOwnersResponseNew';
  items: Array<CopyrightOwnerNew>;
  next?: Maybe<Array<Maybe<Scalars['Any']['output']>>>;
  total: Scalars['Int']['output'];
};

export type CopyrightTransaction = {
  __typename: 'CopyrightTransaction';
  contractAddress: Scalars['String']['output'];
  file?: Maybe<File>;
  licenseAction?: Maybe<LicenseAction>;
  owner: Entity;
  price?: Maybe<Price>;
  receiver?: Maybe<Entity>;
  receiverAddress: Scalars['String']['output'];
  royaltyDacr?: Maybe<Royalty>;
  royaltyOwner?: Maybe<Royalty>;
  sender?: Maybe<Entity>;
  status: CopyrightTransactionStatus;
  timestamp: Scalars['Timestamp']['output'];
  tokenId: Scalars['String']['output'];
  transaction: TransactionMetadata;
  type: CopyrightTransactionType;
  wallet: Wallet;
};

export enum CopyrightTransactionQueryType {
  Pending = 'PENDING',
  Posted = 'POSTED'
}

export enum CopyrightTransactionStatus {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Rejected = 'REJECTED'
}

export enum CopyrightTransactionType {
  LicenseRequestReceived = 'LICENSE_REQUEST_RECEIVED',
  LicenseRequestSent = 'LICENSE_REQUEST_SENT',
  PurchaseRequestReceived = 'PURCHASE_REQUEST_RECEIVED',
  PurchaseRequestSent = 'PURCHASE_REQUEST_SENT',
  RoyaltiesRequestReceived = 'ROYALTIES_REQUEST_RECEIVED',
  RoyaltiesRequestSent = 'ROYALTIES_REQUEST_SENT',
  RoyaltyOfferReceived = 'ROYALTY_OFFER_RECEIVED',
  RoyaltyReceived = 'ROYALTY_RECEIVED',
  TransferRequestReceived = 'TRANSFER_REQUEST_RECEIVED',
  TransferRequestSent = 'TRANSFER_REQUEST_SENT'
}

export type CopyrightTransactionsResponse = {
  __typename: 'CopyrightTransactionsResponse';
  copyrightTransactions: Array<CopyrightTransaction>;
  next?: Maybe<Array<Maybe<Scalars['Any']['output']>>>;
};

export enum CopyrightType {
  Dacr = 'DACR',
  License = 'LICENSE'
}

export type CreateSubscriptionResponse = {
  __typename: 'CreateSubscriptionResponse';
  /** Set when the payment was declined/failed — a human-readable reason (no plan, account untouched). */
  failedMessage?: Maybe<Scalars['String']['output']>;
  isScheduled?: Maybe<Scalars['Boolean']['output']>;
  /** The activated plan. Present only on a completed subscription (null on 3DS/decline). */
  plan?: Maybe<BillingPlan>;
  /** Set when the card requires a 3DS challenge — complete it with this clientSecret, then confirm. */
  requiresAction?: Maybe<PaymentRequiresAction>;
};

export type CreateUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  platform?: InputMaybe<PlatformType>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export enum Crypto {
  Pol = 'POL'
}

export type Custom = {
  __typename: 'Custom';
  avatarUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Dacr = {
  __typename: 'Dacr';
  archiveStatus: ArchivedStatus;
  contractAddress?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<Entity>;
  creatorAddress?: Maybe<Scalars['String']['output']>;
  file?: Maybe<File>;
  id: Scalars['ID']['output'];
  licenseStatus: LicenseStatus;
  metadata?: Maybe<DacrMetadata>;
  owner: Entity;
  ownerAddress?: Maybe<Scalars['String']['output']>;
  royaltyOwner?: Maybe<RoyaltyOwner>;
  status: DacrStatus;
  tokenId?: Maybe<Scalars['String']['output']>;
};

export type DacrMetadata = {
  __typename: 'DacrMetadata';
  checksum: Scalars['String']['output'];
  copyright_id: Scalars['String']['output'];
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum DacrStatus {
  Active = 'active',
  Expired = 'expired',
  Inactive = 'inactive'
}

export type DateRangeInput = {
  endDate: Scalars['Timestamp']['input'];
  startDate: Scalars['Timestamp']['input'];
  timezone: Scalars['String']['input'];
};

export type DeactivateResponse = {
  __typename: 'DeactivateResponse';
  requiresAction?: Maybe<PaymentRequiresAction>;
};

export type DeleteResponse = {
  __typename: 'DeleteResponse';
  requiresAction?: Maybe<PaymentRequiresAction>;
};

export type DisconnectWalletInput = {
  address: Scalars['String']['input'];
};

export type DocumentResponse = {
  __typename: 'DocumentResponse';
  date: Scalars['Timestamp']['output'];
  url: Scalars['String']['output'];
};

export enum DocumentType {
  Cookies = 'COOKIES',
  Pricing = 'PRICING',
  Privacy = 'PRIVACY',
  Terms = 'TERMS'
}

export type Email = {
  __typename: 'Email';
  email: Scalars['String']['output'];
};

export type Entity = BasicUser | Organization;

export type EntityInput = {
  id: Scalars['String']['input'];
  type: EntityType;
};

export type EntityOrCustom = BasicUser | Custom | Organization;

export type EntityOrEmail = BasicUser | Email | Organization;

export enum EntityType {
  Email = 'EMAIL',
  Organization = 'ORGANIZATION',
  User = 'USER'
}

export enum ErrorCodes {
  AccessTokenExpired = 'ACCESS_TOKEN_EXPIRED',
  AccessTokenInvalid = 'ACCESS_TOKEN_INVALID',
  Forbidden = 'FORBIDDEN',
  InternalError = 'INTERNAL_ERROR',
  InvalidRefreshToken = 'INVALID_REFRESH_TOKEN',
  LimitExceeded = 'LIMIT_EXCEEDED',
  NotFound = 'NOT_FOUND',
  NotSupported = 'NOT_SUPPORTED',
  PaymentActionRequired = 'PAYMENT_ACTION_REQUIRED',
  PaymentFailed = 'PAYMENT_FAILED',
  PaymentMethodInvalid = 'PAYMENT_METHOD_INVALID',
  RateLimitExceeded = 'RATE_LIMIT_EXCEEDED',
  Unauthorized = 'UNAUTHORIZED',
  UnexpectedError = 'UNEXPECTED_ERROR',
  UploadError = 'UPLOAD_ERROR',
  UploadFileSizeExceededError = 'UPLOAD_FILE_SIZE_EXCEEDED_ERROR',
  ValidationError = 'VALIDATION_ERROR'
}

export type File = {
  __typename: 'File';
  activePrimaryLicenseQuantity?: Maybe<Scalars['Int']['output']>;
  activeSecondaryLicenseQuantity?: Maybe<Scalars['Int']['output']>;
  analysis?: Maybe<AnalysisResponse>;
  archiveStatus: ArchivedStatus;
  archivedAt?: Maybe<Scalars['Timestamp']['output']>;
  authorRole?: Maybe<FileAuthorRole>;
  authorRoles: Array<FileAuthorRole>;
  authors: Array<EntityOrEmail>;
  authorsCount?: Maybe<Scalars['Int']['output']>;
  authorsNew: Array<Entity>;
  billingExpirationDate?: Maybe<Scalars['Timestamp']['output']>;
  certificateUrl?: Maybe<Scalars['String']['output']>;
  contractAddress?: Maybe<Scalars['String']['output']>;
  copyrightId?: Maybe<Scalars['ID']['output']>;
  copyrightType?: Maybe<CopyrightType>;
  description?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  friendlyType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  inactiveReason?: Maybe<InactiveReason>;
  isDownloadAvailable: Scalars['Boolean']['output'];
  isLifetime: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  license?: Maybe<License>;
  licenseStatus?: Maybe<LicenseStatus>;
  notifications?: Maybe<Array<Notification>>;
  owner: Entity;
  ownerAddress?: Maybe<Scalars['String']['output']>;
  owners: Array<EntityOrEmail>;
  ownersCount?: Maybe<Scalars['Int']['output']>;
  ownersNew: Array<Entity>;
  ownershipRole?: Maybe<FileOwnerRole>;
  ownershipRoles: Array<FileOwnerRole>;
  permissions: Array<FilePermission>;
  preview?: Maybe<AssetPreview>;
  privacyControllersCount?: Maybe<Scalars['Int']['output']>;
  privacyRoles: Array<FilePrivacyRole>;
  registrant: BasicUser;
  registrations: Array<Registration>;
  royaltyOwner?: Maybe<RoyaltyOwner>;
  saleStatus?: Maybe<SaleStatus>;
  size: Scalars['String']['output'];
  status: FileStatus;
  timestamp?: Maybe<Scalars['Timestamp']['output']>;
  tokenId?: Maybe<Scalars['String']['output']>;
  transactions: Array<Transaction>;
  transferStatus?: Maybe<TransferStatus>;
  type: FileType;
  vanityName: Scalars['String']['output'];
};

export type FileAuthorAccess = {
  entity: EntityInput;
  role: FileAuthorRole;
};

export enum FileAuthorRole {
  Author = 'AUTHOR'
}

export enum FileAuthorStatus {
  Author = 'AUTHOR',
  Invited = 'INVITED'
}

export type FileAuthorsItem = {
  __typename: 'FileAuthorsItem';
  entity: EntityOrEmail;
  /** @deprecated Field no longer supported */
  status: FileAuthorStatus;
  statuses: Array<FileAuthorStatus>;
};

export type FileAuthorsResponse = {
  __typename: 'FileAuthorsResponse';
  id: Scalars['ID']['output'];
  items: Array<FileAuthorsItem>;
  next?: Maybe<Array<Maybe<Scalars['Any']['output']>>>;
  total: Scalars['Int']['output'];
};

export enum FileCategory {
  Audio = 'AUDIO',
  Code = 'CODE',
  Documents = 'DOCUMENTS',
  Images = 'IMAGES',
  Other = 'OTHER',
  Videos = 'VIDEOS'
}

export type FileMetadata = {
  __typename: 'FileMetadata';
  file: File;
};

export type FileOwnerAccess = {
  entity: EntityInput;
  role: FileOwnerRole;
};

export enum FileOwnerRole {
  ControllingOwner = 'CONTROLLING_OWNER',
  Owner = 'OWNER'
}

export enum FileOwnerStatus {
  ControllingOwner = 'CONTROLLING_OWNER',
  Invited = 'INVITED',
  Owner = 'OWNER'
}

export type FileOwnersItem = {
  __typename: 'FileOwnersItem';
  entity: EntityOrEmail;
  /** @deprecated Field no longer supported */
  status: FileOwnerStatus;
  statuses: Array<FileOwnerStatus>;
};

export type FileOwnersResponse = {
  __typename: 'FileOwnersResponse';
  id: Scalars['ID']['output'];
  items: Array<FileOwnersItem>;
  next?: Maybe<Array<Maybe<Scalars['Any']['output']>>>;
  total: Scalars['Int']['output'];
};

export enum FilePermission {
  Archive = 'ARCHIVE',
  Edit = 'EDIT',
  Invite = 'INVITE',
  PrivacyControls = 'PRIVACY_CONTROLS'
}

export enum FilePrivacy {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type FilePrivacyAccess = {
  entity: EntityInput;
  role: FilePrivacyRole;
};

export type FilePrivacyDownloadStatus = {
  id: Scalars['ID']['input'];
  isDownloadAvailable: Scalars['Boolean']['input'];
};

export type FilePrivacyItem = {
  __typename: 'FilePrivacyItem';
  entity: EntityOrEmail;
  isDownloadAvailable: Scalars['Boolean']['output'];
  /** @deprecated Field no longer supported */
  status: FilePrivacyStatus;
  statuses: Array<FilePrivacyStatus>;
};

export type FilePrivacyResponse = {
  __typename: 'FilePrivacyResponse';
  id: Scalars['ID']['output'];
  items: Array<FilePrivacyItem>;
  next?: Maybe<Array<Maybe<Scalars['Any']['output']>>>;
  total: Scalars['Int']['output'];
};

export enum FilePrivacyRole {
  Viewer = 'VIEWER'
}

export enum FilePrivacyStatus {
  Invited = 'INVITED',
  Viewer = 'VIEWER'
}

export enum FileStatus {
  Active = 'active',
  Inactive = 'inactive'
}

export enum FileType {
  AdobeAfterEffects = 'ADOBE_AFTER_EFFECTS',
  AdobeAudition = 'ADOBE_AUDITION',
  AdobeIllustrator = 'ADOBE_ILLUSTRATOR',
  AdobeIndesign = 'ADOBE_INDESIGN',
  AdobePhotoshop = 'ADOBE_PHOTOSHOP',
  AdobePremierPro = 'ADOBE_PREMIER_PRO',
  Audio = 'AUDIO',
  AutodeskAutocad = 'AUTODESK_AUTOCAD',
  AutodeskFusion = 'AUTODESK_FUSION',
  AutodeskMaya = 'AUTODESK_MAYA',
  Cinema_4D = 'CINEMA_4D',
  Code = 'CODE',
  DavinciResolve = 'DAVINCI_RESOLVE',
  Generic = 'GENERIC',
  Image = 'IMAGE',
  MsAccess = 'MS_ACCESS',
  MsExcel = 'MS_EXCEL',
  MsPowerPoint = 'MS_POWER_POINT',
  MsPublisher = 'MS_PUBLISHER',
  MsWord = 'MS_WORD',
  Pdf = 'PDF',
  Table = 'TABLE',
  Text = 'TEXT',
  ThreeD = 'THREE_D',
  Vector = 'VECTOR',
  Video = 'VIDEO',
  Zip = 'ZIP'
}

export type FileUploadHeaders = {
  __typename: 'FileUploadHeaders';
  Content_Type?: Maybe<Scalars['String']['output']>;
  Policy: Scalars['String']['output'];
  X_Amz_Algorithm: Scalars['String']['output'];
  X_Amz_Credential: Scalars['String']['output'];
  X_Amz_Date: Scalars['String']['output'];
  X_Amz_Security_Token?: Maybe<Scalars['String']['output']>;
  X_Amz_Signature: Scalars['String']['output'];
  bucket: Scalars['String']['output'];
  key: Scalars['String']['output'];
  x_amz_meta_userid: Scalars['String']['output'];
};

export type FileUploadResponse = {
  __typename: 'FileUploadResponse';
  description?: Maybe<Scalars['String']['output']>;
  headers: FileUploadHeaders;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type FilesOverTime = {
  __typename: 'FilesOverTime';
  activeFiles: Scalars['Int']['output'];
  archivedFiles: Scalars['Int']['output'];
  dateHistogram: Array<OverTimeAnalyticsDataPoint>;
  inactiveFiles: Scalars['Int']['output'];
};

export type Folder = {
  __typename: 'Folder';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  numberOfItems: Scalars['Int']['output'];
  timestamp: Scalars['Timestamp']['output'];
};

export type FolderByIdResponse = {
  __typename: 'FolderByIdResponse';
  id: Scalars['ID']['output'];
  items: Array<Item>;
  name: Scalars['String']['output'];
  next?: Maybe<Array<Maybe<Scalars['Any']['output']>>>;
  numberOfItems: Scalars['Int']['output'];
  parentFolderId?: Maybe<Scalars['String']['output']>;
  parentFolderName?: Maybe<Scalars['String']['output']>;
  parentPath?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['Timestamp']['output'];
};

export type FolderByPathResponse = {
  __typename: 'FolderByPathResponse';
  id: Scalars['ID']['output'];
  items: Array<Item>;
  name: Scalars['String']['output'];
  next?: Maybe<Array<Maybe<Scalars['Any']['output']>>>;
  numberOfItems: Scalars['Int']['output'];
  parentFolderId?: Maybe<Scalars['String']['output']>;
  parentPath?: Maybe<Scalars['String']['output']>;
  sortBy: SearchSort;
  timestamp: Scalars['Timestamp']['output'];
};

export type FoldersResponse = {
  __typename: 'FoldersResponse';
  id: Scalars['ID']['output'];
  items: Array<Item>;
  name: Scalars['String']['output'];
  next?: Maybe<Array<Maybe<Scalars['Any']['output']>>>;
  parentFolderId?: Maybe<Scalars['String']['output']>;
};

export enum GuidanceActionState {
  Completed = 'COMPLETED',
  None = 'NONE',
  Show = 'SHOW'
}

export enum GuidanceId {
  CopyrightModal = 'COPYRIGHT_MODAL',
  OwnersInviteModal = 'OWNERS_INVITE_MODAL',
  WelcomeModal = 'WELCOME_MODAL'
}

export type GuidanceState = {
  __typename: 'GuidanceState';
  setAt?: Maybe<Scalars['Timestamp']['output']>;
  state: GuidanceActionState;
};

export type GuidanceStateEntry = {
  __typename: 'GuidanceStateEntry';
  id: GuidanceId;
  state: GuidanceState;
};

export type GuidanceStateInput = {
  action: GuidanceActionState;
  id: GuidanceId;
};

export type GuidanceStates = {
  __typename: 'GuidanceStates';
  states: Array<GuidanceStateEntry>;
};

export enum InactiveReason {
  ExceededFileLimit = 'EXCEEDED_FILE_LIMIT'
}

export type InfringementMatchMetadata = {
  __typename: 'InfringementMatchMetadata';
  id: Scalars['ID']['output'];
  infringingEntity: Entity;
  infringingFile: File;
  level: ScoreLevel;
  registeredEntity: Entity;
  registeredFile: File;
};

export type Invite = {
  __typename: 'Invite';
  from: Entity;
  id: Scalars['ID']['output'];
  reference: InviteReference;
  role?: Maybe<InviteRole>;
  status: InviteStatus;
  to: Entity;
  type: InviteType;
};

export type InviteFileAuthorRole = {
  __typename: 'InviteFileAuthorRole';
  value?: Maybe<FileAuthorRole>;
};

export type InviteFileOwnerRole = {
  __typename: 'InviteFileOwnerRole';
  value?: Maybe<FileOwnerRole>;
};

export type InviteFilePrivacyRole = {
  __typename: 'InviteFilePrivacyRole';
  value?: Maybe<FilePrivacyRole>;
};

export type InviteMetadata = {
  __typename: 'InviteMetadata';
  invite: Invite;
};

export type InviteReference = Dacr | License | Origin;

export type InviteReportReviewRole = {
  __typename: 'InviteReportReviewRole';
  value: Scalars['String']['output'];
};

export type InviteRole = InviteFileAuthorRole | InviteFileOwnerRole | InviteFilePrivacyRole | InviteReportReviewRole | InviteTeamMemberRole;

export enum InviteStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING',
  Removed = 'REMOVED'
}

export type InviteTeamMemberRole = {
  __typename: 'InviteTeamMemberRole';
  value?: Maybe<TeamMemberRole>;
};

export enum InviteType {
  FileAuthorAccess = 'FILE_AUTHOR_ACCESS',
  FileOwnerAccess = 'FILE_OWNER_ACCESS',
  FilePrivacyAccess = 'FILE_PRIVACY_ACCESS',
  ReportReviewAccess = 'REPORT_REVIEW_ACCESS',
  TeamMemberAccess = 'TEAM_MEMBER_ACCESS'
}

export type Invoice = {
  __typename: 'Invoice';
  currency: Scalars['String']['output'];
  date: Scalars['Timestamp']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: InvoiceStatus;
  total: Scalars['Int']['output'];
};

export type InvoiceMetadata = {
  __typename: 'InvoiceMetadata';
  invoice: Invoice;
};

export type InvoicePdfHeaders = {
  __typename: 'InvoicePdfHeaders';
  Policy: Scalars['String']['output'];
  X_Amz_Algorithm: Scalars['String']['output'];
  X_Amz_Credential: Scalars['String']['output'];
  X_Amz_Date: Scalars['String']['output'];
  X_Amz_Security_Token?: Maybe<Scalars['String']['output']>;
  X_Amz_Signature: Scalars['String']['output'];
  bucket: Scalars['String']['output'];
  key: Scalars['String']['output'];
  x_amz_meta_userid: Scalars['String']['output'];
};

export type InvoicePdfResult = {
  __typename: 'InvoicePdfResult';
  status: InvoicePdfStatusEnum;
  url?: Maybe<Scalars['String']['output']>;
};

export enum InvoicePdfStatusEnum {
  Finished = 'finished',
  Processing = 'processing'
}

export enum InvoiceStatus {
  Expired = 'expired',
  Overdue = 'overdue',
  Paid = 'paid'
}

export type InvoicesResponse = {
  __typename: 'InvoicesResponse';
  invoices: Array<Invoice>;
  next?: Maybe<Scalars['String']['output']>;
};

export type IssueLicenseInput = {
  agreement?: InputMaybe<LicenseAgreementInput>;
  allowSellOrTransfer?: InputMaybe<Scalars['Boolean']['input']>;
  copyrightId: Scalars['String']['input'];
  endsAt?: InputMaybe<Scalars['Timestamp']['input']>;
  licenseToOthers?: InputMaybe<LicenseToOthersInput>;
  licenseType: LicenseType;
  licenseeAddress: Scalars['String']['input'];
  price: PriceInput;
  royaltyNormalized?: InputMaybe<Scalars['Float']['input']>;
  startsAt: Scalars['Timestamp']['input'];
};

export type Item = {
  __typename: 'Item';
  file?: Maybe<File>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  numberOfItems?: Maybe<Scalars['Int']['output']>;
  parentFolderId: Scalars['String']['output'];
  parentPath: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['Timestamp']['output']>;
  type: ItemType;
};

export enum ItemType {
  File = 'file',
  Folder = 'folder'
}

export type License = {
  __typename: 'License';
  agreement?: Maybe<LicenseAgreement>;
  canSellOrTransfer: Scalars['Boolean']['output'];
  contractAddress: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['Timestamp']['output']>;
  file?: Maybe<File>;
  id: Scalars['ID']['output'];
  issuedAt: Scalars['Timestamp']['output'];
  licenseToOthers?: Maybe<LicenseToOthers>;
  licenser?: Maybe<Entity>;
  originalCopyright?: Maybe<OriginalCopyright>;
  owner?: Maybe<Entity>;
  ownerRoyalty?: Maybe<RoyaltyOwner>;
  price?: Maybe<Price>;
  timestamp?: Maybe<Scalars['Timestamp']['output']>;
  tokenId: Scalars['String']['output'];
  type?: Maybe<LicenseType>;
};

export type LicenseAction = {
  __typename: 'LicenseAction';
  agreement?: Maybe<LicenseAgreement>;
  allowSellOrTransfer?: Maybe<Scalars['Boolean']['output']>;
  contractAddress?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<Scalars['Timestamp']['output']>;
  fromAddress: Scalars['String']['output'];
  licenseToOthers?: Maybe<LicenseToOthers>;
  referenceId?: Maybe<Scalars['ID']['output']>;
  royaltyDacr?: Maybe<Royalty>;
  royaltyDacrAmount?: Maybe<Price>;
  royaltyOwner?: Maybe<Royalty>;
  royaltyOwnerAmount?: Maybe<Price>;
  startsAt?: Maybe<Scalars['Timestamp']['output']>;
  status: ActionStatus;
  toAddress: Scalars['String']['output'];
  tokenId: Scalars['String']['output'];
  total?: Maybe<Price>;
  transaction?: Maybe<TransactionMetadata>;
  type?: Maybe<LicenseType>;
};

export type LicenseAgreement = {
  __typename: 'LicenseAgreement';
  content: Scalars['String']['output'];
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  type: LicenseAgreementType;
};

export type LicenseAgreementInput = {
  content: Scalars['String']['input'];
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  type: LicenseAgreementType;
};

export enum LicenseAgreementType {
  Text = 'text',
  Url = 'url'
}

export enum LicenseReference {
  Dacr = 'DACR',
  License = 'LICENSE'
}

export enum LicenseStatus {
  Licensed = 'licensed',
  None = 'none',
  Pending = 'pending',
  Processing = 'processing'
}

export type LicenseToOthers = {
  __typename: 'LicenseToOthers';
  agreement?: Maybe<LicenseAgreement>;
  currentSaleQuantity?: Maybe<Scalars['Int']['output']>;
  endsAt?: Maybe<Scalars['Timestamp']['output']>;
  saleQuantity: Scalars['Int']['output'];
  startsAt: Scalars['Timestamp']['output'];
};

export type LicenseToOthersInput = {
  agreement: LicenseAgreementInput;
  endsAt?: InputMaybe<Scalars['Timestamp']['input']>;
  saleQuantity: Scalars['Int']['input'];
  startsAt: Scalars['Timestamp']['input'];
};

export enum LicenseType {
  Primary = 'primary',
  Secondary = 'secondary'
}

export type LicensesResponse = {
  __typename: 'LicensesResponse';
  items: Array<Item>;
  next?: Maybe<Array<Maybe<Scalars['Any']['output']>>>;
};

/**
 * Local currency equivalent for display purposes
 * Shows the price in user's preferred currency
 */
export type LocalEquivalent = {
  __typename: 'LocalEquivalent';
  amount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  renderedPrice: Scalars['String']['output'];
};

export type Lyric = {
  __typename: 'Lyric';
  lyric: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type Lyrics = {
  __typename: 'Lyrics';
  preview: Array<Lyric>;
  url: Scalars['String']['output'];
};

export type MarkNotificationResponse = {
  __typename: 'MarkNotificationResponse';
  unread?: Maybe<Scalars['Int']['output']>;
};

export type Marker = {
  __typename: 'Marker';
  color: Scalars['String']['output'];
  shine: Scalars['Boolean']['output'];
};

export type Match = {
  __typename: 'Match';
  coords: Array<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  file: BasicFile;
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  location: Scalars['String']['output'];
  matchScore?: Maybe<Scalars['Int']['output']>;
  matchType: MatchType;
};

export type MatchPair = {
  __typename: 'MatchPair';
  infringing: Match;
  original: Match;
};

export enum MatchType {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type Membership = {
  __typename: 'Membership';
  expiresAt?: Maybe<Scalars['Timestamp']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  since?: Maybe<Scalars['Timestamp']['output']>;
};

export type MintedTokenMetadata = {
  __typename: 'MintedTokenMetadata';
  transaction: TransactionMetadata;
};

export type Mutation = {
  __typename: 'Mutation';
  acceptInvite: Scalars['Boolean']['output'];
  acceptTerms: User;
  /** @deprecated Field no longer supported */
  addCopyrightOwner: CopyrightOwner;
  /** @deprecated Field no longer supported */
  addCopyrightOwnerEntity: CopyrightOwner;
  addCopyrightOwnerEntityNew: CopyrightOwnerNew;
  addCopyrightOwnerNew: CopyrightOwnerNew;
  archiveFiles: BatchActionResponse;
  cancelPlan: Scalars['String']['output'];
  cancelSubscription: CancelSubResponse;
  changeLicenseAgreementVisibility?: Maybe<Scalars['Boolean']['output']>;
  changePassword: Scalars['String']['output'];
  completeOnboarding: Scalars['Boolean']['output'];
  completeOnboardingStep: Scalars['Boolean']['output'];
  connectWallet: ConnectWalletResponse;
  createAgreementUploadUrl: AgreementUploadResponse;
  createAvatarUploadUrl: FileUploadResponse;
  createBatchUploadUrl: BatchFileUploadResponse;
  createFolder: Folder;
  createNotificationTest: Scalars['Boolean']['output'];
  createOTP?: Maybe<OtpCreateResponse>;
  createSubscription: CreateSubscriptionResponse;
  createUploadUrl: FileUploadResponse;
  createUser: User;
  deactiveAccount: DeactivateResponse;
  declineInvite: Scalars['Boolean']['output'];
  deleteAccount: DeleteResponse;
  deleteCopyrightOwner: Scalars['Boolean']['output'];
  deleteFolders: Scalars['String']['output'];
  disconnectWallet: User;
  download: Scalars['String']['output'];
  forgotPassword: Scalars['String']['output'];
  guidance: GuidanceStates;
  issueLicense: Scalars['Boolean']['output'];
  markAllNotificationsAsRead: MarkNotificationResponse;
  markNotificationAsRead: MarkNotificationResponse;
  moveItems: BatchActionResponse;
  newSignin: NewAuthResponse;
  newSignup: NewAuthResponse;
  pay: BillingResponse;
  refreshAccessToken: RefreshAccessTokenResponse;
  registerDevice: Scalars['Boolean']['output'];
  removeFileAuthorAccess: FileAuthorsResponse;
  removeFileOwnerAccess: FileOwnersResponse;
  removeFilePrivacyAccess: FilePrivacyResponse;
  renameFolder: Folder;
  requestFileAuthorAccess: FileAuthorsResponse;
  requestFileOwnerAccess: FileOwnersResponse;
  requestFilePrivacyAccess: FilePrivacyResponse;
  resetPassword: Scalars['String']['output'];
  selectCopyrightOwner: Scalars['Boolean']['output'];
  signin: AuthResponse;
  signout: Scalars['Boolean']['output'];
  signup: AuthResponse;
  subscribeToDevelopers: Scalars['Boolean']['output'];
  syncTokensToWallet: Scalars['Boolean']['output'];
  trackEvent: Scalars['Boolean']['output'];
  transferTokensToAccount: Scalars['Boolean']['output'];
  updateAccountBio: User;
  updateAccountDateFormat: User;
  updateAccountDefaultFilePrivacy: User;
  updateAccountEmail: User;
  updateAccountLanguage: User;
  updateAccountName: User;
  updateAccountTimezone: User;
  updateAccountTitle: User;
  updateAccountUsername: User;
  updateBillingInformation: UpdateBillingResponse;
  /** @deprecated Field no longer supported */
  updateCopyrightOwner: CopyrightOwner;
  updateCopyrightOwnerNew: CopyrightOwnerNew;
  updateFilePrivacy: BatchActionResponse;
  updateFilePrivacyDownloadStatus: Array<Scalars['Boolean']['output']>;
  updateFileSettings: File;
  validateOTP?: Maybe<OtpValidateResponse>;
  validateResetPasswordToken: Scalars['Boolean']['output'];
};


export type MutationAcceptInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddCopyrightOwnerArgs = {
  autoSelect?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  type?: InputMaybe<CopyrightOwnerType>;
};


export type MutationAddCopyrightOwnerEntityArgs = {
  autoSelect?: InputMaybe<Scalars['Boolean']['input']>;
  input: EntityInput;
};


export type MutationAddCopyrightOwnerEntityNewArgs = {
  autoSelect?: InputMaybe<Scalars['Boolean']['input']>;
  input: EntityInput;
};


export type MutationAddCopyrightOwnerNewArgs = {
  autoSelect?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  type?: InputMaybe<CopyrightOwnerType>;
};


export type MutationArchiveFilesArgs = {
  fileIds: Array<Scalars['ID']['input']>;
};


export type MutationChangeLicenseAgreementVisibilityArgs = {
  copyrightId: Scalars['ID']['input'];
  visiblity?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationChangePasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationCompleteOnboardingStepArgs = {
  answers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  question?: InputMaybe<Scalars['String']['input']>;
  step: Scalars['Int']['input'];
};


export type MutationConnectWalletArgs = {
  input: ConnectWalletInput;
};


export type MutationCreateAgreementUploadUrlArgs = {
  copyrightId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
};


export type MutationCreateAvatarUploadUrlArgs = {
  fileName: Scalars['String']['input'];
};


export type MutationCreateBatchUploadUrlArgs = {
  input: BatchUploadInput;
};


export type MutationCreateFolderArgs = {
  folderName: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
};


export type MutationCreateNotificationTestArgs = {
  input: NotificationType;
};


export type MutationCreateOtpArgs = {
  deviceId: Scalars['String']['input'];
};


export type MutationCreateSubscriptionArgs = {
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  platform: PlatformType;
  productId: Scalars['ID']['input'];
  receipt?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateUploadUrlArgs = {
  copyrightOwnerId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  fileSize?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  parentFolderId: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationDeclineInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCopyrightOwnerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFoldersArgs = {
  folderIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDisconnectWalletArgs = {
  input: DisconnectWalletInput;
};


export type MutationDownloadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationGuidanceArgs = {
  input?: InputMaybe<GuidanceStateInput>;
};


export type MutationIssueLicenseArgs = {
  input: IssueLicenseInput;
};


export type MutationMarkNotificationAsReadArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationMoveItemsArgs = {
  sourceIds: Array<Scalars['ID']['input']>;
  to: Scalars['String']['input'];
};


export type MutationNewSigninArgs = {
  input: NewSigninInput;
};


export type MutationNewSignupArgs = {
  input: NewSignupInput;
};


export type MutationPayArgs = {
  reactivateAccount?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRefreshAccessTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationRegisterDeviceArgs = {
  input: RegisterDeviceInput;
};


export type MutationRemoveFileAuthorAccessArgs = {
  input: RemoveFileAccessInput;
};


export type MutationRemoveFileOwnerAccessArgs = {
  input: RemoveFileAccessInput;
};


export type MutationRemoveFilePrivacyAccessArgs = {
  input: RemoveFileAccessInput;
};


export type MutationRenameFolderArgs = {
  id: Scalars['ID']['input'];
  newFolderName: Scalars['String']['input'];
};


export type MutationRequestFileAuthorAccessArgs = {
  input: RequestFileAuthorAccessInput;
};


export type MutationRequestFileOwnerAccessArgs = {
  input: RequestFileOwnerAccessInput;
};


export type MutationRequestFilePrivacyAccessArgs = {
  input: RequestFilePrivacyAccessInput;
};


export type MutationResetPasswordArgs = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSelectCopyrightOwnerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSigninArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  platform?: InputMaybe<PlatformType>;
};


export type MutationSignupArgs = {
  input: SignupInput;
};


export type MutationSubscribeToDevelopersArgs = {
  email: Scalars['String']['input'];
};


export type MutationSyncTokensToWalletArgs = {
  walletAddress: Scalars['String']['input'];
};


export type MutationTrackEventArgs = {
  data?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationTransferTokensToAccountArgs = {
  walletAddress: Scalars['String']['input'];
};


export type MutationUpdateAccountBioArgs = {
  bio: Scalars['String']['input'];
};


export type MutationUpdateAccountDateFormatArgs = {
  dateFormat: Scalars['String']['input'];
};


export type MutationUpdateAccountDefaultFilePrivacyArgs = {
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateAccountEmailArgs = {
  newEmail: Scalars['String']['input'];
};


export type MutationUpdateAccountLanguageArgs = {
  language: Scalars['String']['input'];
};


export type MutationUpdateAccountNameArgs = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};


export type MutationUpdateAccountTimezoneArgs = {
  timezone?: InputMaybe<TimezoneInput>;
};


export type MutationUpdateAccountTitleArgs = {
  title: Scalars['String']['input'];
};


export type MutationUpdateAccountUsernameArgs = {
  username: Scalars['String']['input'];
};


export type MutationUpdateBillingInformationArgs = {
  paymentMethodId: Scalars['ID']['input'];
};


export type MutationUpdateCopyrightOwnerArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateCopyrightOwnerNewArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateFilePrivacyArgs = {
  fileIds: Array<Scalars['ID']['input']>;
  isPrivate: Scalars['Boolean']['input'];
};


export type MutationUpdateFilePrivacyDownloadStatusArgs = {
  input: UpdateFilePrivacyDownloadStatusInput;
};


export type MutationUpdateFileSettingsArgs = {
  input: UpdateFileSettingsInput;
};


export type MutationValidateOtpArgs = {
  code: Scalars['String']['input'];
};


export type MutationValidateResetPasswordTokenArgs = {
  token: Scalars['String']['input'];
};

export type NewAuthResponse = {
  __typename: 'NewAuthResponse';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type NewSigninInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  platform?: InputMaybe<PlatformType>;
};

export type NewSignupInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  platform?: InputMaybe<PlatformType>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

export type Notification = {
  __typename: 'Notification';
  id: Scalars['ID']['output'];
  metadata?: Maybe<NotificationMetadata>;
  owner: Entity;
  primaryIcon: NotificationIcon;
  read: Scalars['Boolean']['output'];
  secondaryIcon?: Maybe<NotificationIcon>;
  timestamp: Scalars['Timestamp']['output'];
  type: NotificationType;
};

export type NotificationIcon = {
  __typename: 'NotificationIcon';
  alertIcon?: Maybe<Scalars['Boolean']['output']>;
  dacrIcon?: Maybe<Scalars['Boolean']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  syncIcon?: Maybe<Scalars['Boolean']['output']>;
};

export type NotificationMetadata = AccountPaymentMetadata | FileMetadata | InfringementMatchMetadata | InviteMetadata | InvoiceMetadata | ReportMetadata | ReportReviewMetadata | TokenMetadata | TransferToNoAccountMetadata | UploadFileMetadata | UserMetadata;

export enum NotificationType {
  AccountPaymentFailed = 'ACCOUNT_PAYMENT_FAILED',
  AccountPaymentRequiresAction = 'ACCOUNT_PAYMENT_REQUIRES_ACTION',
  ActivatedFullAccess = 'ACTIVATED_FULL_ACCESS',
  ActivatedLimitedAccess = 'ACTIVATED_LIMITED_ACCESS',
  FileAuthorAccessAccepted = 'FILE_AUTHOR_ACCESS_ACCEPTED',
  FileAuthorAccessPending = 'FILE_AUTHOR_ACCESS_PENDING',
  FileAuthorAccessRemoved = 'FILE_AUTHOR_ACCESS_REMOVED',
  FileOwnerAccessAccepted = 'FILE_OWNER_ACCESS_ACCEPTED',
  FileOwnerAccessPending = 'FILE_OWNER_ACCESS_PENDING',
  FileOwnerAccessRemoved = 'FILE_OWNER_ACCESS_REMOVED',
  FilePrivacyAccessAccepted = 'FILE_PRIVACY_ACCESS_ACCEPTED',
  FileUploadEmptyFile = 'FILE_UPLOAD_EMPTY_FILE',
  FileUploadFailed = 'FILE_UPLOAD_FAILED',
  InfringementMatchCreated = 'INFRINGEMENT_MATCH_CREATED',
  InvoiceOverdue = 'INVOICE_OVERDUE',
  LicenseeExpired = 'LICENSEE_EXPIRED',
  LicenseeWillExpire = 'LICENSEE_WILL_EXPIRE',
  LicenserExpired = 'LICENSER_EXPIRED',
  LicenserWillExpire = 'LICENSER_WILL_EXPIRE',
  LicenseRequest = 'LICENSE_REQUEST',
  LicenseRequestCanceled = 'LICENSE_REQUEST_CANCELED',
  LicenseRequestPaid = 'LICENSE_REQUEST_PAID',
  LicenseRequestRejected = 'LICENSE_REQUEST_REJECTED',
  OwnershipAccept = 'OWNERSHIP_ACCEPT',
  OwnershipUserAccept = 'OWNERSHIP_USER_ACCEPT',
  PaymentCanceled = 'PAYMENT_CANCELED',
  PaymentPaid = 'PAYMENT_PAID',
  PaymentRejected = 'PAYMENT_REJECTED',
  PaymentRequest = 'PAYMENT_REQUEST',
  ReceivedFile = 'RECEIVED_FILE',
  ReceivedLicense = 'RECEIVED_LICENSE',
  ReportCreated = 'REPORT_CREATED',
  ReportReviewAccessAccepted = 'REPORT_REVIEW_ACCESS_ACCEPTED',
  ReportReviewAccessPending = 'REPORT_REVIEW_ACCESS_PENDING',
  RoyaltyOfferReceived = 'ROYALTY_OFFER_RECEIVED',
  RoyaltyReceived = 'ROYALTY_RECEIVED',
  SubscriptionDowngradeFailed = 'SUBSCRIPTION_DOWNGRADE_FAILED',
  TeamMemberAccessAccepted = 'TEAM_MEMBER_ACCESS_ACCEPTED',
  TeamMemberAccessPending = 'TEAM_MEMBER_ACCESS_PENDING',
  TeamMemberAccessRemoved = 'TEAM_MEMBER_ACCESS_REMOVED',
  TokenSyncFailed = 'TOKEN_SYNC_FAILED',
  TokenSyncSuccess = 'TOKEN_SYNC_SUCCESS',
  TransferAccepted = 'TRANSFER_ACCEPTED',
  TransferCanceled = 'TRANSFER_CANCELED',
  TransferRejected = 'TRANSFER_REJECTED',
  TransferRequest = 'TRANSFER_REQUEST',
  TransferToNoAccount = 'TRANSFER_TO_NO_ACCOUNT',
  TrialExpiresSoon = 'TRIAL_EXPIRES_SOON',
  UserCreated = 'USER_CREATED',
  UserVerificationFailed = 'USER_VERIFICATION_FAILED',
  UserVerificationSucess = 'USER_VERIFICATION_SUCESS',
  WalletSyncFailed = 'WALLET_SYNC_FAILED',
  WalletSyncSuccess = 'WALLET_SYNC_SUCCESS'
}

export type NotificationsResponse = {
  __typename: 'NotificationsResponse';
  next?: Maybe<Array<Maybe<Scalars['Any']['output']>>>;
  notifications: Array<Notification>;
  unreadNotifications?: Maybe<Scalars['Int']['output']>;
};

export enum OtpAccessStatus {
  Invalid = 'INVALID',
  Valid = 'VALID'
}

export type OtpCreateResponse = {
  __typename: 'OTPCreateResponse';
  code: Scalars['String']['output'];
};

export type OtpGetAccessResponse = {
  __typename: 'OTPGetAccessResponse';
  accessToken?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  status: OtpAccessStatus;
};

export type OtpValidateResponse = {
  __typename: 'OTPValidateResponse';
  validated?: Maybe<Scalars['Boolean']['output']>;
};

export type Onboarding = {
  __typename: 'Onboarding';
  completed: Scalars['Boolean']['output'];
  step?: Maybe<Scalars['Int']['output']>;
};

export type Organization = {
  __typename: 'Organization';
  avatarUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner?: Maybe<Entity>;
};

export type Origin = {
  __typename: 'Origin';
  avatarUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OriginalCopyright = {
  __typename: 'OriginalCopyright';
  copyrightId: Scalars['ID']['output'];
  owner: Entity;
  timestamp: Scalars['Timestamp']['output'];
};

export type OverTimeAnalyticsDataPoint = {
  __typename: 'OverTimeAnalyticsDataPoint';
  date: Scalars['Timestamp']['output'];
  increment: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Payment = {
  __typename: 'Payment';
  failedMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: PaymentStatus;
};

export type PaymentMethod = {
  __typename: 'PaymentMethod';
  card?: Maybe<Card>;
  requiresAction?: Maybe<PaymentRequiresAction>;
};

export type PaymentRequiresAction = {
  __typename: 'PaymentRequiresAction';
  clientSecret: Scalars['String']['output'];
};

export enum PaymentStatus {
  Canceled = 'canceled',
  Processing = 'processing',
  RequiresAction = 'requires_action',
  Succeeded = 'succeeded'
}

export type Payout = {
  __typename: 'Payout';
  amount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  date: Scalars['Timestamp']['output'];
  status: PayoutStatus;
};

export type PayoutResponse = {
  __typename: 'PayoutResponse';
  next?: Maybe<Array<Maybe<Scalars['Any']['output']>>>;
  payouts: Array<Payout>;
  total: Scalars['Int']['output'];
};

export enum PayoutStatus {
  Paid = 'PAID',
  Unpaid = 'UNPAID'
}

export type Plan = {
  __typename: 'Plan';
  benefits?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  footerText?: Maybe<Scalars['String']['output']>;
  headerText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  includes: Array<PlanInclude>;
  items: Array<PlanItem>;
  name: Scalars['String']['output'];
  priceCallout?: Maybe<Scalars['String']['output']>;
  showExtraSpacing?: Maybe<Scalars['Boolean']['output']>;
  tags: Array<Scalars['String']['output']>;
};

export enum PlanCycle {
  Annual = 'ANNUAL',
  Daily = 'DAILY',
  Monthly = 'MONTHLY'
}

export type PlanInclude = {
  __typename: 'PlanInclude';
  description?: Maybe<Scalars['String']['output']>;
  link?: Maybe<PlanIncludeLink>;
  separator?: Maybe<Scalars['Boolean']['output']>;
  text: Scalars['String']['output'];
};

export type PlanIncludeLink = {
  __typename: 'PlanIncludeLink';
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PlanItem = {
  __typename: 'PlanItem';
  action: ActionType;
  maxUnits?: Maybe<Scalars['Int']['output']>;
  nativePlanId?: Maybe<Scalars['String']['output']>;
  nativeProductId?: Maybe<Scalars['String']['output']>;
  prices: Array<PlanPriceItem>;
  productId: Scalars['ID']['output'];
  status: PlanItemStatus;
  upsell?: Maybe<UpsellDetails>;
};

export enum PlanItemStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type PlanPriceDetail = {
  __typename: 'PlanPriceDetail';
  amount?: Maybe<Scalars['Int']['output']>;
  billingCycleType?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  localEquivalent?: Maybe<LocalEquivalent>;
  renderedPrice?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
};

export type PlanPriceItem = {
  __typename: 'PlanPriceItem';
  details?: Maybe<PlanPriceDetail>;
  type?: Maybe<PlanPriceType>;
};

export enum PlanPriceType {
  File = 'FILE',
  Subscription = 'SUBSCRIPTION'
}

export type PlanResponse = {
  __typename: 'PlanResponse';
  activeBillingCycleType?: Maybe<Scalars['String']['output']>;
  defaultBillingCycleType: Scalars['String']['output'];
  groupByBillingCycle: Array<BillingCycle>;
};

export enum PlanStatus {
  Active = 'active',
  Canceled = 'canceled',
  Overdue = 'overdue',
  RequiresAction = 'requires_action'
}

export enum PlanType {
  Basic = 'BASIC',
  Bundle = 'BUNDLE',
  Pro = 'PRO'
}

export enum PlatformType {
  Apple = 'APPLE',
  Google = 'GOOGLE',
  Web = 'WEB'
}

export type Price = {
  __typename: 'Price';
  currency: Scalars['String']['output'];
  decimalDigits?: Maybe<Scalars['Int']['output']>;
  displayValue: Scalars['String']['output'];
  localEquivalent?: Maybe<LocalEquivalent>;
  value: Scalars['String']['output'];
};

export type PriceInput = {
  currency: Scalars['String']['input'];
  decimalDigits: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type Query = {
  __typename: 'Query';
  addOnLicenses: LicensesResponse;
  affiliate: AffiliateResponse;
  agreementUrl: AgreementUrlResult;
  archivedFiles: ArchivedFilesResponse;
  billing: BillingResponse;
  canPurchaseTransaction: CanPurchaseResponse;
  certificateUrl: CertificateUrlResult;
  checkUsernameAvailability: Scalars['Boolean']['output'];
  config: Config;
  confirmPassword: Scalars['Boolean']['output'];
  /** @deprecated Field no longer supported */
  copyrightOwners: CopyrightOwnersResponse;
  copyrightOwnersNew: CopyrightOwnersResponseNew;
  copyrightTransactions: CopyrightTransactionsResponse;
  document: DocumentResponse;
  exchangeRate: Scalars['String']['output'];
  file: File;
  fileAuthors: FileAuthorsResponse;
  fileControllers: AggregatedFileControllersResponse;
  fileOwners: FileOwnersResponse;
  filePrivacyControllers: FilePrivacyResponse;
  files: Array<File>;
  filesOverTime: FilesOverTime;
  folder: FolderByIdResponse;
  folderByPath: FolderByPathResponse;
  folders: FoldersResponse;
  getOTPAccessToken?: Maybe<OtpGetAccessResponse>;
  guidanceStates: GuidanceStates;
  invoicePdf: InvoicePdfResult;
  invoices: InvoicesResponse;
  licensedToMe: LicensesResponse;
  licensedToOthers: LicensesResponse;
  me: User;
  /** The tiers of the plan the signed-in user is subscribed to, regardless of whether that plan is still sold publicly. */
  myPlan?: Maybe<PlanResponse>;
  notifications: NotificationsResponse;
  onboarding: Onboarding;
  payouts: PayoutResponse;
  ping: Scalars['String']['output'];
  plans?: Maybe<PlanResponse>;
  report: ReportResponse;
  search: SearchResult;
  searchEntities: SearchEntitiesResponse;
  searchFiles: SearchFilesResponse;
  searchItems: SearchItemsResponse;
  searchUsers: SearchUsersResponse;
  stats: UserStats;
  users: Array<User>;
  usersOverTime: Array<OverTimeAnalyticsDataPoint>;
  validateEmail: Scalars['Boolean']['output'];
};


export type QueryAddOnLicensesArgs = {
  copyrightId: Scalars['ID']['input'];
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
  sortBy?: InputMaybe<SearchLicenseSort>;
};


export type QueryAffiliateArgs = {
  currency: Scalars['String']['input'];
  from: Scalars['Timestamp']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Timestamp']['input'];
};


export type QueryAgreementUrlArgs = {
  content: Scalars['String']['input'];
};


export type QueryArchivedFilesArgs = {
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
  sortBy?: InputMaybe<SearchSort>;
};


export type QueryBillingArgs = {
  nextInvoice?: InputMaybe<Scalars['Any']['input']>;
};


export type QueryCanPurchaseTransactionArgs = {
  bundleId: Scalars['ID']['input'];
  platform: PlatformType;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCertificateUrlArgs = {
  copyrightId: Scalars['String']['input'];
};


export type QueryCheckUsernameAvailabilityArgs = {
  username: Scalars['String']['input'];
};


export type QueryConfirmPasswordArgs = {
  password: Scalars['String']['input'];
};


export type QueryCopyrightOwnersArgs = {
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
};


export type QueryCopyrightOwnersNewArgs = {
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
};


export type QueryCopyrightTransactionsArgs = {
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SearchSort>;
  type: CopyrightTransactionQueryType;
};


export type QueryDocumentArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  type: DocumentType;
};


export type QueryFileArgs = {
  accessToken?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryFileAuthorsArgs = {
  id: Scalars['ID']['input'];
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
};


export type QueryFileControllersArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFileOwnersArgs = {
  id: Scalars['ID']['input'];
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
};


export type QueryFilePrivacyControllersArgs = {
  id: Scalars['ID']['input'];
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
};


export type QueryFilesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFilesOverTimeArgs = {
  input: DateRangeInput;
};


export type QueryFolderArgs = {
  id: Scalars['ID']['input'];
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
  sortBy?: InputMaybe<SearchSort>;
};


export type QueryFolderByPathArgs = {
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
  path: Scalars['String']['input'];
  sortBy?: InputMaybe<SearchSort>;
};


export type QueryFoldersArgs = {
  id: Scalars['ID']['input'];
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
};


export type QueryGetOtpAccessTokenArgs = {
  code: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
};


export type QueryInvoicePdfArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type QueryInvoicesArgs = {
  nextInvoice?: InputMaybe<Scalars['Any']['input']>;
};


export type QueryLicensedToMeArgs = {
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
  sortBy?: InputMaybe<SearchLicenseSort>;
};


export type QueryLicensedToOthersArgs = {
  copyrightId?: InputMaybe<Scalars['ID']['input']>;
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
  sortBy?: InputMaybe<SearchLicenseSort>;
};


export type QueryMeArgs = {
  platform?: InputMaybe<PlatformType>;
};


export type QueryNotificationsArgs = {
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
};


export type QueryPayoutsArgs = {
  currency: Scalars['String']['input'];
  from: Scalars['Timestamp']['input'];
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
  to: Scalars['Timestamp']['input'];
};


export type QueryPlansArgs = {
  accessToken?: InputMaybe<Scalars['ID']['input']>;
  platform?: InputMaybe<PlatformType>;
};


export type QueryReportArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySearchArgs = {
  query: Scalars['String']['input'];
};


export type QuerySearchEntitiesArgs = {
  filterBy?: InputMaybe<EntityType>;
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
  query: Scalars['String']['input'];
  showOwnEntity?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchFilesArgs = {
  filterBy?: InputMaybe<Array<FileCategory>>;
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
  query: Scalars['String']['input'];
  sortBy?: InputMaybe<SearchSort>;
};


export type QuerySearchItemsArgs = {
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
  query: Scalars['String']['input'];
  sortBy?: InputMaybe<SearchSort>;
};


export type QuerySearchUsersArgs = {
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
  query: Scalars['String']['input'];
  withConnectedWallets?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUsersOverTimeArgs = {
  input: DateRangeInput;
};


export type QueryValidateEmailArgs = {
  email: Scalars['String']['input'];
};

export type RefreshAccessTokenResponse = {
  __typename: 'RefreshAccessTokenResponse';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type RegisterDeviceInput = {
  id: Scalars['String']['input'];
  type: RegisterDeviceType;
};

export enum RegisterDeviceType {
  Apns = 'APNS',
  Fcm = 'FCM'
}

export type Registration = {
  __typename: 'Registration';
  certificateUrl?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['Timestamp']['output']>;
};

export type RemoveFileAccessInput = {
  entity: EntityInput;
  fileId: Scalars['String']['input'];
};

export type Report = {
  __typename: 'Report';
  attributes?: Maybe<Array<Attribute>>;
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  infringingFile: BasicFile;
  matchQuantity: Scalars['Int']['output'];
  matchScore: Scalars['Int']['output'];
  matches: Array<MatchPair>;
  originalFile: BasicFile;
  summary: Scalars['String']['output'];
};

export type ReportMetadata = {
  __typename: 'ReportMetadata';
  id: Scalars['ID']['output'];
  level: ScoreLevel;
  registeredEntity: Entity;
  registeredFile: File;
};

export type ReportResponse = {
  __typename: 'ReportResponse';
  data?: Maybe<Report>;
  status: ReportStatus;
};

export type ReportReviewMetadata = {
  __typename: 'ReportReviewMetadata';
  from: Entity;
  inviteId: Scalars['ID']['output'];
  reportId: Scalars['ID']['output'];
};

export enum ReportStatus {
  Created = 'CREATED',
  Processing = 'PROCESSING',
  Unsupported = 'UNSUPPORTED'
}

export type RequestFileAuthorAccessInput = {
  fileId: Scalars['String']['input'];
  inputs: Array<FileAuthorAccess>;
};

export type RequestFileOwnerAccessInput = {
  fileId: Scalars['String']['input'];
  inputs: Array<FileOwnerAccess>;
};

export type RequestFilePrivacyAccessInput = {
  fileId: Scalars['String']['input'];
  inputs: Array<FilePrivacyAccess>;
};

export type Royalty = {
  __typename: 'Royalty';
  feeDenominator: Scalars['Int']['output'];
  feeNumerator: Scalars['Int']['output'];
};

export type RoyaltyOwner = {
  __typename: 'RoyaltyOwner';
  address?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Entity>;
  royalty?: Maybe<Royalty>;
};

export type SaleAction = {
  __typename: 'SaleAction';
  contractAddress?: Maybe<Scalars['String']['output']>;
  fromAddress: Scalars['String']['output'];
  royaltyDacr?: Maybe<Royalty>;
  royaltyDacrAmount?: Maybe<Price>;
  royaltyOwner?: Maybe<Royalty>;
  royaltyOwnerAmount?: Maybe<Price>;
  status: ActionStatus;
  toAddress: Scalars['String']['output'];
  tokenId: Scalars['String']['output'];
  total?: Maybe<Price>;
  transaction?: Maybe<TransactionMetadata>;
};

export enum SaleStatus {
  None = 'none',
  Pending = 'pending',
  Processing = 'processing'
}

export enum ScoreLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type SearchEntitiesResponse = {
  __typename: 'SearchEntitiesResponse';
  entities: Array<Entity>;
  next?: Maybe<Array<Maybe<Scalars['Any']['output']>>>;
  total: Scalars['Int']['output'];
};

export type SearchFile = {
  __typename: 'SearchFile';
  category: FileCategory;
  copyrightType?: Maybe<CopyrightType>;
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  owner: Entity;
  status?: Maybe<FileStatus>;
  timestamp?: Maybe<Scalars['Timestamp']['output']>;
  type: FileType;
};

export type SearchFilesResponse = {
  __typename: 'SearchFilesResponse';
  files: Array<SearchFile>;
  next?: Maybe<Array<Maybe<Scalars['Any']['output']>>>;
  total: Scalars['Int']['output'];
};

export type SearchItem = {
  __typename: 'SearchItem';
  copyrightId?: Maybe<Scalars['ID']['output']>;
  copyrightType?: Maybe<CopyrightType>;
  fileType?: Maybe<FileType>;
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parentFolderId: Scalars['String']['output'];
  path: Scalars['String']['output'];
  status?: Maybe<FileStatus>;
  timestamp?: Maybe<Scalars['Timestamp']['output']>;
  type: ItemType;
};

export type SearchItemsResponse = {
  __typename: 'SearchItemsResponse';
  files: Array<Item>;
  next?: Maybe<Array<Maybe<Scalars['Any']['output']>>>;
  total: Scalars['Int']['output'];
};

export enum SearchLicenseSort {
  CopyrightAsc = 'COPYRIGHT_ASC',
  CopyrightDesc = 'COPYRIGHT_DESC',
  EndingDateAsc = 'ENDING_DATE_ASC',
  EndingDateDesc = 'ENDING_DATE_DESC',
  IssuedDateAsc = 'ISSUED_DATE_ASC',
  IssuedDateDesc = 'ISSUED_DATE_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

export type SearchResult = CombinedSearchResult;

export enum SearchSort {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  TimestampAsc = 'TIMESTAMP_ASC',
  TimestampDesc = 'TIMESTAMP_DESC'
}

export type SearchUser = {
  __typename: 'SearchUser';
  avatarUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  username: Scalars['String']['output'];
  wallet?: Maybe<Wallet>;
};

export type SearchUsersResponse = {
  __typename: 'SearchUsersResponse';
  next?: Maybe<Array<Maybe<Scalars['Any']['output']>>>;
  total: Scalars['Int']['output'];
  users: Array<SearchUser>;
};

export type SheetMusic = {
  __typename: 'SheetMusic';
  preview: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SignupInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  platform?: InputMaybe<PlatformType>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
  validateCode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Stem = {
  __typename: 'Stem';
  name: Scalars['String']['output'];
  sheet: SheetMusic;
  url: Scalars['String']['output'];
};

export type Stems = {
  __typename: 'Stems';
  amplitudeUrl: Scalars['String']['output'];
  breakdown: Array<Stem>;
};

export type TeamMemberAccess = {
  entity: EntityInput;
  role: FilePrivacyRole;
};

export enum TeamMemberRole {
  Administrator = 'ADMINISTRATOR',
  Analyst = 'ANALYST',
  Custom = 'CUSTOM',
  Support = 'SUPPORT'
}

export type Timezone = {
  __typename: 'Timezone';
  country: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TimezoneInput = {
  country: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type TokenMetadata = {
  __typename: 'TokenMetadata';
  copyright?: Maybe<Copyright>;
  from?: Maybe<Entity>;
  licenseAction?: Maybe<LicenseAction>;
  saleAction?: Maybe<SaleAction>;
  to?: Maybe<Entity>;
  transferAction?: Maybe<TransferAction>;
};

export type TokenSoldMetadata = {
  __typename: 'TokenSoldMetadata';
  price: Price;
  transaction: TransactionMetadata;
};

export type TokenTransferredMetadata = {
  __typename: 'TokenTransferredMetadata';
  transaction: TransactionMetadata;
};

export type Transaction = {
  __typename: 'Transaction';
  from?: Maybe<Entity>;
  hash: Scalars['String']['output'];
  price?: Maybe<Price>;
  status: TransactionStatus;
  timestamp: Scalars['Timestamp']['output'];
  to: Entity;
  url: Scalars['String']['output'];
};

export type TransactionMetadata = {
  __typename: 'TransactionMetadata';
  chain: Chain;
  hash: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum TransactionStatus {
  Created = 'CREATED',
  Sold = 'SOLD',
  Transferred = 'TRANSFERRED'
}

export type TransferAction = {
  __typename: 'TransferAction';
  contractAddress?: Maybe<Scalars['String']['output']>;
  fromAddress: Scalars['String']['output'];
  status: ActionStatus;
  toAddress: Scalars['String']['output'];
  tokenId: Scalars['String']['output'];
  transaction?: Maybe<TransactionMetadata>;
};

export enum TransferStatus {
  None = 'none',
  Pending = 'pending',
  Processing = 'processing'
}

export type TransferToNoAccountMetadata = {
  __typename: 'TransferToNoAccountMetadata';
  address: Scalars['String']['output'];
  file: File;
};

export type UpcomingBiling = {
  __typename: 'UpcomingBiling';
  breakdown: Array<UpcomingBillingBreakdown>;
  currency: Scalars['String']['output'];
  date: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  outstandingTotal: Scalars['Int']['output'];
  registrationTotal: Scalars['Int']['output'];
  tax?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type UpcomingBillingBreakdown = {
  __typename: 'UpcomingBillingBreakdown';
  amount?: Maybe<Scalars['Int']['output']>;
  description: UpcomingBillingBreakdownDescription;
  localEquivalent?: Maybe<LocalEquivalent>;
  outstanding: Scalars['Boolean']['output'];
  quantity: Scalars['Int']['output'];
};

export type UpcomingBillingBreakdownDescription = {
  __typename: 'UpcomingBillingBreakdownDescription';
  subtext?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type UpdateBillingResponse = {
  __typename: 'UpdateBillingResponse';
  paymentMethod?: Maybe<PaymentMethod>;
};

export type UpdateFilePrivacyDownloadStatusInput = {
  fileId: Scalars['String']['input'];
  inputs: Array<FilePrivacyDownloadStatus>;
};

export type UpdateFileSettingsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  viewers?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UploadFileMetadata = {
  __typename: 'UploadFileMetadata';
  filename: Scalars['String']['output'];
};

export type UpsellDetails = {
  __typename: 'UpsellDetails';
  ctaText: Scalars['String']['output'];
  pillText: Scalars['String']['output'];
  plan: Plan;
  planItem: PlanItem;
  text: Scalars['String']['output'];
};

export type User = UserBase & {
  __typename: 'User';
  avatarUrl: Scalars['String']['output'];
  bio?: Maybe<Scalars['String']['output']>;
  canAddCopyrightOwner?: Maybe<Scalars['Boolean']['output']>;
  canChangePlan?: Maybe<Scalars['Boolean']['output']>;
  canUpgradePlan?: Maybe<Scalars['Boolean']['output']>;
  canUploadFile?: Maybe<Scalars['Boolean']['output']>;
  dateFormat: Scalars['String']['output'];
  defaultFilePrivacy: FilePrivacy;
  email: Scalars['String']['output'];
  fileSize?: Maybe<Scalars['Int']['output']>;
  files?: Maybe<Scalars['Int']['output']>;
  firstName: Scalars['String']['output'];
  guidanceStates: GuidanceStates;
  hasUploadedFile?: Maybe<Scalars['Boolean']['output']>;
  hasUploadedFileAsAPro?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  isCreatingReport: Scalars['Boolean']['output'];
  language?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  membership?: Maybe<Membership>;
  name: Scalars['String']['output'];
  origin: Scalars['ID']['output'];
  pendingLicenses?: Maybe<Scalars['Int']['output']>;
  pendingSales?: Maybe<Scalars['Int']['output']>;
  pendingTransfers?: Maybe<Scalars['Int']['output']>;
  permissions: Array<UserPermission>;
  reportCredits: Scalars['Int']['output'];
  showUpdatedTerms?: Maybe<Scalars['Boolean']['output']>;
  timezone?: Maybe<Timezone>;
  title?: Maybe<Scalars['String']['output']>;
  totalCopyrightOwners?: Maybe<Scalars['Int']['output']>;
  totalCopyrightOwnersLimit?: Maybe<Scalars['Int']['output']>;
  totalFiles?: Maybe<Scalars['Int']['output']>;
  totalFilesLimit?: Maybe<Scalars['Int']['output']>;
  upcomingBilling?: Maybe<UpcomingBiling>;
  username: Scalars['String']['output'];
  verificationStatus?: Maybe<VerificationStatus>;
  wallet?: Maybe<Wallet>;
};

export type UserBase = {
  avatarUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export enum UserLevel {
  Admin = 'ADMIN',
  User = 'USER'
}

export type UserMetadata = {
  __typename: 'UserMetadata';
  entity: Entity;
};

export enum UserPermission {
  Admin = 'ADMIN',
  Affiliate = 'AFFILIATE',
  /** @deprecated Field no longer supported */
  Archive = 'ARCHIVE',
  CopyrightOwners = 'COPYRIGHT_OWNERS',
  /** @deprecated Field no longer supported */
  Invite = 'INVITE',
  License = 'LICENSE',
  Payments = 'PAYMENTS',
  Pro = 'PRO',
  Sell = 'SELL',
  Transfer = 'TRANSFER',
  Upload = 'UPLOAD'
}

export type UserStats = {
  __typename: 'UserStats';
  canUpgradePlan?: Maybe<Scalars['Boolean']['output']>;
  canUploadFile?: Maybe<Scalars['Boolean']['output']>;
  hasUploadedFileAsAPro?: Maybe<Scalars['Boolean']['output']>;
  pendingLicenses: Scalars['Int']['output'];
  pendingSales: Scalars['Int']['output'];
  pendingTransfers: Scalars['Int']['output'];
  totalCopyrightOwners?: Maybe<Scalars['Int']['output']>;
  totalCopyrightOwnersLimit?: Maybe<Scalars['Int']['output']>;
  totalFiles: Scalars['Int']['output'];
  totalFilesLimit?: Maybe<Scalars['Int']['output']>;
};

export enum VerificationStatus {
  None = 'NONE',
  Processing = 'PROCESSING',
  Verified = 'VERIFIED'
}

export type Wallet = {
  __typename: 'Wallet';
  address: Scalars['String']['output'];
  anyTokensToSync?: Maybe<Scalars['Boolean']['output']>;
  anyTokensToTransfer?: Maybe<Scalars['Boolean']['output']>;
  syncingTokens?: Maybe<Scalars['Boolean']['output']>;
  transferringTokens?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
};

export type BasicUserFieldsFragment = { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string };

export type OrganizationFieldsFragment = { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null };

export type EmailFieldsFragment = { __typename: 'Email', email: string };

export type UserFieldsFragment = { __typename: 'User', id: string, permissions: Array<UserPermission>, avatarUrl: string, bio?: string | null, dateFormat: string, email: string, firstName: string, language?: string | null, lastName: string, name: string, title?: string | null, username: string, totalFiles?: number | null, pendingSales?: number | null, pendingTransfers?: number | null, pendingLicenses?: number | null, totalFilesLimit?: number | null, hasUploadedFileAsAPro?: boolean | null, canChangePlan?: boolean | null, canUpgradePlan?: boolean | null, showUpdatedTerms?: boolean | null, totalCopyrightOwners?: number | null, totalCopyrightOwnersLimit?: number | null, defaultFilePrivacy: FilePrivacy, hasUploadedFile?: boolean | null, reportCredits: number, isCreatingReport: boolean, origin: string, verificationStatus?: VerificationStatus | null, timezone?: { __typename: 'Timezone', country: string, name: string } | null, wallet?: { __typename: 'Wallet', address: string, type: string, anyTokensToTransfer?: boolean | null, anyTokensToSync?: boolean | null, transferringTokens?: boolean | null, syncingTokens?: boolean | null } | null, upcomingBilling?: { __typename: 'UpcomingBiling', date: any, currency: string, total: number, tax?: number | null, registrationTotal: number, outstandingTotal: number } | null, guidanceStates: { __typename: 'GuidanceStates', states: Array<{ __typename: 'GuidanceStateEntry', id: GuidanceId, state: { __typename: 'GuidanceState', state: GuidanceActionState } }> }, membership?: { __typename: 'Membership', id?: string | null, since?: any | null, expiresAt?: any | null } | null };

export type FileFieldsFragment = { __typename: 'File', id: string, status: FileStatus, billingExpirationDate?: any | null, copyrightId?: string | null, copyrightType?: CopyrightType | null, description?: string | null, fileName: string, imageUrl?: string | null, isDownloadAvailable: boolean, isPrivate: boolean, ownerAddress?: string | null, ownershipRoles: Array<FileOwnerRole>, size: string, timestamp?: any | null, type: FileType, friendlyType: string, vanityName: string, tokenId?: string | null, contractAddress?: string | null, transferStatus?: TransferStatus | null, saleStatus?: SaleStatus | null, licenseStatus?: LicenseStatus | null, certificateUrl?: string | null, ownersCount?: number | null, privacyControllersCount?: number | null, authorsCount?: number | null, authorRoles: Array<FileAuthorRole>, permissions: Array<FilePermission>, isLifetime: boolean, privacyRoles: Array<FilePrivacyRole>, preview?: { __typename: 'AssetPreview', type: AssetPreviewType, url: string, numberOfPages?: number | null } | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, registrations: Array<{ __typename: 'Registration', id: string, name: string, timestamp?: any | null, certificateUrl?: string | null, icon?: string | null }>, license?: { __typename: 'License', id: string, issuedAt: any, tokenId: string, contractAddress: string, timestamp?: any | null, expiresAt?: any | null, canSellOrTransfer: boolean, type?: LicenseType | null, price?: { __typename: 'Price', value: string } | null, agreement?: { __typename: 'LicenseAgreement', isPublic?: boolean | null, type: LicenseAgreementType, content: string } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', isPublic?: boolean | null, type: LicenseAgreementType, content: string } | null } | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, originalCopyright?: { __typename: 'OriginalCopyright', copyrightId: string, timestamp: any, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | null, royaltyOwner?: { __typename: 'RoyaltyOwner', address?: string | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, royalty?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, transactions: Array<{ __typename: 'Transaction', status: TransactionStatus, timestamp: any, hash: string, url: string, from?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, to: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, price?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null }>, owners: Array<{ __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }>, authors: Array<{ __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }>, notifications?: Array<{ __typename: 'Notification', id: string, type: NotificationType, timestamp: any, read: boolean, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' }, primaryIcon: { __typename: 'NotificationIcon', imageUrl?: string | null, syncIcon?: boolean | null, alertIcon?: boolean | null, dacrIcon?: boolean | null }, secondaryIcon?: { __typename: 'NotificationIcon', imageUrl?: string | null, syncIcon?: boolean | null, alertIcon?: boolean | null, dacrIcon?: boolean | null } | null, metadata?: { __typename: 'AccountPaymentMetadata', payment: { __typename: 'Payment', id: string, failedMessage?: string | null, status: PaymentStatus } } | { __typename: 'FileMetadata', file: { __typename: 'File', vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } } | { __typename: 'InfringementMatchMetadata', id: string, level: ScoreLevel, infringingFile: { __typename: 'File', id: string, vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, imageUrl?: string | null }, registeredFile: { __typename: 'File', id: string, vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, imageUrl?: string | null } } | { __typename: 'InviteMetadata', invite: { __typename: 'Invite', id: string, status: InviteStatus, type: InviteType, role?: { __typename: 'InviteFileAuthorRole' } | { __typename: 'InviteFileOwnerRole', value?: FileOwnerRole | null } | { __typename: 'InviteFilePrivacyRole' } | { __typename: 'InviteReportReviewRole' } | { __typename: 'InviteTeamMemberRole', role?: TeamMemberRole | null } | null, from: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, to: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, reference: { __typename: 'Dacr', id: string, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'License', id: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'Origin', id: string, name: string, avatarUrl: string } } } | { __typename: 'InvoiceMetadata' } | { __typename: 'ReportMetadata', id: string, registeredFile: { __typename: 'File', id: string, fileName: string, type: FileType } } | { __typename: 'ReportReviewMetadata' } | { __typename: 'TokenMetadata', from?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, to?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, transferAction?: { __typename: 'TransferAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, contractAddress?: string | null } | null, saleAction?: { __typename: 'SaleAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, contractAddress?: string | null, total?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyOwnerAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacrAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacr?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null, royaltyOwner?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, licenseAction?: { __typename: 'LicenseAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, startsAt?: any | null, endsAt?: any | null, type?: LicenseType | null, referenceId?: string | null, contractAddress?: string | null, allowSellOrTransfer?: boolean | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null } | null, total?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyOwnerAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacrAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacr?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null, royaltyOwner?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, copyright?: { __typename: 'Dacr', id: string, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, contractAddress?: string | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'License', id: string, issuedAt: any, contractAddress: string, expiresAt?: any | null, canSellOrTransfer: boolean, type?: LicenseType | null, licenser?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, contractAddress?: string | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', content: string, type: LicenseAgreementType, isPublic?: boolean | null } | null } | null } | null } | { __typename: 'TransferToNoAccountMetadata', address: string, file: { __typename: 'File', vanityName: string, fileName: string, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } } | { __typename: 'UploadFileMetadata', filename: string } | { __typename: 'UserMetadata', entity: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null }> | null, analysis?: { __typename: 'AnalysisResponse', status: AnalysisStatus, data?: { __typename: 'Analysis', summary: string, stems?: Array<{ __typename: 'Stems', amplitudeUrl: string, breakdown: Array<{ __typename: 'Stem', name: string, url: string, sheet: { __typename: 'SheetMusic', url: string, preview: string } }> }> | null, lyrics?: { __typename: 'Lyrics', url: string, preview: Array<{ __typename: 'Lyric', lyric: string, timestamp: string }> } | null, markers: Array<{ __typename: 'Marker', color: string, shine: boolean } | null>, attributes: Array<{ __typename: 'Attribute', key: string, value: string }>, sheetMusic?: { __typename: 'SheetMusic', url: string, preview: string } | null } | null } | null, registrant: { __typename: 'BasicUser', id: string, name: string } };

export type BillingFieldsFragment = { __typename: 'BillingResponse', plan: { __typename: 'BillingPlan', id: string, type: PlanType, name: string, description: string, status: PlanStatus, subscriptionCycle?: PlanCycle | null, platform: PlatformType, prices: Array<{ __typename: 'BillingPrice', type?: BillingPriceType | null, description: string, details: { __typename: 'BillingPriceDetail', amount?: number | null, suffix?: string | null, currency?: string | null } }>, dateInfo?: { __typename: 'BillingPlanDateInfo', date?: any | null, prefix: string } | null, details: { __typename: 'BillingPlanDetails', prices: Array<{ __typename: 'BillingPrice', type?: BillingPriceType | null, description: string, details: { __typename: 'BillingPriceDetail', suffix?: string | null, amount?: number | null, currency?: string | null } }>, upcomingBilling?: { __typename: 'UpcomingBiling', currency: string, date: any, total: number, tax?: number | null, breakdown: Array<{ __typename: 'UpcomingBillingBreakdown', outstanding: boolean }> } | null } }, billingAlert?: { __typename: 'BillingAlert', type: BillingAlertType, isActive: boolean, description?: string | null, date?: any | null } | null, paymentMethod?: { __typename: 'PaymentMethod', card?: { __typename: 'Card', type: string, last4: string } | null, requiresAction?: { __typename: 'PaymentRequiresAction', clientSecret: string } | null } | null, upcomingDetails: { __typename: 'BillingPlanDetails', callout?: string | null, prices: Array<{ __typename: 'BillingPrice', type?: BillingPriceType | null, description: string, details: { __typename: 'BillingPriceDetail', suffix?: string | null, amount?: number | null, currency?: string | null } }>, upcomingBilling?: { __typename: 'UpcomingBiling', title: string, description?: string | null, total: number, tax?: number | null, date: any, currency: string, breakdown: Array<{ __typename: 'UpcomingBillingBreakdown', amount?: number | null, quantity: number, outstanding: boolean, description: { __typename: 'UpcomingBillingBreakdownDescription', text: string, subtext?: string | null } }> } | null }, currentDetails?: { __typename: 'BillingPlanDetails', callout?: string | null, prices: Array<{ __typename: 'BillingPrice', type?: BillingPriceType | null, description: string, details: { __typename: 'BillingPriceDetail', suffix?: string | null, amount?: number | null, currency?: string | null } }>, upcomingBilling?: { __typename: 'UpcomingBiling', title: string, description?: string | null, total: number, tax?: number | null, date: any, currency: string, breakdown: Array<{ __typename: 'UpcomingBillingBreakdown', amount?: number | null, quantity: number, outstanding: boolean, description: { __typename: 'UpcomingBillingBreakdownDescription', text: string, subtext?: string | null } }> } | null } | null, invoices: { __typename: 'InvoicesResponse', next?: string | null, invoices: Array<{ __typename: 'Invoice', id: string, date: any, total: number, description: string, status: InvoiceStatus, currency: string }> }, upsell?: { __typename: 'UpsellDetails', text: string, ctaText: string, pillText: string, plan: { __typename: 'Plan', id: string, name: string, headerText?: string | null, footerText?: string | null, benefits?: Array<string> | null, description?: string | null, priceCallout?: string | null, showExtraSpacing?: boolean | null, error?: string | null, includes: Array<{ __typename: 'PlanInclude', text: string, description?: string | null, separator?: boolean | null, link?: { __typename: 'PlanIncludeLink', text: string, url: string } | null }>, items: Array<{ __typename: 'PlanItem', status: PlanItemStatus, productId: string, nativeProductId?: string | null, nativePlanId?: string | null, maxUnits?: number | null, action: ActionType, prices: Array<{ __typename: 'PlanPriceItem', type?: PlanPriceType | null, details?: { __typename: 'PlanPriceDetail', billingCycleType?: string | null, amount?: number | null, suffix?: string | null, renderedPrice?: string | null, currency?: string | null } | null }>, upsell?: { __typename: 'UpsellDetails', text: string, ctaText: string, pillText: string, plan: { __typename: 'Plan', id: string, name: string, headerText?: string | null, footerText?: string | null, benefits?: Array<string> | null, description?: string | null, priceCallout?: string | null, showExtraSpacing?: boolean | null, error?: string | null, includes: Array<{ __typename: 'PlanInclude', text: string, description?: string | null, separator?: boolean | null, link?: { __typename: 'PlanIncludeLink', text: string, url: string } | null }> }, planItem: { __typename: 'PlanItem', status: PlanItemStatus, productId: string, nativeProductId?: string | null, nativePlanId?: string | null, maxUnits?: number | null, action: ActionType, prices: Array<{ __typename: 'PlanPriceItem', type?: PlanPriceType | null, details?: { __typename: 'PlanPriceDetail', billingCycleType?: string | null, amount?: number | null, suffix?: string | null, renderedPrice?: string | null, currency?: string | null } | null }> } } | null }> }, planItem: { __typename: 'PlanItem', status: PlanItemStatus, productId: string, nativeProductId?: string | null, nativePlanId?: string | null, maxUnits?: number | null, action: ActionType, prices: Array<{ __typename: 'PlanPriceItem', type?: PlanPriceType | null, details?: { __typename: 'PlanPriceDetail', billingCycleType?: string | null, amount?: number | null, suffix?: string | null, renderedPrice?: string | null, currency?: string | null } | null }>, upsell?: { __typename: 'UpsellDetails', text: string, ctaText: string, pillText: string, plan: { __typename: 'Plan', id: string, name: string, headerText?: string | null, footerText?: string | null, benefits?: Array<string> | null, description?: string | null, priceCallout?: string | null, showExtraSpacing?: boolean | null, error?: string | null, includes: Array<{ __typename: 'PlanInclude', text: string, description?: string | null, separator?: boolean | null, link?: { __typename: 'PlanIncludeLink', text: string, url: string } | null }> }, planItem: { __typename: 'PlanItem', status: PlanItemStatus, productId: string, nativeProductId?: string | null, nativePlanId?: string | null, maxUnits?: number | null, action: ActionType, prices: Array<{ __typename: 'PlanPriceItem', type?: PlanPriceType | null, details?: { __typename: 'PlanPriceDetail', billingCycleType?: string | null, amount?: number | null, suffix?: string | null, renderedPrice?: string | null, currency?: string | null } | null }> } } | null } } | null };

export type PlanFieldsFragment = { __typename: 'Plan', id: string, name: string, headerText?: string | null, footerText?: string | null, benefits?: Array<string> | null, description?: string | null, priceCallout?: string | null, showExtraSpacing?: boolean | null, error?: string | null, includes: Array<{ __typename: 'PlanInclude', text: string, description?: string | null, separator?: boolean | null, link?: { __typename: 'PlanIncludeLink', text: string, url: string } | null }>, items: Array<{ __typename: 'PlanItem', status: PlanItemStatus, productId: string, nativeProductId?: string | null, nativePlanId?: string | null, maxUnits?: number | null, action: ActionType, prices: Array<{ __typename: 'PlanPriceItem', type?: PlanPriceType | null, details?: { __typename: 'PlanPriceDetail', billingCycleType?: string | null, amount?: number | null, suffix?: string | null, renderedPrice?: string | null, currency?: string | null } | null }>, upsell?: { __typename: 'UpsellDetails', text: string, ctaText: string, pillText: string, plan: { __typename: 'Plan', id: string, name: string, headerText?: string | null, footerText?: string | null, benefits?: Array<string> | null, description?: string | null, priceCallout?: string | null, showExtraSpacing?: boolean | null, error?: string | null, includes: Array<{ __typename: 'PlanInclude', text: string, description?: string | null, separator?: boolean | null, link?: { __typename: 'PlanIncludeLink', text: string, url: string } | null }> }, planItem: { __typename: 'PlanItem', status: PlanItemStatus, productId: string, nativeProductId?: string | null, nativePlanId?: string | null, maxUnits?: number | null, action: ActionType, prices: Array<{ __typename: 'PlanPriceItem', type?: PlanPriceType | null, details?: { __typename: 'PlanPriceDetail', billingCycleType?: string | null, amount?: number | null, suffix?: string | null, renderedPrice?: string | null, currency?: string | null } | null }> } } | null }> };

export type PlanItemFieldsFragment = { __typename: 'PlanItem', status: PlanItemStatus, productId: string, nativeProductId?: string | null, nativePlanId?: string | null, maxUnits?: number | null, action: ActionType, prices: Array<{ __typename: 'PlanPriceItem', type?: PlanPriceType | null, details?: { __typename: 'PlanPriceDetail', billingCycleType?: string | null, amount?: number | null, suffix?: string | null, renderedPrice?: string | null, currency?: string | null } | null }>, upsell?: { __typename: 'UpsellDetails', text: string, ctaText: string, pillText: string, plan: { __typename: 'Plan', id: string, name: string, headerText?: string | null, footerText?: string | null, benefits?: Array<string> | null, description?: string | null, priceCallout?: string | null, showExtraSpacing?: boolean | null, error?: string | null, includes: Array<{ __typename: 'PlanInclude', text: string, description?: string | null, separator?: boolean | null, link?: { __typename: 'PlanIncludeLink', text: string, url: string } | null }> }, planItem: { __typename: 'PlanItem', status: PlanItemStatus, productId: string, nativeProductId?: string | null, nativePlanId?: string | null, maxUnits?: number | null, action: ActionType, prices: Array<{ __typename: 'PlanPriceItem', type?: PlanPriceType | null, details?: { __typename: 'PlanPriceDetail', billingCycleType?: string | null, amount?: number | null, suffix?: string | null, renderedPrice?: string | null, currency?: string | null } | null }> } } | null };

export type NotificationFieldsFragment = { __typename: 'Notification', id: string, type: NotificationType, timestamp: any, read: boolean, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' }, primaryIcon: { __typename: 'NotificationIcon', imageUrl?: string | null, syncIcon?: boolean | null, alertIcon?: boolean | null, dacrIcon?: boolean | null }, secondaryIcon?: { __typename: 'NotificationIcon', imageUrl?: string | null, syncIcon?: boolean | null, alertIcon?: boolean | null, dacrIcon?: boolean | null } | null, metadata?: { __typename: 'AccountPaymentMetadata', payment: { __typename: 'Payment', id: string, failedMessage?: string | null, status: PaymentStatus } } | { __typename: 'FileMetadata', file: { __typename: 'File', vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } } | { __typename: 'InfringementMatchMetadata', id: string, level: ScoreLevel, infringingFile: { __typename: 'File', id: string, vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, imageUrl?: string | null }, registeredFile: { __typename: 'File', id: string, vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, imageUrl?: string | null } } | { __typename: 'InviteMetadata', invite: { __typename: 'Invite', id: string, status: InviteStatus, type: InviteType, role?: { __typename: 'InviteFileAuthorRole' } | { __typename: 'InviteFileOwnerRole', value?: FileOwnerRole | null } | { __typename: 'InviteFilePrivacyRole' } | { __typename: 'InviteReportReviewRole' } | { __typename: 'InviteTeamMemberRole', role?: TeamMemberRole | null } | null, from: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, to: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, reference: { __typename: 'Dacr', id: string, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'License', id: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'Origin', id: string, name: string, avatarUrl: string } } } | { __typename: 'InvoiceMetadata' } | { __typename: 'ReportMetadata', id: string, registeredFile: { __typename: 'File', id: string, fileName: string, type: FileType } } | { __typename: 'ReportReviewMetadata' } | { __typename: 'TokenMetadata', from?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, to?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, transferAction?: { __typename: 'TransferAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, contractAddress?: string | null } | null, saleAction?: { __typename: 'SaleAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, contractAddress?: string | null, total?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyOwnerAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacrAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacr?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null, royaltyOwner?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, licenseAction?: { __typename: 'LicenseAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, startsAt?: any | null, endsAt?: any | null, type?: LicenseType | null, referenceId?: string | null, contractAddress?: string | null, allowSellOrTransfer?: boolean | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null } | null, total?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyOwnerAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacrAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacr?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null, royaltyOwner?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, copyright?: { __typename: 'Dacr', id: string, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, contractAddress?: string | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'License', id: string, issuedAt: any, contractAddress: string, expiresAt?: any | null, canSellOrTransfer: boolean, type?: LicenseType | null, licenser?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, contractAddress?: string | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', content: string, type: LicenseAgreementType, isPublic?: boolean | null } | null } | null } | null } | { __typename: 'TransferToNoAccountMetadata', address: string, file: { __typename: 'File', vanityName: string, fileName: string, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } } | { __typename: 'UploadFileMetadata', filename: string } | { __typename: 'UserMetadata', entity: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null };

export type SignInMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type SignInMutation = { __typename: 'Mutation', signin: { __typename: 'AuthResponse', accessToken: string, refreshToken: string, user: { __typename: 'User', id: string, permissions: Array<UserPermission>, avatarUrl: string, bio?: string | null, dateFormat: string, email: string, firstName: string, language?: string | null, lastName: string, name: string, title?: string | null, username: string, totalFiles?: number | null, pendingSales?: number | null, pendingTransfers?: number | null, pendingLicenses?: number | null, totalFilesLimit?: number | null, hasUploadedFileAsAPro?: boolean | null, canChangePlan?: boolean | null, canUpgradePlan?: boolean | null, showUpdatedTerms?: boolean | null, totalCopyrightOwners?: number | null, totalCopyrightOwnersLimit?: number | null, defaultFilePrivacy: FilePrivacy, hasUploadedFile?: boolean | null, reportCredits: number, isCreatingReport: boolean, origin: string, verificationStatus?: VerificationStatus | null, timezone?: { __typename: 'Timezone', country: string, name: string } | null, wallet?: { __typename: 'Wallet', address: string, type: string, anyTokensToTransfer?: boolean | null, anyTokensToSync?: boolean | null, transferringTokens?: boolean | null, syncingTokens?: boolean | null } | null, upcomingBilling?: { __typename: 'UpcomingBiling', date: any, currency: string, total: number, tax?: number | null, registrationTotal: number, outstandingTotal: number } | null, guidanceStates: { __typename: 'GuidanceStates', states: Array<{ __typename: 'GuidanceStateEntry', id: GuidanceId, state: { __typename: 'GuidanceState', state: GuidanceActionState } }> }, membership?: { __typename: 'Membership', id?: string | null, since?: any | null, expiresAt?: any | null } | null } } };

export type SignUpMutationVariables = Exact<{
  input: SignupInput;
}>;


export type SignUpMutation = { __typename: 'Mutation', signup: { __typename: 'AuthResponse', accessToken: string, refreshToken: string, user: { __typename: 'User', id: string, permissions: Array<UserPermission>, avatarUrl: string, bio?: string | null, dateFormat: string, email: string, firstName: string, language?: string | null, lastName: string, name: string, title?: string | null, username: string, totalFiles?: number | null, pendingSales?: number | null, pendingTransfers?: number | null, pendingLicenses?: number | null, totalFilesLimit?: number | null, hasUploadedFileAsAPro?: boolean | null, canChangePlan?: boolean | null, canUpgradePlan?: boolean | null, showUpdatedTerms?: boolean | null, totalCopyrightOwners?: number | null, totalCopyrightOwnersLimit?: number | null, defaultFilePrivacy: FilePrivacy, hasUploadedFile?: boolean | null, reportCredits: number, isCreatingReport: boolean, origin: string, verificationStatus?: VerificationStatus | null, timezone?: { __typename: 'Timezone', country: string, name: string } | null, wallet?: { __typename: 'Wallet', address: string, type: string, anyTokensToTransfer?: boolean | null, anyTokensToSync?: boolean | null, transferringTokens?: boolean | null, syncingTokens?: boolean | null } | null, upcomingBilling?: { __typename: 'UpcomingBiling', date: any, currency: string, total: number, tax?: number | null, registrationTotal: number, outstandingTotal: number } | null, guidanceStates: { __typename: 'GuidanceStates', states: Array<{ __typename: 'GuidanceStateEntry', id: GuidanceId, state: { __typename: 'GuidanceState', state: GuidanceActionState } }> }, membership?: { __typename: 'Membership', id?: string | null, since?: any | null, expiresAt?: any | null } | null } } };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = { __typename: 'Mutation', forgotPassword: string };

export type ValidateResetPasswordTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ValidateResetPasswordTokenMutation = { __typename: 'Mutation', validateResetPasswordToken: boolean };

export type ResetPasswordMutationVariables = Exact<{
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename: 'Mutation', resetPassword: string };

export type RefreshTokensMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type RefreshTokensMutation = { __typename: 'Mutation', refreshAccessToken: { __typename: 'RefreshAccessTokenResponse', accessToken: string, refreshToken: string } };

export type CreateUploadUrlMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  parentFolderId: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateUploadUrlMutation = { __typename: 'Mutation', createUploadUrl: { __typename: 'FileUploadResponse', url: string, title?: string | null, description?: string | null, headers: { __typename: 'FileUploadHeaders', bucket: string, key: string, Policy: string, X_Amz_Algorithm: string, X_Amz_Credential: string, X_Amz_Date: string, x_amz_meta_userid: string, X_Amz_Security_Token?: string | null, X_Amz_Signature: string, Content_Type?: string | null } } };

export type CreateAvatarUploadUrlMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
}>;


export type CreateAvatarUploadUrlMutation = { __typename: 'Mutation', createAvatarUploadUrl: { __typename: 'FileUploadResponse', url: string, headers: { __typename: 'FileUploadHeaders', bucket: string, Content_Type?: string | null, key: string, Policy: string, X_Amz_Algorithm: string, X_Amz_Credential: string, X_Amz_Date: string, x_amz_meta_userid: string, X_Amz_Security_Token?: string | null, X_Amz_Signature: string } } };

export type CreateAgreementUploadUrlMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  copyrightId: Scalars['ID']['input'];
}>;


export type CreateAgreementUploadUrlMutation = { __typename: 'Mutation', createAgreementUploadUrl: { __typename: 'AgreementUploadResponse', content: string, previewUrl: string, uploadPresignedData: { __typename: 'FileUploadResponse', url: string, headers: { __typename: 'FileUploadHeaders', bucket: string, Content_Type?: string | null, key: string, Policy: string, X_Amz_Algorithm: string, X_Amz_Credential: string, X_Amz_Date: string, x_amz_meta_userid: string, X_Amz_Security_Token?: string | null, X_Amz_Signature: string } } } };

export type AddFolderMutationVariables = Exact<{
  folderName: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
}>;


export type AddFolderMutation = { __typename: 'Mutation', createFolder: { __typename: 'Folder', id: string, name: string, timestamp: any } };

export type RenameFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  newFolderName: Scalars['String']['input'];
}>;


export type RenameFolderMutation = { __typename: 'Mutation', renameFolder: { __typename: 'Folder', id: string, name: string } };

export type DeleteFoldersMutationVariables = Exact<{
  folderIds: Array<Scalars['ID']['input']>;
}>;


export type DeleteFoldersMutation = { __typename: 'Mutation', deleteFolders: string };

export type MoveItemsMutationVariables = Exact<{
  sourceIds: Array<Scalars['ID']['input']>;
  to: Scalars['String']['input'];
}>;


export type MoveItemsMutation = { __typename: 'Mutation', moveItems: { __typename: 'BatchActionResponse', asyncProcess?: boolean | null } };

export type ArchiveFilesMutationVariables = Exact<{
  fileIds: Array<Scalars['ID']['input']>;
}>;


export type ArchiveFilesMutation = { __typename: 'Mutation', archiveFiles: { __typename: 'BatchActionResponse', asyncProcess?: boolean | null } };

export type UpdateFileSettingsMutationVariables = Exact<{
  input: UpdateFileSettingsInput;
}>;


export type UpdateFileSettingsMutation = { __typename: 'Mutation', updateFileSettings: { __typename: 'File', id: string, vanityName: string, description?: string | null, isPrivate: boolean, isDownloadAvailable: boolean } };

export type CreateSubscriptionMutationVariables = Exact<{
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  productId: Scalars['ID']['input'];
  platform: PlatformType;
}>;


export type CreateSubscriptionMutation = { __typename: 'Mutation', createSubscription: { __typename: 'CreateSubscriptionResponse', failedMessage?: string | null, isScheduled?: boolean | null, requiresAction?: { __typename: 'PaymentRequiresAction', clientSecret: string } | null, plan?: { __typename: 'BillingPlan', id: string, name: string, description: string, status: PlanStatus, subscriptionCycle?: PlanCycle | null, platform: PlatformType, type: PlanType, prices: Array<{ __typename: 'BillingPrice', type?: BillingPriceType | null, description: string, details: { __typename: 'BillingPriceDetail', amount?: number | null, currency?: string | null, suffix?: string | null } }>, dateInfo?: { __typename: 'BillingPlanDateInfo', date?: any | null, prefix: string } | null, details: { __typename: 'BillingPlanDetails', prices: Array<{ __typename: 'BillingPrice', type?: BillingPriceType | null, description: string, details: { __typename: 'BillingPriceDetail', suffix?: string | null, amount?: number | null, currency?: string | null } }>, upcomingBilling?: { __typename: 'UpcomingBiling', date: any, total: number, tax?: number | null, currency: string, registrationTotal: number, outstandingTotal: number, breakdown: Array<{ __typename: 'UpcomingBillingBreakdown', outstanding: boolean, amount?: number | null, description: { __typename: 'UpcomingBillingBreakdownDescription', text: string, subtext?: string | null } }> } | null } } | null } };

export type UpdateBillingInformationMutationVariables = Exact<{
  paymentMethodId: Scalars['ID']['input'];
}>;


export type UpdateBillingInformationMutation = { __typename: 'Mutation', updateBillingInformation: { __typename: 'UpdateBillingResponse', paymentMethod?: { __typename: 'PaymentMethod', card?: { __typename: 'Card', type: string, last4: string } | null, requiresAction?: { __typename: 'PaymentRequiresAction', clientSecret: string } | null } | null } };

export type UpdateAccountNameMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
}>;


export type UpdateAccountNameMutation = { __typename: 'Mutation', updateAccountName: { __typename: 'User', id: string, firstName: string, lastName: string, name: string } };

export type UpdateAccountEmailMutationVariables = Exact<{
  newEmail: Scalars['String']['input'];
}>;


export type UpdateAccountEmailMutation = { __typename: 'Mutation', updateAccountEmail: { __typename: 'User', email: string, id: string } };

export type UpdateAccountUsernameMutationVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type UpdateAccountUsernameMutation = { __typename: 'Mutation', updateAccountUsername: { __typename: 'User', id: string, username: string } };

export type UpdateAccountTitleMutationVariables = Exact<{
  title: Scalars['String']['input'];
}>;


export type UpdateAccountTitleMutation = { __typename: 'Mutation', updateAccountTitle: { __typename: 'User', id: string, title?: string | null } };

export type UpdateAccountBioMutationVariables = Exact<{
  bio: Scalars['String']['input'];
}>;


export type UpdateAccountBioMutation = { __typename: 'Mutation', updateAccountBio: { __typename: 'User', id: string, bio?: string | null } };

export type UpdateAccountDateFormatMutationVariables = Exact<{
  dateFormat: Scalars['String']['input'];
}>;


export type UpdateAccountDateFormatMutation = { __typename: 'Mutation', updateAccountDateFormat: { __typename: 'User', id: string, dateFormat: string } };

export type UpdateAccountTimezoneMutationVariables = Exact<{
  timezone?: InputMaybe<TimezoneInput>;
}>;


export type UpdateAccountTimezoneMutation = { __typename: 'Mutation', updateAccountTimezone: { __typename: 'User', id: string, timezone?: { __typename: 'Timezone', country: string, name: string } | null } };

export type UpdateAccountDefaultFilePrivacyMutationVariables = Exact<{
  isPrivate: Scalars['Boolean']['input'];
}>;


export type UpdateAccountDefaultFilePrivacyMutation = { __typename: 'Mutation', updateAccountDefaultFilePrivacy: { __typename: 'User', id: string, defaultFilePrivacy: FilePrivacy } };

export type ChangePasswordMutationVariables = Exact<{
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
}>;


export type ChangePasswordMutation = { __typename: 'Mutation', changePassword: string };

export type ConnectWalletMutationVariables = Exact<{
  input: ConnectWalletInput;
}>;


export type ConnectWalletMutation = { __typename: 'Mutation', connectWallet: { __typename: 'ConnectWalletResponse', anyTokensToSync: boolean, anyTokensToTransfer: boolean, transferringTokens?: boolean | null, syncingTokens?: boolean | null, user: { __typename: 'BasicUser', id: string } } };

export type DisconnectWalletMutationVariables = Exact<{
  input: DisconnectWalletInput;
}>;


export type DisconnectWalletMutation = { __typename: 'Mutation', disconnectWallet: { __typename: 'User', id: string, wallet?: { __typename: 'Wallet', address: string, type: string } | null } };

export type DeactivateAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DeactivateAccountMutation = { __typename: 'Mutation', deactiveAccount: { __typename: 'DeactivateResponse', requiresAction?: { __typename: 'PaymentRequiresAction', clientSecret: string } | null } };

export type CancelSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelSubscriptionMutation = { __typename: 'Mutation', cancelSubscription: { __typename: 'CancelSubResponse', paymentMethod?: { __typename: 'PaymentMethod', card?: { __typename: 'Card', type: string, last4: string } | null, requiresAction?: { __typename: 'PaymentRequiresAction', clientSecret: string } | null } | null } };

export type DeleteAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAccountMutation = { __typename: 'Mutation', deleteAccount: { __typename: 'DeleteResponse', requiresAction?: { __typename: 'PaymentRequiresAction', clientSecret: string } | null } };

export type SyncTokensToWalletMutationVariables = Exact<{
  walletAddress: Scalars['String']['input'];
}>;


export type SyncTokensToWalletMutation = { __typename: 'Mutation', syncTokensToWallet: boolean };

export type TransferTokensToAcccountMutationVariables = Exact<{
  walletAddress: Scalars['String']['input'];
}>;


export type TransferTokensToAcccountMutation = { __typename: 'Mutation', transferTokensToAccount: boolean };

export type IssueLicenseMutationVariables = Exact<{
  input: IssueLicenseInput;
}>;


export type IssueLicenseMutation = { __typename: 'Mutation', issueLicense: boolean };

export type MarkAllNotificationsAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllNotificationsAsReadMutation = { __typename: 'Mutation', markAllNotificationsAsRead: { __typename: 'MarkNotificationResponse', unread?: number | null } };

export type DownloadMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DownloadMutation = { __typename: 'Mutation', download: string };

export type MarkNotificationAsReadMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']>;
}>;


export type MarkNotificationAsReadMutation = { __typename: 'Mutation', markNotificationAsRead: { __typename: 'MarkNotificationResponse', unread?: number | null } };

export type AcceptInviteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AcceptInviteMutation = { __typename: 'Mutation', acceptInvite: boolean };

export type DeclineInviteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeclineInviteMutation = { __typename: 'Mutation', declineInvite: boolean };

export type RemoveFileOwnerAccessMutationVariables = Exact<{
  input: RemoveFileAccessInput;
}>;


export type RemoveFileOwnerAccessMutation = { __typename: 'Mutation', removeFileOwnerAccess: { __typename: 'FileOwnersResponse', next?: Array<any | null> | null, items: Array<{ __typename: 'FileOwnersItem', statuses: Array<FileOwnerStatus>, entity: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } }> } };

export type RemoveFilePrivacyAccessMutationVariables = Exact<{
  input: RemoveFileAccessInput;
}>;


export type RemoveFilePrivacyAccessMutation = { __typename: 'Mutation', removeFilePrivacyAccess: { __typename: 'FilePrivacyResponse', next?: Array<any | null> | null, items: Array<{ __typename: 'FilePrivacyItem', statuses: Array<FilePrivacyStatus>, isDownloadAvailable: boolean, entity: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } }> } };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename: 'Mutation', createUser: { __typename: 'User', id: string, permissions: Array<UserPermission>, avatarUrl: string, bio?: string | null, dateFormat: string, email: string, firstName: string, language?: string | null, lastName: string, name: string, title?: string | null, username: string, totalFiles?: number | null, pendingSales?: number | null, pendingTransfers?: number | null, pendingLicenses?: number | null, totalFilesLimit?: number | null, hasUploadedFileAsAPro?: boolean | null, canChangePlan?: boolean | null, canUpgradePlan?: boolean | null, showUpdatedTerms?: boolean | null, totalCopyrightOwners?: number | null, totalCopyrightOwnersLimit?: number | null, defaultFilePrivacy: FilePrivacy, hasUploadedFile?: boolean | null, reportCredits: number, isCreatingReport: boolean, origin: string, verificationStatus?: VerificationStatus | null, timezone?: { __typename: 'Timezone', country: string, name: string } | null, wallet?: { __typename: 'Wallet', address: string, type: string, anyTokensToTransfer?: boolean | null, anyTokensToSync?: boolean | null, transferringTokens?: boolean | null, syncingTokens?: boolean | null } | null, upcomingBilling?: { __typename: 'UpcomingBiling', date: any, currency: string, total: number, tax?: number | null, registrationTotal: number, outstandingTotal: number } | null, guidanceStates: { __typename: 'GuidanceStates', states: Array<{ __typename: 'GuidanceStateEntry', id: GuidanceId, state: { __typename: 'GuidanceState', state: GuidanceActionState } }> }, membership?: { __typename: 'Membership', id?: string | null, since?: any | null, expiresAt?: any | null } | null } };

export type AcceptTermsMutationVariables = Exact<{ [key: string]: never; }>;


export type AcceptTermsMutation = { __typename: 'Mutation', acceptTerms: { __typename: 'User', id: string, showUpdatedTerms?: boolean | null } };

export type RequestFilePrivacyAccessMutationVariables = Exact<{
  input: RequestFilePrivacyAccessInput;
}>;


export type RequestFilePrivacyAccessMutation = { __typename: 'Mutation', requestFilePrivacyAccess: { __typename: 'FilePrivacyResponse', next?: Array<any | null> | null, items: Array<{ __typename: 'FilePrivacyItem', statuses: Array<FilePrivacyStatus>, isDownloadAvailable: boolean, entity: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } }> } };

export type RequestFileOwnerAccessMutationVariables = Exact<{
  input: RequestFileOwnerAccessInput;
}>;


export type RequestFileOwnerAccessMutation = { __typename: 'Mutation', requestFileOwnerAccess: { __typename: 'FileOwnersResponse', next?: Array<any | null> | null, items: Array<{ __typename: 'FileOwnersItem', statuses: Array<FileOwnerStatus>, entity: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } }> } };

export type CreateBatchUploadUrlMutationVariables = Exact<{
  input: BatchUploadInput;
}>;


export type CreateBatchUploadUrlMutation = { __typename: 'Mutation', createBatchUploadUrl: { __typename: 'BatchFileUploadResponse', uploads: Array<{ __typename: 'FileUploadResponse', url: string, title?: string | null, description?: string | null, headers: { __typename: 'FileUploadHeaders', bucket: string, key: string, Policy: string, X_Amz_Algorithm: string, X_Amz_Credential: string, X_Amz_Date: string, x_amz_meta_userid: string, X_Amz_Security_Token?: string | null, X_Amz_Signature: string, Content_Type?: string | null } }> } };

export type AddCopyrightOwnerMutationVariables = Exact<{
  name: Scalars['String']['input'];
  type: CopyrightOwnerType;
  autoSelect?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddCopyrightOwnerMutation = { __typename: 'Mutation', addCopyrightOwnerNew: { __typename: 'CopyrightOwnerNew', id: string, name: string, avatarUrl: string, isSelected: boolean, type: CopyrightOwnerType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } } };

export type UpdateCopyrightOwnerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateCopyrightOwnerMutation = { __typename: 'Mutation', updateCopyrightOwnerNew: { __typename: 'CopyrightOwnerNew', id: string, name: string, avatarUrl: string, isSelected: boolean, type: CopyrightOwnerType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } } };

export type DeleteCopyrightOwnerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCopyrightOwnerMutation = { __typename: 'Mutation', deleteCopyrightOwner: boolean };

export type SelectCopyrightOwnerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SelectCopyrightOwnerMutation = { __typename: 'Mutation', selectCopyrightOwner: boolean };

export type UpdateFilePrivacyDownloadStatusMutationVariables = Exact<{
  input: UpdateFilePrivacyDownloadStatusInput;
}>;


export type UpdateFilePrivacyDownloadStatusMutation = { __typename: 'Mutation', updateFilePrivacyDownloadStatus: Array<boolean> };

export type RemoveFileAuthorAccessMutationVariables = Exact<{
  input: RemoveFileAccessInput;
}>;


export type RemoveFileAuthorAccessMutation = { __typename: 'Mutation', removeFileAuthorAccess: { __typename: 'FileAuthorsResponse', next?: Array<any | null> | null, items: Array<{ __typename: 'FileAuthorsItem', statuses: Array<FileAuthorStatus>, entity: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } }> } };

export type RequestFileAuthorAccessMutationVariables = Exact<{
  input: RequestFileAuthorAccessInput;
}>;


export type RequestFileAuthorAccessMutation = { __typename: 'Mutation', requestFileAuthorAccess: { __typename: 'FileAuthorsResponse', next?: Array<any | null> | null, items: Array<{ __typename: 'FileAuthorsItem', statuses: Array<FileAuthorStatus>, entity: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } }> } };

export type AddCopyrightOwnerEntityMutationVariables = Exact<{
  input: EntityInput;
  autoSelect?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddCopyrightOwnerEntityMutation = { __typename: 'Mutation', addCopyrightOwnerEntityNew: { __typename: 'CopyrightOwnerNew', id: string, name: string, type: CopyrightOwnerType, avatarUrl: string, isSelected: boolean, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } } };

export type SignoutMutationVariables = Exact<{ [key: string]: never; }>;


export type SignoutMutation = { __typename: 'Mutation', signout: boolean };

export type PayMutationVariables = Exact<{
  reactivateAccount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PayMutation = { __typename: 'Mutation', pay: { __typename: 'BillingResponse', plan: { __typename: 'BillingPlan', id: string, type: PlanType, name: string, description: string, status: PlanStatus, subscriptionCycle?: PlanCycle | null, platform: PlatformType, prices: Array<{ __typename: 'BillingPrice', type?: BillingPriceType | null, description: string, details: { __typename: 'BillingPriceDetail', amount?: number | null, suffix?: string | null, currency?: string | null } }>, dateInfo?: { __typename: 'BillingPlanDateInfo', date?: any | null, prefix: string } | null, details: { __typename: 'BillingPlanDetails', prices: Array<{ __typename: 'BillingPrice', type?: BillingPriceType | null, description: string, details: { __typename: 'BillingPriceDetail', suffix?: string | null, amount?: number | null, currency?: string | null } }>, upcomingBilling?: { __typename: 'UpcomingBiling', currency: string, date: any, total: number, tax?: number | null, breakdown: Array<{ __typename: 'UpcomingBillingBreakdown', outstanding: boolean }> } | null } }, billingAlert?: { __typename: 'BillingAlert', type: BillingAlertType, isActive: boolean, description?: string | null, date?: any | null } | null, paymentMethod?: { __typename: 'PaymentMethod', card?: { __typename: 'Card', type: string, last4: string } | null, requiresAction?: { __typename: 'PaymentRequiresAction', clientSecret: string } | null } | null, upcomingDetails: { __typename: 'BillingPlanDetails', callout?: string | null, prices: Array<{ __typename: 'BillingPrice', type?: BillingPriceType | null, description: string, details: { __typename: 'BillingPriceDetail', suffix?: string | null, amount?: number | null, currency?: string | null } }>, upcomingBilling?: { __typename: 'UpcomingBiling', title: string, description?: string | null, total: number, tax?: number | null, date: any, currency: string, breakdown: Array<{ __typename: 'UpcomingBillingBreakdown', amount?: number | null, quantity: number, outstanding: boolean, description: { __typename: 'UpcomingBillingBreakdownDescription', text: string, subtext?: string | null } }> } | null }, currentDetails?: { __typename: 'BillingPlanDetails', callout?: string | null, prices: Array<{ __typename: 'BillingPrice', type?: BillingPriceType | null, description: string, details: { __typename: 'BillingPriceDetail', suffix?: string | null, amount?: number | null, currency?: string | null } }>, upcomingBilling?: { __typename: 'UpcomingBiling', title: string, description?: string | null, total: number, tax?: number | null, date: any, currency: string, breakdown: Array<{ __typename: 'UpcomingBillingBreakdown', amount?: number | null, quantity: number, outstanding: boolean, description: { __typename: 'UpcomingBillingBreakdownDescription', text: string, subtext?: string | null } }> } | null } | null, invoices: { __typename: 'InvoicesResponse', next?: string | null, invoices: Array<{ __typename: 'Invoice', id: string, date: any, total: number, description: string, status: InvoiceStatus, currency: string }> }, upsell?: { __typename: 'UpsellDetails', text: string, ctaText: string, pillText: string, plan: { __typename: 'Plan', id: string, name: string, headerText?: string | null, footerText?: string | null, benefits?: Array<string> | null, description?: string | null, priceCallout?: string | null, showExtraSpacing?: boolean | null, error?: string | null, includes: Array<{ __typename: 'PlanInclude', text: string, description?: string | null, separator?: boolean | null, link?: { __typename: 'PlanIncludeLink', text: string, url: string } | null }>, items: Array<{ __typename: 'PlanItem', status: PlanItemStatus, productId: string, nativeProductId?: string | null, nativePlanId?: string | null, maxUnits?: number | null, action: ActionType, prices: Array<{ __typename: 'PlanPriceItem', type?: PlanPriceType | null, details?: { __typename: 'PlanPriceDetail', billingCycleType?: string | null, amount?: number | null, suffix?: string | null, renderedPrice?: string | null, currency?: string | null } | null }>, upsell?: { __typename: 'UpsellDetails', text: string, ctaText: string, pillText: string, plan: { __typename: 'Plan', id: string, name: string, headerText?: string | null, footerText?: string | null, benefits?: Array<string> | null, description?: string | null, priceCallout?: string | null, showExtraSpacing?: boolean | null, error?: string | null, includes: Array<{ __typename: 'PlanInclude', text: string, description?: string | null, separator?: boolean | null, link?: { __typename: 'PlanIncludeLink', text: string, url: string } | null }> }, planItem: { __typename: 'PlanItem', status: PlanItemStatus, productId: string, nativeProductId?: string | null, nativePlanId?: string | null, maxUnits?: number | null, action: ActionType, prices: Array<{ __typename: 'PlanPriceItem', type?: PlanPriceType | null, details?: { __typename: 'PlanPriceDetail', billingCycleType?: string | null, amount?: number | null, suffix?: string | null, renderedPrice?: string | null, currency?: string | null } | null }> } } | null }> }, planItem: { __typename: 'PlanItem', status: PlanItemStatus, productId: string, nativeProductId?: string | null, nativePlanId?: string | null, maxUnits?: number | null, action: ActionType, prices: Array<{ __typename: 'PlanPriceItem', type?: PlanPriceType | null, details?: { __typename: 'PlanPriceDetail', billingCycleType?: string | null, amount?: number | null, suffix?: string | null, renderedPrice?: string | null, currency?: string | null } | null }>, upsell?: { __typename: 'UpsellDetails', text: string, ctaText: string, pillText: string, plan: { __typename: 'Plan', id: string, name: string, headerText?: string | null, footerText?: string | null, benefits?: Array<string> | null, description?: string | null, priceCallout?: string | null, showExtraSpacing?: boolean | null, error?: string | null, includes: Array<{ __typename: 'PlanInclude', text: string, description?: string | null, separator?: boolean | null, link?: { __typename: 'PlanIncludeLink', text: string, url: string } | null }> }, planItem: { __typename: 'PlanItem', status: PlanItemStatus, productId: string, nativeProductId?: string | null, nativePlanId?: string | null, maxUnits?: number | null, action: ActionType, prices: Array<{ __typename: 'PlanPriceItem', type?: PlanPriceType | null, details?: { __typename: 'PlanPriceDetail', billingCycleType?: string | null, amount?: number | null, suffix?: string | null, renderedPrice?: string | null, currency?: string | null } | null }> } } | null } } | null } };

export type UpdateFilePrivacyMutationVariables = Exact<{
  fileIds: Array<Scalars['ID']['input']>;
  isPrivate: Scalars['Boolean']['input'];
}>;


export type UpdateFilePrivacyMutation = { __typename: 'Mutation', updateFilePrivacy: { __typename: 'BatchActionResponse', asyncProcess?: boolean | null } };

export type ValidateOtpMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ValidateOtpMutation = { __typename: 'Mutation', validateOTP?: { __typename: 'OTPValidateResponse', validated?: boolean | null } | null };

export type UpdateGuidanceMutationVariables = Exact<{
  input: GuidanceStateInput;
}>;


export type UpdateGuidanceMutation = { __typename: 'Mutation', guidance: { __typename: 'GuidanceStates', states: Array<{ __typename: 'GuidanceStateEntry', id: GuidanceId, state: { __typename: 'GuidanceState', state: GuidanceActionState } }> } };

export type TrackEventMutationVariables = Exact<{
  name: Scalars['String']['input'];
  data: Scalars['String']['input'];
}>;


export type TrackEventMutation = { __typename: 'Mutation', trackEvent: boolean };

export type CompleteStepMutationVariables = Exact<{
  step: Scalars['Int']['input'];
  question?: InputMaybe<Scalars['String']['input']>;
  answers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}>;


export type CompleteStepMutation = { __typename: 'Mutation', completeOnboardingStep: boolean };

export type CompleteOnboardingMutationVariables = Exact<{ [key: string]: never; }>;


export type CompleteOnboardingMutation = { __typename: 'Mutation', completeOnboarding: boolean };

export type PingQueryVariables = Exact<{ [key: string]: never; }>;


export type PingQuery = { __typename: 'Query', ping: string };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename: 'Query', me: { __typename: 'User', id: string, permissions: Array<UserPermission>, avatarUrl: string, bio?: string | null, dateFormat: string, email: string, firstName: string, language?: string | null, lastName: string, name: string, title?: string | null, username: string, totalFiles?: number | null, pendingSales?: number | null, pendingTransfers?: number | null, pendingLicenses?: number | null, totalFilesLimit?: number | null, hasUploadedFileAsAPro?: boolean | null, canChangePlan?: boolean | null, canUpgradePlan?: boolean | null, showUpdatedTerms?: boolean | null, totalCopyrightOwners?: number | null, totalCopyrightOwnersLimit?: number | null, defaultFilePrivacy: FilePrivacy, hasUploadedFile?: boolean | null, reportCredits: number, isCreatingReport: boolean, origin: string, verificationStatus?: VerificationStatus | null, timezone?: { __typename: 'Timezone', country: string, name: string } | null, wallet?: { __typename: 'Wallet', address: string, type: string, anyTokensToTransfer?: boolean | null, anyTokensToSync?: boolean | null, transferringTokens?: boolean | null, syncingTokens?: boolean | null } | null, upcomingBilling?: { __typename: 'UpcomingBiling', date: any, currency: string, total: number, tax?: number | null, registrationTotal: number, outstandingTotal: number } | null, guidanceStates: { __typename: 'GuidanceStates', states: Array<{ __typename: 'GuidanceStateEntry', id: GuidanceId, state: { __typename: 'GuidanceState', state: GuidanceActionState } }> }, membership?: { __typename: 'Membership', id?: string | null, since?: any | null, expiresAt?: any | null } | null } };

export type StatsQueryVariables = Exact<{ [key: string]: never; }>;


export type StatsQuery = { __typename: 'Query', stats: { __typename: 'UserStats', totalFiles: number, pendingLicenses: number, pendingSales: number, pendingTransfers: number, totalFilesLimit?: number | null, hasUploadedFileAsAPro?: boolean | null } };

export type InvoicePdfQueryVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;


export type InvoicePdfQuery = { __typename: 'Query', invoicePdf: { __typename: 'InvoicePdfResult', status: InvoicePdfStatusEnum, url?: string | null } };

export type AgreementUrlQueryVariables = Exact<{
  content: Scalars['String']['input'];
}>;


export type AgreementUrlQuery = { __typename: 'Query', agreementUrl: { __typename: 'AgreementUrlResult', url?: string | null } };

export type FolderByPathQueryVariables = Exact<{
  path: Scalars['String']['input'];
  sortBy?: InputMaybe<SearchSort>;
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
}>;


export type FolderByPathQuery = { __typename: 'Query', folderByPath: { __typename: 'FolderByPathResponse', id: string, name: string, numberOfItems: number, parentPath?: string | null, parentFolderId?: string | null, timestamp: any, next?: Array<any | null> | null, sortBy: SearchSort, items: Array<{ __typename: 'Item', id: string, name: string, parentFolderId: string, parentPath: string, timestamp?: any | null, numberOfItems?: number | null, type: ItemType, file?: { __typename: 'File', id: string, status: FileStatus, billingExpirationDate?: any | null, copyrightId?: string | null, copyrightType?: CopyrightType | null, description?: string | null, fileName: string, imageUrl?: string | null, isDownloadAvailable: boolean, isPrivate: boolean, ownerAddress?: string | null, ownershipRoles: Array<FileOwnerRole>, size: string, timestamp?: any | null, type: FileType, friendlyType: string, vanityName: string, tokenId?: string | null, contractAddress?: string | null, transferStatus?: TransferStatus | null, saleStatus?: SaleStatus | null, licenseStatus?: LicenseStatus | null, certificateUrl?: string | null, ownersCount?: number | null, privacyControllersCount?: number | null, authorsCount?: number | null, authorRoles: Array<FileAuthorRole>, permissions: Array<FilePermission>, isLifetime: boolean, privacyRoles: Array<FilePrivacyRole>, preview?: { __typename: 'AssetPreview', type: AssetPreviewType, url: string, numberOfPages?: number | null } | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, registrations: Array<{ __typename: 'Registration', id: string, name: string, timestamp?: any | null, certificateUrl?: string | null, icon?: string | null }>, license?: { __typename: 'License', id: string, issuedAt: any, tokenId: string, contractAddress: string, timestamp?: any | null, expiresAt?: any | null, canSellOrTransfer: boolean, type?: LicenseType | null, price?: { __typename: 'Price', value: string } | null, agreement?: { __typename: 'LicenseAgreement', isPublic?: boolean | null, type: LicenseAgreementType, content: string } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', isPublic?: boolean | null, type: LicenseAgreementType, content: string } | null } | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, originalCopyright?: { __typename: 'OriginalCopyright', copyrightId: string, timestamp: any, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | null, royaltyOwner?: { __typename: 'RoyaltyOwner', address?: string | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, royalty?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, transactions: Array<{ __typename: 'Transaction', status: TransactionStatus, timestamp: any, hash: string, url: string, from?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, to: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, price?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null }>, owners: Array<{ __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }>, authors: Array<{ __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }>, notifications?: Array<{ __typename: 'Notification', id: string, type: NotificationType, timestamp: any, read: boolean, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' }, primaryIcon: { __typename: 'NotificationIcon', imageUrl?: string | null, syncIcon?: boolean | null, alertIcon?: boolean | null, dacrIcon?: boolean | null }, secondaryIcon?: { __typename: 'NotificationIcon', imageUrl?: string | null, syncIcon?: boolean | null, alertIcon?: boolean | null, dacrIcon?: boolean | null } | null, metadata?: { __typename: 'AccountPaymentMetadata', payment: { __typename: 'Payment', id: string, failedMessage?: string | null, status: PaymentStatus } } | { __typename: 'FileMetadata', file: { __typename: 'File', vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } } | { __typename: 'InfringementMatchMetadata', id: string, level: ScoreLevel, infringingFile: { __typename: 'File', id: string, vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, imageUrl?: string | null }, registeredFile: { __typename: 'File', id: string, vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, imageUrl?: string | null } } | { __typename: 'InviteMetadata', invite: { __typename: 'Invite', id: string, status: InviteStatus, type: InviteType, role?: { __typename: 'InviteFileAuthorRole' } | { __typename: 'InviteFileOwnerRole', value?: FileOwnerRole | null } | { __typename: 'InviteFilePrivacyRole' } | { __typename: 'InviteReportReviewRole' } | { __typename: 'InviteTeamMemberRole', role?: TeamMemberRole | null } | null, from: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, to: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, reference: { __typename: 'Dacr', id: string, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'License', id: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'Origin', id: string, name: string, avatarUrl: string } } } | { __typename: 'InvoiceMetadata' } | { __typename: 'ReportMetadata', id: string, registeredFile: { __typename: 'File', id: string, fileName: string, type: FileType } } | { __typename: 'ReportReviewMetadata' } | { __typename: 'TokenMetadata', from?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, to?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, transferAction?: { __typename: 'TransferAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, contractAddress?: string | null } | null, saleAction?: { __typename: 'SaleAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, contractAddress?: string | null, total?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyOwnerAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacrAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacr?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null, royaltyOwner?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, licenseAction?: { __typename: 'LicenseAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, startsAt?: any | null, endsAt?: any | null, type?: LicenseType | null, referenceId?: string | null, contractAddress?: string | null, allowSellOrTransfer?: boolean | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null } | null, total?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyOwnerAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacrAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacr?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null, royaltyOwner?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, copyright?: { __typename: 'Dacr', id: string, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, contractAddress?: string | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'License', id: string, issuedAt: any, contractAddress: string, expiresAt?: any | null, canSellOrTransfer: boolean, type?: LicenseType | null, licenser?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, contractAddress?: string | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', content: string, type: LicenseAgreementType, isPublic?: boolean | null } | null } | null } | null } | { __typename: 'TransferToNoAccountMetadata', address: string, file: { __typename: 'File', vanityName: string, fileName: string, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } } | { __typename: 'UploadFileMetadata', filename: string } | { __typename: 'UserMetadata', entity: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null }> | null, analysis?: { __typename: 'AnalysisResponse', status: AnalysisStatus, data?: { __typename: 'Analysis', summary: string, stems?: Array<{ __typename: 'Stems', amplitudeUrl: string, breakdown: Array<{ __typename: 'Stem', name: string, url: string, sheet: { __typename: 'SheetMusic', url: string, preview: string } }> }> | null, lyrics?: { __typename: 'Lyrics', url: string, preview: Array<{ __typename: 'Lyric', lyric: string, timestamp: string }> } | null, markers: Array<{ __typename: 'Marker', color: string, shine: boolean } | null>, attributes: Array<{ __typename: 'Attribute', key: string, value: string }>, sheetMusic?: { __typename: 'SheetMusic', url: string, preview: string } | null } | null } | null, registrant: { __typename: 'BasicUser', id: string, name: string } } | null }> } };

export type FolderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  sortBy?: InputMaybe<SearchSort>;
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
}>;


export type FolderQuery = { __typename: 'Query', folder: { __typename: 'FolderByIdResponse', id: string, name: string, numberOfItems: number, parentPath?: string | null, parentFolderId?: string | null, timestamp: any, next?: Array<any | null> | null, items: Array<{ __typename: 'Item', id: string, name: string, parentFolderId: string, parentPath: string, timestamp?: any | null, numberOfItems?: number | null, type: ItemType, file?: { __typename: 'File', id: string, status: FileStatus, billingExpirationDate?: any | null, copyrightId?: string | null, copyrightType?: CopyrightType | null, description?: string | null, fileName: string, imageUrl?: string | null, isDownloadAvailable: boolean, isPrivate: boolean, ownerAddress?: string | null, ownershipRoles: Array<FileOwnerRole>, size: string, timestamp?: any | null, type: FileType, friendlyType: string, vanityName: string, tokenId?: string | null, contractAddress?: string | null, transferStatus?: TransferStatus | null, saleStatus?: SaleStatus | null, licenseStatus?: LicenseStatus | null, certificateUrl?: string | null, ownersCount?: number | null, privacyControllersCount?: number | null, authorsCount?: number | null, authorRoles: Array<FileAuthorRole>, permissions: Array<FilePermission>, isLifetime: boolean, privacyRoles: Array<FilePrivacyRole>, preview?: { __typename: 'AssetPreview', type: AssetPreviewType, url: string, numberOfPages?: number | null } | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, registrations: Array<{ __typename: 'Registration', id: string, name: string, timestamp?: any | null, certificateUrl?: string | null, icon?: string | null }>, license?: { __typename: 'License', id: string, issuedAt: any, tokenId: string, contractAddress: string, timestamp?: any | null, expiresAt?: any | null, canSellOrTransfer: boolean, type?: LicenseType | null, price?: { __typename: 'Price', value: string } | null, agreement?: { __typename: 'LicenseAgreement', isPublic?: boolean | null, type: LicenseAgreementType, content: string } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', isPublic?: boolean | null, type: LicenseAgreementType, content: string } | null } | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, originalCopyright?: { __typename: 'OriginalCopyright', copyrightId: string, timestamp: any, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | null, royaltyOwner?: { __typename: 'RoyaltyOwner', address?: string | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, royalty?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, transactions: Array<{ __typename: 'Transaction', status: TransactionStatus, timestamp: any, hash: string, url: string, from?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, to: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, price?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null }>, owners: Array<{ __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }>, authors: Array<{ __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }>, notifications?: Array<{ __typename: 'Notification', id: string, type: NotificationType, timestamp: any, read: boolean, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' }, primaryIcon: { __typename: 'NotificationIcon', imageUrl?: string | null, syncIcon?: boolean | null, alertIcon?: boolean | null, dacrIcon?: boolean | null }, secondaryIcon?: { __typename: 'NotificationIcon', imageUrl?: string | null, syncIcon?: boolean | null, alertIcon?: boolean | null, dacrIcon?: boolean | null } | null, metadata?: { __typename: 'AccountPaymentMetadata', payment: { __typename: 'Payment', id: string, failedMessage?: string | null, status: PaymentStatus } } | { __typename: 'FileMetadata', file: { __typename: 'File', vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } } | { __typename: 'InfringementMatchMetadata', id: string, level: ScoreLevel, infringingFile: { __typename: 'File', id: string, vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, imageUrl?: string | null }, registeredFile: { __typename: 'File', id: string, vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, imageUrl?: string | null } } | { __typename: 'InviteMetadata', invite: { __typename: 'Invite', id: string, status: InviteStatus, type: InviteType, role?: { __typename: 'InviteFileAuthorRole' } | { __typename: 'InviteFileOwnerRole', value?: FileOwnerRole | null } | { __typename: 'InviteFilePrivacyRole' } | { __typename: 'InviteReportReviewRole' } | { __typename: 'InviteTeamMemberRole', role?: TeamMemberRole | null } | null, from: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, to: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, reference: { __typename: 'Dacr', id: string, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'License', id: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'Origin', id: string, name: string, avatarUrl: string } } } | { __typename: 'InvoiceMetadata' } | { __typename: 'ReportMetadata', id: string, registeredFile: { __typename: 'File', id: string, fileName: string, type: FileType } } | { __typename: 'ReportReviewMetadata' } | { __typename: 'TokenMetadata', from?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, to?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, transferAction?: { __typename: 'TransferAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, contractAddress?: string | null } | null, saleAction?: { __typename: 'SaleAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, contractAddress?: string | null, total?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyOwnerAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacrAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacr?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null, royaltyOwner?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, licenseAction?: { __typename: 'LicenseAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, startsAt?: any | null, endsAt?: any | null, type?: LicenseType | null, referenceId?: string | null, contractAddress?: string | null, allowSellOrTransfer?: boolean | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null } | null, total?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyOwnerAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacrAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacr?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null, royaltyOwner?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, copyright?: { __typename: 'Dacr', id: string, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, contractAddress?: string | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'License', id: string, issuedAt: any, contractAddress: string, expiresAt?: any | null, canSellOrTransfer: boolean, type?: LicenseType | null, licenser?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, contractAddress?: string | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', content: string, type: LicenseAgreementType, isPublic?: boolean | null } | null } | null } | null } | { __typename: 'TransferToNoAccountMetadata', address: string, file: { __typename: 'File', vanityName: string, fileName: string, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } } | { __typename: 'UploadFileMetadata', filename: string } | { __typename: 'UserMetadata', entity: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null }> | null, analysis?: { __typename: 'AnalysisResponse', status: AnalysisStatus, data?: { __typename: 'Analysis', summary: string, stems?: Array<{ __typename: 'Stems', amplitudeUrl: string, breakdown: Array<{ __typename: 'Stem', name: string, url: string, sheet: { __typename: 'SheetMusic', url: string, preview: string } }> }> | null, lyrics?: { __typename: 'Lyrics', url: string, preview: Array<{ __typename: 'Lyric', lyric: string, timestamp: string }> } | null, markers: Array<{ __typename: 'Marker', color: string, shine: boolean } | null>, attributes: Array<{ __typename: 'Attribute', key: string, value: string }>, sheetMusic?: { __typename: 'SheetMusic', url: string, preview: string } | null } | null } | null, registrant: { __typename: 'BasicUser', id: string, name: string } } | null }> } };

export type CheckUsernameAvailabilityQueryVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type CheckUsernameAvailabilityQuery = { __typename: 'Query', checkUsernameAvailability: boolean };

export type FileQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  accessToken?: InputMaybe<Scalars['ID']['input']>;
}>;


export type FileQuery = { __typename: 'Query', file: { __typename: 'File', id: string, status: FileStatus, billingExpirationDate?: any | null, copyrightId?: string | null, copyrightType?: CopyrightType | null, description?: string | null, fileName: string, imageUrl?: string | null, isDownloadAvailable: boolean, isPrivate: boolean, ownerAddress?: string | null, ownershipRoles: Array<FileOwnerRole>, size: string, timestamp?: any | null, type: FileType, friendlyType: string, vanityName: string, tokenId?: string | null, contractAddress?: string | null, transferStatus?: TransferStatus | null, saleStatus?: SaleStatus | null, licenseStatus?: LicenseStatus | null, certificateUrl?: string | null, ownersCount?: number | null, privacyControllersCount?: number | null, authorsCount?: number | null, authorRoles: Array<FileAuthorRole>, permissions: Array<FilePermission>, isLifetime: boolean, privacyRoles: Array<FilePrivacyRole>, preview?: { __typename: 'AssetPreview', type: AssetPreviewType, url: string, numberOfPages?: number | null } | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, registrations: Array<{ __typename: 'Registration', id: string, name: string, timestamp?: any | null, certificateUrl?: string | null, icon?: string | null }>, license?: { __typename: 'License', id: string, issuedAt: any, tokenId: string, contractAddress: string, timestamp?: any | null, expiresAt?: any | null, canSellOrTransfer: boolean, type?: LicenseType | null, price?: { __typename: 'Price', value: string } | null, agreement?: { __typename: 'LicenseAgreement', isPublic?: boolean | null, type: LicenseAgreementType, content: string } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', isPublic?: boolean | null, type: LicenseAgreementType, content: string } | null } | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, originalCopyright?: { __typename: 'OriginalCopyright', copyrightId: string, timestamp: any, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | null, royaltyOwner?: { __typename: 'RoyaltyOwner', address?: string | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, royalty?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, transactions: Array<{ __typename: 'Transaction', status: TransactionStatus, timestamp: any, hash: string, url: string, from?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, to: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, price?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null }>, owners: Array<{ __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }>, authors: Array<{ __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }>, notifications?: Array<{ __typename: 'Notification', id: string, type: NotificationType, timestamp: any, read: boolean, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' }, primaryIcon: { __typename: 'NotificationIcon', imageUrl?: string | null, syncIcon?: boolean | null, alertIcon?: boolean | null, dacrIcon?: boolean | null }, secondaryIcon?: { __typename: 'NotificationIcon', imageUrl?: string | null, syncIcon?: boolean | null, alertIcon?: boolean | null, dacrIcon?: boolean | null } | null, metadata?: { __typename: 'AccountPaymentMetadata', payment: { __typename: 'Payment', id: string, failedMessage?: string | null, status: PaymentStatus } } | { __typename: 'FileMetadata', file: { __typename: 'File', vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } } | { __typename: 'InfringementMatchMetadata', id: string, level: ScoreLevel, infringingFile: { __typename: 'File', id: string, vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, imageUrl?: string | null }, registeredFile: { __typename: 'File', id: string, vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, imageUrl?: string | null } } | { __typename: 'InviteMetadata', invite: { __typename: 'Invite', id: string, status: InviteStatus, type: InviteType, role?: { __typename: 'InviteFileAuthorRole' } | { __typename: 'InviteFileOwnerRole', value?: FileOwnerRole | null } | { __typename: 'InviteFilePrivacyRole' } | { __typename: 'InviteReportReviewRole' } | { __typename: 'InviteTeamMemberRole', role?: TeamMemberRole | null } | null, from: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, to: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, reference: { __typename: 'Dacr', id: string, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'License', id: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'Origin', id: string, name: string, avatarUrl: string } } } | { __typename: 'InvoiceMetadata' } | { __typename: 'ReportMetadata', id: string, registeredFile: { __typename: 'File', id: string, fileName: string, type: FileType } } | { __typename: 'ReportReviewMetadata' } | { __typename: 'TokenMetadata', from?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, to?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, transferAction?: { __typename: 'TransferAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, contractAddress?: string | null } | null, saleAction?: { __typename: 'SaleAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, contractAddress?: string | null, total?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyOwnerAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacrAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacr?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null, royaltyOwner?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, licenseAction?: { __typename: 'LicenseAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, startsAt?: any | null, endsAt?: any | null, type?: LicenseType | null, referenceId?: string | null, contractAddress?: string | null, allowSellOrTransfer?: boolean | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null } | null, total?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyOwnerAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacrAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacr?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null, royaltyOwner?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, copyright?: { __typename: 'Dacr', id: string, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, contractAddress?: string | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'License', id: string, issuedAt: any, contractAddress: string, expiresAt?: any | null, canSellOrTransfer: boolean, type?: LicenseType | null, licenser?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, contractAddress?: string | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', content: string, type: LicenseAgreementType, isPublic?: boolean | null } | null } | null } | null } | { __typename: 'TransferToNoAccountMetadata', address: string, file: { __typename: 'File', vanityName: string, fileName: string, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } } | { __typename: 'UploadFileMetadata', filename: string } | { __typename: 'UserMetadata', entity: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null }> | null, analysis?: { __typename: 'AnalysisResponse', status: AnalysisStatus, data?: { __typename: 'Analysis', summary: string, stems?: Array<{ __typename: 'Stems', amplitudeUrl: string, breakdown: Array<{ __typename: 'Stem', name: string, url: string, sheet: { __typename: 'SheetMusic', url: string, preview: string } }> }> | null, lyrics?: { __typename: 'Lyrics', url: string, preview: Array<{ __typename: 'Lyric', lyric: string, timestamp: string }> } | null, markers: Array<{ __typename: 'Marker', color: string, shine: boolean } | null>, attributes: Array<{ __typename: 'Attribute', key: string, value: string }>, sheetMusic?: { __typename: 'SheetMusic', url: string, preview: string } | null } | null } | null, registrant: { __typename: 'BasicUser', id: string, name: string } } };

export type ArchivedFilesQueryVariables = Exact<{
  sortBy?: InputMaybe<SearchSort>;
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
}>;


export type ArchivedFilesQuery = { __typename: 'Query', archivedFiles: { __typename: 'ArchivedFilesResponse', next?: Array<any | null> | null, total: number, items: Array<{ __typename: 'ArchivedFile', id: string, archivedAt: any, status: string, size: string, type: FileType, friendlyType: string, fileName: string, imageUrl?: string | null, transactions: Array<{ __typename: 'Transaction', timestamp: any, status: TransactionStatus, hash: string, from?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, to: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, price?: { __typename: 'Price', value: string } | null }> }> } };

export type ConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type ConfigQuery = { __typename: 'Query', config: { __typename: 'Config', wallets: { __typename: 'ConfigWallets', dacrAddress: string, licenseAddress: string }, contracts: { __typename: 'ConfigContract', dacr: { __typename: 'Contract', contractAddress: string, royalty?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null }, license: { __typename: 'Contract', contractAddress: string, royalty?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } } } };

export type SearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SearchQuery = { __typename: 'Query', search: { __typename: 'CombinedSearchResult', items: Array<{ __typename: 'Item', id: string, name: string, parentFolderId: string, parentPath: string, timestamp?: any | null, numberOfItems?: number | null, type: ItemType, file?: { __typename: 'File', id: string, status: FileStatus, billingExpirationDate?: any | null, copyrightId?: string | null, copyrightType?: CopyrightType | null, description?: string | null, fileName: string, imageUrl?: string | null, isDownloadAvailable: boolean, isPrivate: boolean, ownerAddress?: string | null, ownershipRoles: Array<FileOwnerRole>, size: string, timestamp?: any | null, type: FileType, friendlyType: string, vanityName: string, tokenId?: string | null, contractAddress?: string | null, transferStatus?: TransferStatus | null, saleStatus?: SaleStatus | null, licenseStatus?: LicenseStatus | null, certificateUrl?: string | null, ownersCount?: number | null, privacyControllersCount?: number | null, authorsCount?: number | null, authorRoles: Array<FileAuthorRole>, permissions: Array<FilePermission>, isLifetime: boolean, privacyRoles: Array<FilePrivacyRole>, preview?: { __typename: 'AssetPreview', type: AssetPreviewType, url: string, numberOfPages?: number | null } | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, registrations: Array<{ __typename: 'Registration', id: string, name: string, timestamp?: any | null, certificateUrl?: string | null, icon?: string | null }>, license?: { __typename: 'License', id: string, issuedAt: any, tokenId: string, contractAddress: string, timestamp?: any | null, expiresAt?: any | null, canSellOrTransfer: boolean, type?: LicenseType | null, price?: { __typename: 'Price', value: string } | null, agreement?: { __typename: 'LicenseAgreement', isPublic?: boolean | null, type: LicenseAgreementType, content: string } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', isPublic?: boolean | null, type: LicenseAgreementType, content: string } | null } | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, originalCopyright?: { __typename: 'OriginalCopyright', copyrightId: string, timestamp: any, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | null, royaltyOwner?: { __typename: 'RoyaltyOwner', address?: string | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, royalty?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, transactions: Array<{ __typename: 'Transaction', status: TransactionStatus, timestamp: any, hash: string, url: string, from?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, to: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, price?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null }>, owners: Array<{ __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }>, authors: Array<{ __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }>, notifications?: Array<{ __typename: 'Notification', id: string, type: NotificationType, timestamp: any, read: boolean, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' }, primaryIcon: { __typename: 'NotificationIcon', imageUrl?: string | null, syncIcon?: boolean | null, alertIcon?: boolean | null, dacrIcon?: boolean | null }, secondaryIcon?: { __typename: 'NotificationIcon', imageUrl?: string | null, syncIcon?: boolean | null, alertIcon?: boolean | null, dacrIcon?: boolean | null } | null, metadata?: { __typename: 'AccountPaymentMetadata', payment: { __typename: 'Payment', id: string, failedMessage?: string | null, status: PaymentStatus } } | { __typename: 'FileMetadata', file: { __typename: 'File', vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } } | { __typename: 'InfringementMatchMetadata', id: string, level: ScoreLevel, infringingFile: { __typename: 'File', id: string, vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, imageUrl?: string | null }, registeredFile: { __typename: 'File', id: string, vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, imageUrl?: string | null } } | { __typename: 'InviteMetadata', invite: { __typename: 'Invite', id: string, status: InviteStatus, type: InviteType, role?: { __typename: 'InviteFileAuthorRole' } | { __typename: 'InviteFileOwnerRole', value?: FileOwnerRole | null } | { __typename: 'InviteFilePrivacyRole' } | { __typename: 'InviteReportReviewRole' } | { __typename: 'InviteTeamMemberRole', role?: TeamMemberRole | null } | null, from: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, to: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, reference: { __typename: 'Dacr', id: string, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'License', id: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'Origin', id: string, name: string, avatarUrl: string } } } | { __typename: 'InvoiceMetadata' } | { __typename: 'ReportMetadata', id: string, registeredFile: { __typename: 'File', id: string, fileName: string, type: FileType } } | { __typename: 'ReportReviewMetadata' } | { __typename: 'TokenMetadata', from?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, to?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, transferAction?: { __typename: 'TransferAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, contractAddress?: string | null } | null, saleAction?: { __typename: 'SaleAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, contractAddress?: string | null, total?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyOwnerAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacrAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacr?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null, royaltyOwner?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, licenseAction?: { __typename: 'LicenseAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, startsAt?: any | null, endsAt?: any | null, type?: LicenseType | null, referenceId?: string | null, contractAddress?: string | null, allowSellOrTransfer?: boolean | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null } | null, total?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyOwnerAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacrAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacr?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null, royaltyOwner?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, copyright?: { __typename: 'Dacr', id: string, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, contractAddress?: string | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'License', id: string, issuedAt: any, contractAddress: string, expiresAt?: any | null, canSellOrTransfer: boolean, type?: LicenseType | null, licenser?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, contractAddress?: string | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', content: string, type: LicenseAgreementType, isPublic?: boolean | null } | null } | null } | null } | { __typename: 'TransferToNoAccountMetadata', address: string, file: { __typename: 'File', vanityName: string, fileName: string, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } } | { __typename: 'UploadFileMetadata', filename: string } | { __typename: 'UserMetadata', entity: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null }> | null, analysis?: { __typename: 'AnalysisResponse', status: AnalysisStatus, data?: { __typename: 'Analysis', summary: string, stems?: Array<{ __typename: 'Stems', amplitudeUrl: string, breakdown: Array<{ __typename: 'Stem', name: string, url: string, sheet: { __typename: 'SheetMusic', url: string, preview: string } }> }> | null, lyrics?: { __typename: 'Lyrics', url: string, preview: Array<{ __typename: 'Lyric', lyric: string, timestamp: string }> } | null, markers: Array<{ __typename: 'Marker', color: string, shine: boolean } | null>, attributes: Array<{ __typename: 'Attribute', key: string, value: string }>, sheetMusic?: { __typename: 'SheetMusic', url: string, preview: string } | null } | null } | null, registrant: { __typename: 'BasicUser', id: string, name: string } } | null }>, files: Array<{ __typename: 'SearchFile', id: string, name: string, filename: string, type: FileType, status?: FileStatus | null, timestamp?: any | null, imageUrl?: string | null, copyrightType?: CopyrightType | null }>, token?: { __typename: 'SearchFile', id: string, name: string, filename: string, type: FileType, status?: FileStatus | null, timestamp?: any | null, imageUrl?: string | null } | null } };

export type NotificationsQueryVariables = Exact<{
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
}>;


export type NotificationsQuery = { __typename: 'Query', notifications: { __typename: 'NotificationsResponse', next?: Array<any | null> | null, unreadNotifications?: number | null, notifications: Array<{ __typename: 'Notification', id: string, type: NotificationType, timestamp: any, read: boolean, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' }, primaryIcon: { __typename: 'NotificationIcon', imageUrl?: string | null, syncIcon?: boolean | null, alertIcon?: boolean | null, dacrIcon?: boolean | null }, secondaryIcon?: { __typename: 'NotificationIcon', imageUrl?: string | null, syncIcon?: boolean | null, alertIcon?: boolean | null, dacrIcon?: boolean | null } | null, metadata?: { __typename: 'AccountPaymentMetadata', payment: { __typename: 'Payment', id: string, failedMessage?: string | null, status: PaymentStatus } } | { __typename: 'FileMetadata', file: { __typename: 'File', vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } } | { __typename: 'InfringementMatchMetadata', id: string, level: ScoreLevel, infringingFile: { __typename: 'File', id: string, vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, imageUrl?: string | null }, registeredFile: { __typename: 'File', id: string, vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, imageUrl?: string | null } } | { __typename: 'InviteMetadata', invite: { __typename: 'Invite', id: string, status: InviteStatus, type: InviteType, role?: { __typename: 'InviteFileAuthorRole' } | { __typename: 'InviteFileOwnerRole', value?: FileOwnerRole | null } | { __typename: 'InviteFilePrivacyRole' } | { __typename: 'InviteReportReviewRole' } | { __typename: 'InviteTeamMemberRole', role?: TeamMemberRole | null } | null, from: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, to: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, reference: { __typename: 'Dacr', id: string, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'License', id: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'Origin', id: string, name: string, avatarUrl: string } } } | { __typename: 'InvoiceMetadata' } | { __typename: 'ReportMetadata', id: string, registeredFile: { __typename: 'File', id: string, fileName: string, type: FileType } } | { __typename: 'ReportReviewMetadata' } | { __typename: 'TokenMetadata', from?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, to?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, transferAction?: { __typename: 'TransferAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, contractAddress?: string | null } | null, saleAction?: { __typename: 'SaleAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, contractAddress?: string | null, total?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyOwnerAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacrAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacr?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null, royaltyOwner?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, licenseAction?: { __typename: 'LicenseAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, startsAt?: any | null, endsAt?: any | null, type?: LicenseType | null, referenceId?: string | null, contractAddress?: string | null, allowSellOrTransfer?: boolean | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null } | null, total?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyOwnerAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacrAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacr?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null, royaltyOwner?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, copyright?: { __typename: 'Dacr', id: string, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, contractAddress?: string | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'License', id: string, issuedAt: any, contractAddress: string, expiresAt?: any | null, canSellOrTransfer: boolean, type?: LicenseType | null, licenser?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, contractAddress?: string | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', content: string, type: LicenseAgreementType, isPublic?: boolean | null } | null } | null } | null } | { __typename: 'TransferToNoAccountMetadata', address: string, file: { __typename: 'File', vanityName: string, fileName: string, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } } | { __typename: 'UploadFileMetadata', filename: string } | { __typename: 'UserMetadata', entity: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null }> } };

export type SearchItemsQueryVariables = Exact<{
  query: Scalars['String']['input'];
  sortBy?: InputMaybe<SearchSort>;
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
}>;


export type SearchItemsQuery = { __typename: 'Query', searchItems: { __typename: 'SearchItemsResponse', total: number, next?: Array<any | null> | null, files: Array<{ __typename: 'Item', id: string, type: ItemType, name: string, timestamp?: any | null, parentPath: string, file?: { __typename: 'File', id: string, status: FileStatus, billingExpirationDate?: any | null, copyrightId?: string | null, copyrightType?: CopyrightType | null, description?: string | null, fileName: string, imageUrl?: string | null, isDownloadAvailable: boolean, isPrivate: boolean, ownerAddress?: string | null, ownershipRoles: Array<FileOwnerRole>, size: string, timestamp?: any | null, type: FileType, friendlyType: string, vanityName: string, tokenId?: string | null, contractAddress?: string | null, transferStatus?: TransferStatus | null, saleStatus?: SaleStatus | null, licenseStatus?: LicenseStatus | null, certificateUrl?: string | null, ownersCount?: number | null, privacyControllersCount?: number | null, authorsCount?: number | null, authorRoles: Array<FileAuthorRole>, permissions: Array<FilePermission>, isLifetime: boolean, privacyRoles: Array<FilePrivacyRole>, preview?: { __typename: 'AssetPreview', type: AssetPreviewType, url: string, numberOfPages?: number | null } | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, registrations: Array<{ __typename: 'Registration', id: string, name: string, timestamp?: any | null, certificateUrl?: string | null, icon?: string | null }>, license?: { __typename: 'License', id: string, issuedAt: any, tokenId: string, contractAddress: string, timestamp?: any | null, expiresAt?: any | null, canSellOrTransfer: boolean, type?: LicenseType | null, price?: { __typename: 'Price', value: string } | null, agreement?: { __typename: 'LicenseAgreement', isPublic?: boolean | null, type: LicenseAgreementType, content: string } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', isPublic?: boolean | null, type: LicenseAgreementType, content: string } | null } | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, originalCopyright?: { __typename: 'OriginalCopyright', copyrightId: string, timestamp: any, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | null, royaltyOwner?: { __typename: 'RoyaltyOwner', address?: string | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, royalty?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, transactions: Array<{ __typename: 'Transaction', status: TransactionStatus, timestamp: any, hash: string, url: string, from?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, to: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, price?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null }>, owners: Array<{ __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }>, authors: Array<{ __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }>, notifications?: Array<{ __typename: 'Notification', id: string, type: NotificationType, timestamp: any, read: boolean, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' }, primaryIcon: { __typename: 'NotificationIcon', imageUrl?: string | null, syncIcon?: boolean | null, alertIcon?: boolean | null, dacrIcon?: boolean | null }, secondaryIcon?: { __typename: 'NotificationIcon', imageUrl?: string | null, syncIcon?: boolean | null, alertIcon?: boolean | null, dacrIcon?: boolean | null } | null, metadata?: { __typename: 'AccountPaymentMetadata', payment: { __typename: 'Payment', id: string, failedMessage?: string | null, status: PaymentStatus } } | { __typename: 'FileMetadata', file: { __typename: 'File', vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } } | { __typename: 'InfringementMatchMetadata', id: string, level: ScoreLevel, infringingFile: { __typename: 'File', id: string, vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, imageUrl?: string | null }, registeredFile: { __typename: 'File', id: string, vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, imageUrl?: string | null } } | { __typename: 'InviteMetadata', invite: { __typename: 'Invite', id: string, status: InviteStatus, type: InviteType, role?: { __typename: 'InviteFileAuthorRole' } | { __typename: 'InviteFileOwnerRole', value?: FileOwnerRole | null } | { __typename: 'InviteFilePrivacyRole' } | { __typename: 'InviteReportReviewRole' } | { __typename: 'InviteTeamMemberRole', role?: TeamMemberRole | null } | null, from: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, to: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, reference: { __typename: 'Dacr', id: string, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'License', id: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'Origin', id: string, name: string, avatarUrl: string } } } | { __typename: 'InvoiceMetadata' } | { __typename: 'ReportMetadata', id: string, registeredFile: { __typename: 'File', id: string, fileName: string, type: FileType } } | { __typename: 'ReportReviewMetadata' } | { __typename: 'TokenMetadata', from?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, to?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, transferAction?: { __typename: 'TransferAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, contractAddress?: string | null } | null, saleAction?: { __typename: 'SaleAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, contractAddress?: string | null, total?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyOwnerAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacrAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacr?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null, royaltyOwner?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, licenseAction?: { __typename: 'LicenseAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, startsAt?: any | null, endsAt?: any | null, type?: LicenseType | null, referenceId?: string | null, contractAddress?: string | null, allowSellOrTransfer?: boolean | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null } | null, total?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyOwnerAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacrAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacr?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null, royaltyOwner?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, copyright?: { __typename: 'Dacr', id: string, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, contractAddress?: string | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'License', id: string, issuedAt: any, contractAddress: string, expiresAt?: any | null, canSellOrTransfer: boolean, type?: LicenseType | null, licenser?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, contractAddress?: string | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', content: string, type: LicenseAgreementType, isPublic?: boolean | null } | null } | null } | null } | { __typename: 'TransferToNoAccountMetadata', address: string, file: { __typename: 'File', vanityName: string, fileName: string, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } } | { __typename: 'UploadFileMetadata', filename: string } | { __typename: 'UserMetadata', entity: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null }> | null, analysis?: { __typename: 'AnalysisResponse', status: AnalysisStatus, data?: { __typename: 'Analysis', summary: string, stems?: Array<{ __typename: 'Stems', amplitudeUrl: string, breakdown: Array<{ __typename: 'Stem', name: string, url: string, sheet: { __typename: 'SheetMusic', url: string, preview: string } }> }> | null, lyrics?: { __typename: 'Lyrics', url: string, preview: Array<{ __typename: 'Lyric', lyric: string, timestamp: string }> } | null, markers: Array<{ __typename: 'Marker', color: string, shine: boolean } | null>, attributes: Array<{ __typename: 'Attribute', key: string, value: string }>, sheetMusic?: { __typename: 'SheetMusic', url: string, preview: string } | null } | null } | null, registrant: { __typename: 'BasicUser', id: string, name: string } } | null }> } };

export type SearchFilesQueryVariables = Exact<{
  query: Scalars['String']['input'];
  filterBy?: InputMaybe<Array<FileCategory>>;
  sortBy?: InputMaybe<SearchSort>;
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
}>;


export type SearchFilesQuery = { __typename: 'Query', searchFiles: { __typename: 'SearchFilesResponse', total: number, next?: Array<any | null> | null, files: Array<{ __typename: 'SearchFile', id: string, name: string, filename: string, type: FileType, status?: FileStatus | null, imageUrl?: string | null, category: FileCategory, timestamp?: any | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } }> } };

export type SearchUsersQueryVariables = Exact<{
  query: Scalars['String']['input'];
  withConnectedWallets?: InputMaybe<Scalars['Boolean']['input']>;
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
}>;


export type SearchUsersQuery = { __typename: 'Query', searchUsers: { __typename: 'SearchUsersResponse', next?: Array<any | null> | null, users: Array<{ __typename: 'SearchUser', id: string, name: string, avatarUrl: string, username: string }> } };

export type SearchEntitiesQueryVariables = Exact<{
  query: Scalars['String']['input'];
  filterBy?: InputMaybe<EntityType>;
  showOwnEntity?: InputMaybe<Scalars['Boolean']['input']>;
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
}>;


export type SearchEntitiesQuery = { __typename: 'Query', searchEntities: { __typename: 'SearchEntitiesResponse', next?: Array<any | null> | null, entities: Array<{ __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }> } };

export type FoldersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
}>;


export type FoldersQuery = { __typename: 'Query', folders: { __typename: 'FoldersResponse', id: string, name: string, parentFolderId?: string | null, next?: Array<any | null> | null, items: Array<{ __typename: 'Item', name: string, id: string, type: ItemType, parentPath: string }> } };

export type CopyrightTransactionsQueryVariables = Exact<{
  type: CopyrightTransactionQueryType;
  sortBy?: InputMaybe<SearchSort>;
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
}>;


export type CopyrightTransactionsQuery = { __typename: 'Query', copyrightTransactions: { __typename: 'CopyrightTransactionsResponse', next?: Array<any | null> | null, copyrightTransactions: Array<{ __typename: 'CopyrightTransaction', tokenId: string, contractAddress: string, status: CopyrightTransactionStatus, type: CopyrightTransactionType, timestamp: any, receiverAddress: string, file?: { __typename: 'File', id: string, status: FileStatus, billingExpirationDate?: any | null, copyrightId?: string | null, copyrightType?: CopyrightType | null, description?: string | null, fileName: string, imageUrl?: string | null, isDownloadAvailable: boolean, isPrivate: boolean, ownerAddress?: string | null, ownershipRoles: Array<FileOwnerRole>, size: string, timestamp?: any | null, type: FileType, friendlyType: string, vanityName: string, tokenId?: string | null, contractAddress?: string | null, transferStatus?: TransferStatus | null, saleStatus?: SaleStatus | null, licenseStatus?: LicenseStatus | null, certificateUrl?: string | null, ownersCount?: number | null, privacyControllersCount?: number | null, authorsCount?: number | null, authorRoles: Array<FileAuthorRole>, permissions: Array<FilePermission>, isLifetime: boolean, privacyRoles: Array<FilePrivacyRole>, preview?: { __typename: 'AssetPreview', type: AssetPreviewType, url: string, numberOfPages?: number | null } | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, registrations: Array<{ __typename: 'Registration', id: string, name: string, timestamp?: any | null, certificateUrl?: string | null, icon?: string | null }>, license?: { __typename: 'License', id: string, issuedAt: any, tokenId: string, contractAddress: string, timestamp?: any | null, expiresAt?: any | null, canSellOrTransfer: boolean, type?: LicenseType | null, price?: { __typename: 'Price', value: string } | null, agreement?: { __typename: 'LicenseAgreement', isPublic?: boolean | null, type: LicenseAgreementType, content: string } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', isPublic?: boolean | null, type: LicenseAgreementType, content: string } | null } | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, originalCopyright?: { __typename: 'OriginalCopyright', copyrightId: string, timestamp: any, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | null, royaltyOwner?: { __typename: 'RoyaltyOwner', address?: string | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, royalty?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, transactions: Array<{ __typename: 'Transaction', status: TransactionStatus, timestamp: any, hash: string, url: string, from?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, to: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, price?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null }>, owners: Array<{ __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }>, authors: Array<{ __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }>, notifications?: Array<{ __typename: 'Notification', id: string, type: NotificationType, timestamp: any, read: boolean, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' }, primaryIcon: { __typename: 'NotificationIcon', imageUrl?: string | null, syncIcon?: boolean | null, alertIcon?: boolean | null, dacrIcon?: boolean | null }, secondaryIcon?: { __typename: 'NotificationIcon', imageUrl?: string | null, syncIcon?: boolean | null, alertIcon?: boolean | null, dacrIcon?: boolean | null } | null, metadata?: { __typename: 'AccountPaymentMetadata', payment: { __typename: 'Payment', id: string, failedMessage?: string | null, status: PaymentStatus } } | { __typename: 'FileMetadata', file: { __typename: 'File', vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } } | { __typename: 'InfringementMatchMetadata', id: string, level: ScoreLevel, infringingFile: { __typename: 'File', id: string, vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, imageUrl?: string | null }, registeredFile: { __typename: 'File', id: string, vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, imageUrl?: string | null } } | { __typename: 'InviteMetadata', invite: { __typename: 'Invite', id: string, status: InviteStatus, type: InviteType, role?: { __typename: 'InviteFileAuthorRole' } | { __typename: 'InviteFileOwnerRole', value?: FileOwnerRole | null } | { __typename: 'InviteFilePrivacyRole' } | { __typename: 'InviteReportReviewRole' } | { __typename: 'InviteTeamMemberRole', role?: TeamMemberRole | null } | null, from: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, to: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, reference: { __typename: 'Dacr', id: string, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'License', id: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'Origin', id: string, name: string, avatarUrl: string } } } | { __typename: 'InvoiceMetadata' } | { __typename: 'ReportMetadata', id: string, registeredFile: { __typename: 'File', id: string, fileName: string, type: FileType } } | { __typename: 'ReportReviewMetadata' } | { __typename: 'TokenMetadata', from?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, to?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, transferAction?: { __typename: 'TransferAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, contractAddress?: string | null } | null, saleAction?: { __typename: 'SaleAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, contractAddress?: string | null, total?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyOwnerAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacrAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacr?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null, royaltyOwner?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, licenseAction?: { __typename: 'LicenseAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, startsAt?: any | null, endsAt?: any | null, type?: LicenseType | null, referenceId?: string | null, contractAddress?: string | null, allowSellOrTransfer?: boolean | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null } | null, total?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyOwnerAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacrAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacr?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null, royaltyOwner?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, copyright?: { __typename: 'Dacr', id: string, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, contractAddress?: string | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'License', id: string, issuedAt: any, contractAddress: string, expiresAt?: any | null, canSellOrTransfer: boolean, type?: LicenseType | null, licenser?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, contractAddress?: string | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', content: string, type: LicenseAgreementType, isPublic?: boolean | null } | null } | null } | null } | { __typename: 'TransferToNoAccountMetadata', address: string, file: { __typename: 'File', vanityName: string, fileName: string, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } } | { __typename: 'UploadFileMetadata', filename: string } | { __typename: 'UserMetadata', entity: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null }> | null, analysis?: { __typename: 'AnalysisResponse', status: AnalysisStatus, data?: { __typename: 'Analysis', summary: string, stems?: Array<{ __typename: 'Stems', amplitudeUrl: string, breakdown: Array<{ __typename: 'Stem', name: string, url: string, sheet: { __typename: 'SheetMusic', url: string, preview: string } }> }> | null, lyrics?: { __typename: 'Lyrics', url: string, preview: Array<{ __typename: 'Lyric', lyric: string, timestamp: string }> } | null, markers: Array<{ __typename: 'Marker', color: string, shine: boolean } | null>, attributes: Array<{ __typename: 'Attribute', key: string, value: string }>, sheetMusic?: { __typename: 'SheetMusic', url: string, preview: string } | null } | null } | null, registrant: { __typename: 'BasicUser', id: string, name: string } } | null, transaction: { __typename: 'TransactionMetadata', hash: string, url: string, chain: { __typename: 'Chain', id: number } }, wallet: { __typename: 'Wallet', address: string, type: string }, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, sender?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, receiver?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, price?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacr?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null, royaltyOwner?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null, licenseAction?: { __typename: 'LicenseAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, startsAt?: any | null, endsAt?: any | null, type?: LicenseType | null, referenceId?: string | null, contractAddress?: string | null, allowSellOrTransfer?: boolean | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null } | null, total?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyOwnerAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacrAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacr?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null, royaltyOwner?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null }> } };

export type ExchangeRateQueryVariables = Exact<{ [key: string]: never; }>;


export type ExchangeRateQuery = { __typename: 'Query', exchangeRate: string };

export type PlansQueryQueryVariables = Exact<{
  accessToken?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PlansQueryQuery = { __typename: 'Query', plans?: { __typename: 'PlanResponse', activeBillingCycleType?: string | null, defaultBillingCycleType: string, groupByBillingCycle: Array<{ __typename: 'BillingCycle', billingCycleType: string, billingCycleDescription?: string | null, billingCycleCallout?: string | null, plans: Array<{ __typename: 'Plan', id: string, name: string, headerText?: string | null, footerText?: string | null, benefits?: Array<string> | null, description?: string | null, priceCallout?: string | null, showExtraSpacing?: boolean | null, error?: string | null, includes: Array<{ __typename: 'PlanInclude', text: string, description?: string | null, separator?: boolean | null, link?: { __typename: 'PlanIncludeLink', text: string, url: string } | null }>, items: Array<{ __typename: 'PlanItem', status: PlanItemStatus, productId: string, nativeProductId?: string | null, nativePlanId?: string | null, maxUnits?: number | null, action: ActionType, prices: Array<{ __typename: 'PlanPriceItem', type?: PlanPriceType | null, details?: { __typename: 'PlanPriceDetail', billingCycleType?: string | null, amount?: number | null, suffix?: string | null, renderedPrice?: string | null, currency?: string | null } | null }>, upsell?: { __typename: 'UpsellDetails', text: string, ctaText: string, pillText: string, plan: { __typename: 'Plan', id: string, name: string, headerText?: string | null, footerText?: string | null, benefits?: Array<string> | null, description?: string | null, priceCallout?: string | null, showExtraSpacing?: boolean | null, error?: string | null, includes: Array<{ __typename: 'PlanInclude', text: string, description?: string | null, separator?: boolean | null, link?: { __typename: 'PlanIncludeLink', text: string, url: string } | null }> }, planItem: { __typename: 'PlanItem', status: PlanItemStatus, productId: string, nativeProductId?: string | null, nativePlanId?: string | null, maxUnits?: number | null, action: ActionType, prices: Array<{ __typename: 'PlanPriceItem', type?: PlanPriceType | null, details?: { __typename: 'PlanPriceDetail', billingCycleType?: string | null, amount?: number | null, suffix?: string | null, renderedPrice?: string | null, currency?: string | null } | null }> } } | null }> }> }> } | null };

export type MyPlanQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPlanQueryQuery = { __typename: 'Query', myPlan?: { __typename: 'PlanResponse', activeBillingCycleType?: string | null, defaultBillingCycleType: string, groupByBillingCycle: Array<{ __typename: 'BillingCycle', billingCycleType: string, billingCycleDescription?: string | null, billingCycleCallout?: string | null, plans: Array<{ __typename: 'Plan', id: string, name: string, headerText?: string | null, footerText?: string | null, benefits?: Array<string> | null, description?: string | null, priceCallout?: string | null, showExtraSpacing?: boolean | null, error?: string | null, includes: Array<{ __typename: 'PlanInclude', text: string, description?: string | null, separator?: boolean | null, link?: { __typename: 'PlanIncludeLink', text: string, url: string } | null }>, items: Array<{ __typename: 'PlanItem', status: PlanItemStatus, productId: string, nativeProductId?: string | null, nativePlanId?: string | null, maxUnits?: number | null, action: ActionType, prices: Array<{ __typename: 'PlanPriceItem', type?: PlanPriceType | null, details?: { __typename: 'PlanPriceDetail', billingCycleType?: string | null, amount?: number | null, suffix?: string | null, renderedPrice?: string | null, currency?: string | null } | null }>, upsell?: { __typename: 'UpsellDetails', text: string, ctaText: string, pillText: string, plan: { __typename: 'Plan', id: string, name: string, headerText?: string | null, footerText?: string | null, benefits?: Array<string> | null, description?: string | null, priceCallout?: string | null, showExtraSpacing?: boolean | null, error?: string | null, includes: Array<{ __typename: 'PlanInclude', text: string, description?: string | null, separator?: boolean | null, link?: { __typename: 'PlanIncludeLink', text: string, url: string } | null }> }, planItem: { __typename: 'PlanItem', status: PlanItemStatus, productId: string, nativeProductId?: string | null, nativePlanId?: string | null, maxUnits?: number | null, action: ActionType, prices: Array<{ __typename: 'PlanPriceItem', type?: PlanPriceType | null, details?: { __typename: 'PlanPriceDetail', billingCycleType?: string | null, amount?: number | null, suffix?: string | null, renderedPrice?: string | null, currency?: string | null } | null }> } } | null }> }> }> } | null };

export type BillingQueryQueryVariables = Exact<{
  nextInvoice?: InputMaybe<Scalars['Any']['input']>;
}>;


export type BillingQueryQuery = { __typename: 'Query', billing: { __typename: 'BillingResponse', plan: { __typename: 'BillingPlan', id: string, type: PlanType, name: string, description: string, status: PlanStatus, subscriptionCycle?: PlanCycle | null, platform: PlatformType, prices: Array<{ __typename: 'BillingPrice', type?: BillingPriceType | null, description: string, details: { __typename: 'BillingPriceDetail', amount?: number | null, suffix?: string | null, currency?: string | null } }>, dateInfo?: { __typename: 'BillingPlanDateInfo', date?: any | null, prefix: string } | null, details: { __typename: 'BillingPlanDetails', prices: Array<{ __typename: 'BillingPrice', type?: BillingPriceType | null, description: string, details: { __typename: 'BillingPriceDetail', suffix?: string | null, amount?: number | null, currency?: string | null } }>, upcomingBilling?: { __typename: 'UpcomingBiling', currency: string, date: any, total: number, tax?: number | null, breakdown: Array<{ __typename: 'UpcomingBillingBreakdown', outstanding: boolean }> } | null } }, billingAlert?: { __typename: 'BillingAlert', type: BillingAlertType, isActive: boolean, description?: string | null, date?: any | null } | null, paymentMethod?: { __typename: 'PaymentMethod', card?: { __typename: 'Card', type: string, last4: string } | null, requiresAction?: { __typename: 'PaymentRequiresAction', clientSecret: string } | null } | null, upcomingDetails: { __typename: 'BillingPlanDetails', callout?: string | null, prices: Array<{ __typename: 'BillingPrice', type?: BillingPriceType | null, description: string, details: { __typename: 'BillingPriceDetail', suffix?: string | null, amount?: number | null, currency?: string | null } }>, upcomingBilling?: { __typename: 'UpcomingBiling', title: string, description?: string | null, total: number, tax?: number | null, date: any, currency: string, breakdown: Array<{ __typename: 'UpcomingBillingBreakdown', amount?: number | null, quantity: number, outstanding: boolean, description: { __typename: 'UpcomingBillingBreakdownDescription', text: string, subtext?: string | null } }> } | null }, currentDetails?: { __typename: 'BillingPlanDetails', callout?: string | null, prices: Array<{ __typename: 'BillingPrice', type?: BillingPriceType | null, description: string, details: { __typename: 'BillingPriceDetail', suffix?: string | null, amount?: number | null, currency?: string | null } }>, upcomingBilling?: { __typename: 'UpcomingBiling', title: string, description?: string | null, total: number, tax?: number | null, date: any, currency: string, breakdown: Array<{ __typename: 'UpcomingBillingBreakdown', amount?: number | null, quantity: number, outstanding: boolean, description: { __typename: 'UpcomingBillingBreakdownDescription', text: string, subtext?: string | null } }> } | null } | null, invoices: { __typename: 'InvoicesResponse', next?: string | null, invoices: Array<{ __typename: 'Invoice', id: string, date: any, total: number, description: string, status: InvoiceStatus, currency: string }> }, upsell?: { __typename: 'UpsellDetails', text: string, ctaText: string, pillText: string, plan: { __typename: 'Plan', id: string, name: string, headerText?: string | null, footerText?: string | null, benefits?: Array<string> | null, description?: string | null, priceCallout?: string | null, showExtraSpacing?: boolean | null, error?: string | null, includes: Array<{ __typename: 'PlanInclude', text: string, description?: string | null, separator?: boolean | null, link?: { __typename: 'PlanIncludeLink', text: string, url: string } | null }>, items: Array<{ __typename: 'PlanItem', status: PlanItemStatus, productId: string, nativeProductId?: string | null, nativePlanId?: string | null, maxUnits?: number | null, action: ActionType, prices: Array<{ __typename: 'PlanPriceItem', type?: PlanPriceType | null, details?: { __typename: 'PlanPriceDetail', billingCycleType?: string | null, amount?: number | null, suffix?: string | null, renderedPrice?: string | null, currency?: string | null } | null }>, upsell?: { __typename: 'UpsellDetails', text: string, ctaText: string, pillText: string, plan: { __typename: 'Plan', id: string, name: string, headerText?: string | null, footerText?: string | null, benefits?: Array<string> | null, description?: string | null, priceCallout?: string | null, showExtraSpacing?: boolean | null, error?: string | null, includes: Array<{ __typename: 'PlanInclude', text: string, description?: string | null, separator?: boolean | null, link?: { __typename: 'PlanIncludeLink', text: string, url: string } | null }> }, planItem: { __typename: 'PlanItem', status: PlanItemStatus, productId: string, nativeProductId?: string | null, nativePlanId?: string | null, maxUnits?: number | null, action: ActionType, prices: Array<{ __typename: 'PlanPriceItem', type?: PlanPriceType | null, details?: { __typename: 'PlanPriceDetail', billingCycleType?: string | null, amount?: number | null, suffix?: string | null, renderedPrice?: string | null, currency?: string | null } | null }> } } | null }> }, planItem: { __typename: 'PlanItem', status: PlanItemStatus, productId: string, nativeProductId?: string | null, nativePlanId?: string | null, maxUnits?: number | null, action: ActionType, prices: Array<{ __typename: 'PlanPriceItem', type?: PlanPriceType | null, details?: { __typename: 'PlanPriceDetail', billingCycleType?: string | null, amount?: number | null, suffix?: string | null, renderedPrice?: string | null, currency?: string | null } | null }>, upsell?: { __typename: 'UpsellDetails', text: string, ctaText: string, pillText: string, plan: { __typename: 'Plan', id: string, name: string, headerText?: string | null, footerText?: string | null, benefits?: Array<string> | null, description?: string | null, priceCallout?: string | null, showExtraSpacing?: boolean | null, error?: string | null, includes: Array<{ __typename: 'PlanInclude', text: string, description?: string | null, separator?: boolean | null, link?: { __typename: 'PlanIncludeLink', text: string, url: string } | null }> }, planItem: { __typename: 'PlanItem', status: PlanItemStatus, productId: string, nativeProductId?: string | null, nativePlanId?: string | null, maxUnits?: number | null, action: ActionType, prices: Array<{ __typename: 'PlanPriceItem', type?: PlanPriceType | null, details?: { __typename: 'PlanPriceDetail', billingCycleType?: string | null, amount?: number | null, suffix?: string | null, renderedPrice?: string | null, currency?: string | null } | null }> } } | null } } | null } };

export type InvoicesQueryVariables = Exact<{
  nextInvoice?: InputMaybe<Scalars['Any']['input']>;
}>;


export type InvoicesQuery = { __typename: 'Query', invoices: { __typename: 'InvoicesResponse', next?: string | null, invoices: Array<{ __typename: 'Invoice', id: string, description: string, date: any, total: number, currency: string, status: InvoiceStatus }> } };

export type FilePrivacyControllersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
}>;


export type FilePrivacyControllersQuery = { __typename: 'Query', filePrivacyControllers: { __typename: 'FilePrivacyResponse', id: string, next?: Array<any | null> | null, items: Array<{ __typename: 'FilePrivacyItem', statuses: Array<FilePrivacyStatus>, isDownloadAvailable: boolean, entity: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } }> } };

export type FileOwnersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
}>;


export type FileOwnersQuery = { __typename: 'Query', fileOwners: { __typename: 'FileOwnersResponse', next?: Array<any | null> | null, items: Array<{ __typename: 'FileOwnersItem', statuses: Array<FileOwnerStatus>, entity: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } }> } };

export type FileAuthorsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
}>;


export type FileAuthorsQuery = { __typename: 'Query', fileAuthors: { __typename: 'FileAuthorsResponse', id: string, next?: Array<any | null> | null, items: Array<{ __typename: 'FileAuthorsItem', statuses: Array<FileAuthorStatus>, entity: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } }> } };

export type LicensedToOthersQueryVariables = Exact<{
  copyrightId?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<SearchLicenseSort>;
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
}>;


export type LicensedToOthersQuery = { __typename: 'Query', licensedToOthers: { __typename: 'LicensesResponse', next?: Array<any | null> | null, items: Array<{ __typename: 'Item', id: string, name: string, parentFolderId: string, parentPath: string, timestamp?: any | null, numberOfItems?: number | null, type: ItemType, file?: { __typename: 'File', id: string, status: FileStatus, billingExpirationDate?: any | null, copyrightId?: string | null, copyrightType?: CopyrightType | null, description?: string | null, fileName: string, imageUrl?: string | null, isDownloadAvailable: boolean, isPrivate: boolean, ownerAddress?: string | null, ownershipRoles: Array<FileOwnerRole>, size: string, timestamp?: any | null, type: FileType, friendlyType: string, vanityName: string, tokenId?: string | null, contractAddress?: string | null, transferStatus?: TransferStatus | null, saleStatus?: SaleStatus | null, licenseStatus?: LicenseStatus | null, certificateUrl?: string | null, ownersCount?: number | null, privacyControllersCount?: number | null, authorsCount?: number | null, authorRoles: Array<FileAuthorRole>, permissions: Array<FilePermission>, isLifetime: boolean, privacyRoles: Array<FilePrivacyRole>, preview?: { __typename: 'AssetPreview', type: AssetPreviewType, url: string, numberOfPages?: number | null } | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, registrations: Array<{ __typename: 'Registration', id: string, name: string, timestamp?: any | null, certificateUrl?: string | null, icon?: string | null }>, license?: { __typename: 'License', id: string, issuedAt: any, tokenId: string, contractAddress: string, timestamp?: any | null, expiresAt?: any | null, canSellOrTransfer: boolean, type?: LicenseType | null, price?: { __typename: 'Price', value: string } | null, agreement?: { __typename: 'LicenseAgreement', isPublic?: boolean | null, type: LicenseAgreementType, content: string } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', isPublic?: boolean | null, type: LicenseAgreementType, content: string } | null } | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, originalCopyright?: { __typename: 'OriginalCopyright', copyrightId: string, timestamp: any, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | null, royaltyOwner?: { __typename: 'RoyaltyOwner', address?: string | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, royalty?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, transactions: Array<{ __typename: 'Transaction', status: TransactionStatus, timestamp: any, hash: string, url: string, from?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, to: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, price?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null }>, owners: Array<{ __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }>, authors: Array<{ __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }>, notifications?: Array<{ __typename: 'Notification', id: string, type: NotificationType, timestamp: any, read: boolean, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' }, primaryIcon: { __typename: 'NotificationIcon', imageUrl?: string | null, syncIcon?: boolean | null, alertIcon?: boolean | null, dacrIcon?: boolean | null }, secondaryIcon?: { __typename: 'NotificationIcon', imageUrl?: string | null, syncIcon?: boolean | null, alertIcon?: boolean | null, dacrIcon?: boolean | null } | null, metadata?: { __typename: 'AccountPaymentMetadata', payment: { __typename: 'Payment', id: string, failedMessage?: string | null, status: PaymentStatus } } | { __typename: 'FileMetadata', file: { __typename: 'File', vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } } | { __typename: 'InfringementMatchMetadata', id: string, level: ScoreLevel, infringingFile: { __typename: 'File', id: string, vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, imageUrl?: string | null }, registeredFile: { __typename: 'File', id: string, vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, imageUrl?: string | null } } | { __typename: 'InviteMetadata', invite: { __typename: 'Invite', id: string, status: InviteStatus, type: InviteType, role?: { __typename: 'InviteFileAuthorRole' } | { __typename: 'InviteFileOwnerRole', value?: FileOwnerRole | null } | { __typename: 'InviteFilePrivacyRole' } | { __typename: 'InviteReportReviewRole' } | { __typename: 'InviteTeamMemberRole', role?: TeamMemberRole | null } | null, from: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, to: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, reference: { __typename: 'Dacr', id: string, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'License', id: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'Origin', id: string, name: string, avatarUrl: string } } } | { __typename: 'InvoiceMetadata' } | { __typename: 'ReportMetadata', id: string, registeredFile: { __typename: 'File', id: string, fileName: string, type: FileType } } | { __typename: 'ReportReviewMetadata' } | { __typename: 'TokenMetadata', from?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, to?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, transferAction?: { __typename: 'TransferAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, contractAddress?: string | null } | null, saleAction?: { __typename: 'SaleAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, contractAddress?: string | null, total?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyOwnerAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacrAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacr?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null, royaltyOwner?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, licenseAction?: { __typename: 'LicenseAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, startsAt?: any | null, endsAt?: any | null, type?: LicenseType | null, referenceId?: string | null, contractAddress?: string | null, allowSellOrTransfer?: boolean | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null } | null, total?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyOwnerAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacrAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacr?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null, royaltyOwner?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, copyright?: { __typename: 'Dacr', id: string, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, contractAddress?: string | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'License', id: string, issuedAt: any, contractAddress: string, expiresAt?: any | null, canSellOrTransfer: boolean, type?: LicenseType | null, licenser?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, contractAddress?: string | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', content: string, type: LicenseAgreementType, isPublic?: boolean | null } | null } | null } | null } | { __typename: 'TransferToNoAccountMetadata', address: string, file: { __typename: 'File', vanityName: string, fileName: string, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } } | { __typename: 'UploadFileMetadata', filename: string } | { __typename: 'UserMetadata', entity: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null }> | null, analysis?: { __typename: 'AnalysisResponse', status: AnalysisStatus, data?: { __typename: 'Analysis', summary: string, stems?: Array<{ __typename: 'Stems', amplitudeUrl: string, breakdown: Array<{ __typename: 'Stem', name: string, url: string, sheet: { __typename: 'SheetMusic', url: string, preview: string } }> }> | null, lyrics?: { __typename: 'Lyrics', url: string, preview: Array<{ __typename: 'Lyric', lyric: string, timestamp: string }> } | null, markers: Array<{ __typename: 'Marker', color: string, shine: boolean } | null>, attributes: Array<{ __typename: 'Attribute', key: string, value: string }>, sheetMusic?: { __typename: 'SheetMusic', url: string, preview: string } | null } | null } | null, registrant: { __typename: 'BasicUser', id: string, name: string } } | null }> } };

export type LicensedToMeQueryVariables = Exact<{
  sortBy?: InputMaybe<SearchLicenseSort>;
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
}>;


export type LicensedToMeQuery = { __typename: 'Query', licensedToMe: { __typename: 'LicensesResponse', next?: Array<any | null> | null, items: Array<{ __typename: 'Item', id: string, name: string, parentFolderId: string, parentPath: string, timestamp?: any | null, numberOfItems?: number | null, type: ItemType, file?: { __typename: 'File', id: string, status: FileStatus, billingExpirationDate?: any | null, copyrightId?: string | null, copyrightType?: CopyrightType | null, description?: string | null, fileName: string, imageUrl?: string | null, isDownloadAvailable: boolean, isPrivate: boolean, ownerAddress?: string | null, ownershipRoles: Array<FileOwnerRole>, size: string, timestamp?: any | null, type: FileType, friendlyType: string, vanityName: string, tokenId?: string | null, contractAddress?: string | null, transferStatus?: TransferStatus | null, saleStatus?: SaleStatus | null, licenseStatus?: LicenseStatus | null, certificateUrl?: string | null, ownersCount?: number | null, privacyControllersCount?: number | null, authorsCount?: number | null, authorRoles: Array<FileAuthorRole>, permissions: Array<FilePermission>, isLifetime: boolean, privacyRoles: Array<FilePrivacyRole>, preview?: { __typename: 'AssetPreview', type: AssetPreviewType, url: string, numberOfPages?: number | null } | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, registrations: Array<{ __typename: 'Registration', id: string, name: string, timestamp?: any | null, certificateUrl?: string | null, icon?: string | null }>, license?: { __typename: 'License', id: string, issuedAt: any, tokenId: string, contractAddress: string, timestamp?: any | null, expiresAt?: any | null, canSellOrTransfer: boolean, type?: LicenseType | null, price?: { __typename: 'Price', value: string } | null, agreement?: { __typename: 'LicenseAgreement', isPublic?: boolean | null, type: LicenseAgreementType, content: string } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', isPublic?: boolean | null, type: LicenseAgreementType, content: string } | null } | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, originalCopyright?: { __typename: 'OriginalCopyright', copyrightId: string, timestamp: any, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | null, royaltyOwner?: { __typename: 'RoyaltyOwner', address?: string | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, royalty?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, transactions: Array<{ __typename: 'Transaction', status: TransactionStatus, timestamp: any, hash: string, url: string, from?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, to: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, price?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null }>, owners: Array<{ __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }>, authors: Array<{ __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Email', email: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }>, notifications?: Array<{ __typename: 'Notification', id: string, type: NotificationType, timestamp: any, read: boolean, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' }, primaryIcon: { __typename: 'NotificationIcon', imageUrl?: string | null, syncIcon?: boolean | null, alertIcon?: boolean | null, dacrIcon?: boolean | null }, secondaryIcon?: { __typename: 'NotificationIcon', imageUrl?: string | null, syncIcon?: boolean | null, alertIcon?: boolean | null, dacrIcon?: boolean | null } | null, metadata?: { __typename: 'AccountPaymentMetadata', payment: { __typename: 'Payment', id: string, failedMessage?: string | null, status: PaymentStatus } } | { __typename: 'FileMetadata', file: { __typename: 'File', vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } } | { __typename: 'InfringementMatchMetadata', id: string, level: ScoreLevel, infringingFile: { __typename: 'File', id: string, vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, imageUrl?: string | null }, registeredFile: { __typename: 'File', id: string, vanityName: string, fileName: string, copyrightId?: string | null, type: FileType, imageUrl?: string | null } } | { __typename: 'InviteMetadata', invite: { __typename: 'Invite', id: string, status: InviteStatus, type: InviteType, role?: { __typename: 'InviteFileAuthorRole' } | { __typename: 'InviteFileOwnerRole', value?: FileOwnerRole | null } | { __typename: 'InviteFilePrivacyRole' } | { __typename: 'InviteReportReviewRole' } | { __typename: 'InviteTeamMemberRole', role?: TeamMemberRole | null } | null, from: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, to: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null }, reference: { __typename: 'Dacr', id: string, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'License', id: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'Origin', id: string, name: string, avatarUrl: string } } } | { __typename: 'InvoiceMetadata' } | { __typename: 'ReportMetadata', id: string, registeredFile: { __typename: 'File', id: string, fileName: string, type: FileType } } | { __typename: 'ReportReviewMetadata' } | { __typename: 'TokenMetadata', from?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, to?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, transferAction?: { __typename: 'TransferAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, contractAddress?: string | null } | null, saleAction?: { __typename: 'SaleAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, contractAddress?: string | null, total?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyOwnerAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacrAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacr?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null, royaltyOwner?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, licenseAction?: { __typename: 'LicenseAction', status: ActionStatus, fromAddress: string, toAddress: string, tokenId: string, startsAt?: any | null, endsAt?: any | null, type?: LicenseType | null, referenceId?: string | null, contractAddress?: string | null, allowSellOrTransfer?: boolean | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null } | null, total?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyOwnerAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacrAmount?: { __typename: 'Price', value: string, currency: string, decimalDigits?: number | null } | null, royaltyDacr?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null, royaltyOwner?: { __typename: 'Royalty', feeNumerator: number, feeDenominator: number } | null } | null, copyright?: { __typename: 'Dacr', id: string, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, contractAddress?: string | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null } | { __typename: 'License', id: string, issuedAt: any, contractAddress: string, expiresAt?: any | null, canSellOrTransfer: boolean, type?: LicenseType | null, licenser?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } | null, file?: { __typename: 'File', fileName: string, imageUrl?: string | null, type: FileType, contractAddress?: string | null, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null, agreement?: { __typename: 'LicenseAgreement', type: LicenseAgreementType, content: string, isPublic?: boolean | null } | null, licenseToOthers?: { __typename: 'LicenseToOthers', currentSaleQuantity?: number | null, saleQuantity: number, startsAt: any, endsAt?: any | null, agreement?: { __typename: 'LicenseAgreement', content: string, type: LicenseAgreementType, isPublic?: boolean | null } | null } | null } | null } | { __typename: 'TransferToNoAccountMetadata', address: string, file: { __typename: 'File', vanityName: string, fileName: string, type: FileType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } } | { __typename: 'UploadFileMetadata', filename: string } | { __typename: 'UserMetadata', entity: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization', id: string, name: string, avatarUrl: string, owner?: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } | null } } | null }> | null, analysis?: { __typename: 'AnalysisResponse', status: AnalysisStatus, data?: { __typename: 'Analysis', summary: string, stems?: Array<{ __typename: 'Stems', amplitudeUrl: string, breakdown: Array<{ __typename: 'Stem', name: string, url: string, sheet: { __typename: 'SheetMusic', url: string, preview: string } }> }> | null, lyrics?: { __typename: 'Lyrics', url: string, preview: Array<{ __typename: 'Lyric', lyric: string, timestamp: string }> } | null, markers: Array<{ __typename: 'Marker', color: string, shine: boolean } | null>, attributes: Array<{ __typename: 'Attribute', key: string, value: string }>, sheetMusic?: { __typename: 'SheetMusic', url: string, preview: string } | null } | null } | null, registrant: { __typename: 'BasicUser', id: string, name: string } } | null }> } };

export type CopyrightOwnersQueryVariables = Exact<{
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
}>;


export type CopyrightOwnersQuery = { __typename: 'Query', copyrightOwners: { __typename: 'CopyrightOwnersResponse', total: number, next?: Array<any | null> | null, items: Array<{ __typename: 'CopyrightOwner', id: string, name: string, avatarUrl: string, isSelected: boolean, type: CopyrightOwnerType }> } };

export type CopyrightOwnersNewQueryVariables = Exact<{
  next?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
}>;


export type CopyrightOwnersNewQuery = { __typename: 'Query', copyrightOwnersNew: { __typename: 'CopyrightOwnersResponseNew', total: number, next?: Array<any | null> | null, items: Array<{ __typename: 'CopyrightOwnerNew', id: string, name: string, avatarUrl: string, isSelected: boolean, type: CopyrightOwnerType, owner: { __typename: 'BasicUser', id: string, name: string, avatarUrl: string, username: string } | { __typename: 'Organization' } }> } };

export type OnboardingQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingQuery = { __typename: 'Query', onboarding: { __typename: 'Onboarding', step?: number | null, completed: boolean } };

export type ReportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReportQuery = { __typename: 'Query', report: { __typename: 'ReportResponse', status: ReportStatus, data?: { __typename: 'Report', id: string, summary: string, createdAt: any, matchScore: number, matchQuantity: number, attributes?: Array<{ __typename: 'Attribute', key: string, value: string }> | null, originalFile: { __typename: 'BasicFile', id: string, name: string, type: FileType, width?: number | null, height?: number | null, previewImageUrl?: string | null }, infringingFile: { __typename: 'BasicFile', id: string, name: string, type: FileType, width?: number | null, height?: number | null, previewImageUrl?: string | null }, matches: Array<{ __typename: 'MatchPair', original: { __typename: 'Match', id: string, matchScore?: number | null, matchType: MatchType, coords: Array<string>, location: string, imageUrl: string, description?: string | null, file: { __typename: 'BasicFile', id: string, name: string, type: FileType, width?: number | null, height?: number | null, previewImageUrl?: string | null } }, infringing: { __typename: 'Match', id: string, matchScore?: number | null, matchType: MatchType, coords: Array<string>, location: string, imageUrl: string, description?: string | null, file: { __typename: 'BasicFile', id: string, name: string, type: FileType, width?: number | null, height?: number | null, previewImageUrl?: string | null } } }> } | null } };

export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  id
  permissions
  avatarUrl
  bio
  dateFormat
  email
  firstName
  language
  lastName
  name
  timezone {
    country
    name
  }
  title
  username
  wallet {
    address
    type
    anyTokensToTransfer
    anyTokensToSync
    transferringTokens
    syncingTokens
  }
  upcomingBilling {
    date
    currency
    total
    tax
    currency
    registrationTotal
    outstandingTotal
  }
  totalFiles
  pendingSales
  pendingTransfers
  pendingLicenses
  totalFilesLimit
  hasUploadedFileAsAPro
  canChangePlan
  canUpgradePlan
  showUpdatedTerms
  totalCopyrightOwners
  totalCopyrightOwnersLimit
  defaultFilePrivacy
  guidanceStates {
    states {
      id
      state {
        state
      }
    }
  }
  hasUploadedFile
  reportCredits
  isCreatingReport
  origin
  verificationStatus
  membership {
    id
    since
    expiresAt
  }
}
    `;
export const BasicUserFieldsFragmentDoc = gql`
    fragment BasicUserFields on BasicUser {
  __typename
  id
  name
  avatarUrl
  username
}
    `;
export const OrganizationFieldsFragmentDoc = gql`
    fragment OrganizationFields on Organization {
  __typename
  id
  name
  avatarUrl
  owner {
    ...BasicUserFields
  }
}
    ${BasicUserFieldsFragmentDoc}`;
export const EmailFieldsFragmentDoc = gql`
    fragment EmailFields on Email {
  __typename
  email
}
    `;
export const NotificationFieldsFragmentDoc = gql`
    fragment NotificationFields on Notification {
  id
  type
  timestamp
  read
  owner {
    ...BasicUserFields
  }
  primaryIcon {
    imageUrl
    syncIcon
    alertIcon
    dacrIcon
  }
  secondaryIcon {
    imageUrl
    syncIcon
    alertIcon
    dacrIcon
  }
  metadata {
    ... on UserMetadata {
      entity {
        ...BasicUserFields
        ...OrganizationFields
      }
    }
    ... on AccountPaymentMetadata {
      payment {
        id
        failedMessage
        status
      }
    }
    ... on TokenMetadata {
      from {
        ...BasicUserFields
        ...OrganizationFields
      }
      to {
        ...BasicUserFields
        ...OrganizationFields
      }
      transferAction {
        status
        fromAddress
        toAddress
        tokenId
        contractAddress
      }
      saleAction {
        status
        fromAddress
        toAddress
        tokenId
        contractAddress
        total {
          value
          currency
          decimalDigits
        }
        royaltyOwnerAmount {
          value
          currency
          decimalDigits
        }
        royaltyDacrAmount {
          value
          currency
          decimalDigits
        }
        royaltyDacr {
          feeNumerator
          feeDenominator
        }
        royaltyOwner {
          feeNumerator
          feeDenominator
        }
      }
      licenseAction {
        status
        fromAddress
        toAddress
        tokenId
        startsAt
        endsAt
        type
        referenceId
        contractAddress
        allowSellOrTransfer
        agreement {
          type
          content
          isPublic
        }
        licenseToOthers {
          agreement {
            type
            content
            isPublic
          }
          currentSaleQuantity
          saleQuantity
          startsAt
          endsAt
        }
        total {
          value
          currency
          decimalDigits
        }
        royaltyOwnerAmount {
          value
          currency
          decimalDigits
        }
        royaltyDacrAmount {
          value
          currency
          decimalDigits
        }
        royaltyDacr {
          feeNumerator
          feeDenominator
        }
        royaltyOwner {
          feeNumerator
          feeDenominator
        }
      }
      copyright {
        ... on Dacr {
          id
          file {
            fileName
            imageUrl
            type
            contractAddress
            owner {
              ...BasicUserFields
              ...OrganizationFields
            }
          }
        }
        ... on License {
          id
          licenser {
            ...BasicUserFields
            ...OrganizationFields
          }
          owner {
            ...BasicUserFields
            ...OrganizationFields
          }
          file {
            fileName
            imageUrl
            type
            contractAddress
            owner {
              ...BasicUserFields
              ...OrganizationFields
            }
          }
          issuedAt
          contractAddress
          expiresAt
          agreement {
            type
            content
            isPublic
          }
          licenseToOthers {
            agreement {
              content
              type
              isPublic
            }
            currentSaleQuantity
            saleQuantity
            startsAt
            endsAt
          }
          canSellOrTransfer
          type
        }
      }
    }
    ... on FileMetadata {
      file {
        vanityName
        fileName
        copyrightId
        type
        owner {
          ...BasicUserFields
          ...OrganizationFields
        }
      }
    }
    ... on UploadFileMetadata {
      filename
    }
    ... on ReportMetadata {
      id
      registeredFile {
        id
        fileName
        type
      }
    }
    ... on InfringementMatchMetadata {
      id
      level
      infringingFile {
        id
        vanityName
        fileName
        copyrightId
        type
        imageUrl
      }
      registeredFile {
        id
        vanityName
        fileName
        copyrightId
        type
        imageUrl
      }
    }
    ... on TransferToNoAccountMetadata {
      file {
        vanityName
        fileName
        type
        owner {
          ...BasicUserFields
          ...OrganizationFields
        }
      }
      address
    }
    ... on InviteMetadata {
      invite {
        id
        status
        type
        role {
          ... on InviteFileOwnerRole {
            __typename
            value
          }
          ... on InviteFilePrivacyRole {
            __typename
          }
          ... on InviteTeamMemberRole {
            __typename
            role: value
          }
        }
        from {
          ...BasicUserFields
          ...OrganizationFields
        }
        to {
          ...BasicUserFields
          ...OrganizationFields
        }
        reference {
          ... on Origin {
            id
            name
            avatarUrl
          }
          ... on Dacr {
            id
            file {
              fileName
              imageUrl
              type
              owner {
                ...BasicUserFields
                ...OrganizationFields
              }
            }
          }
          ... on License {
            id
            owner {
              ...BasicUserFields
              ...OrganizationFields
            }
            file {
              fileName
              imageUrl
              type
              owner {
                ...BasicUserFields
                ...OrganizationFields
              }
            }
          }
        }
      }
    }
  }
}
    ${BasicUserFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}`;
export const FileFieldsFragmentDoc = gql`
    fragment FileFields on File {
  id
  status
  billingExpirationDate
  copyrightId
  copyrightType
  description
  fileName
  imageUrl
  preview {
    type
    url
    numberOfPages
  }
  isDownloadAvailable
  isPrivate
  ownerAddress
  ownershipRoles
  owner {
    ...BasicUserFields
    ...OrganizationFields
  }
  registrations {
    id
    name
    timestamp
    certificateUrl
    icon
  }
  license {
    id
    issuedAt
    tokenId
    contractAddress
    timestamp
    price {
      value
    }
    expiresAt
    agreement {
      isPublic
      type
      content
    }
    licenseToOthers {
      agreement {
        isPublic
        content
        type
      }
      currentSaleQuantity
      saleQuantity
      startsAt
      endsAt
    }
    owner {
      ...BasicUserFields
      ...OrganizationFields
    }
    canSellOrTransfer
    type
  }
  size
  timestamp
  type
  friendlyType
  vanityName
  tokenId
  contractAddress
  transferStatus
  saleStatus
  licenseStatus
  royaltyOwner {
    address
    owner {
      ...BasicUserFields
      ...OrganizationFields
    }
    royalty {
      feeNumerator
      feeDenominator
    }
  }
  transactions {
    from {
      ...BasicUserFields
      ...OrganizationFields
    }
    to {
      ...BasicUserFields
      ...OrganizationFields
    }
    status
    timestamp
    hash
    price {
      value
      currency
      decimalDigits
    }
    url
  }
  license {
    id
    issuedAt
    tokenId
    contractAddress
    price {
      value
    }
    expiresAt
    agreement {
      type
      isPublic
      content
    }
    licenseToOthers {
      agreement {
        content
        isPublic
        type
      }
      currentSaleQuantity
      saleQuantity
      startsAt
      endsAt
    }
    canSellOrTransfer
    type
    originalCopyright {
      copyrightId
      owner {
        ...BasicUserFields
        ...OrganizationFields
      }
      timestamp
    }
  }
  certificateUrl
  ownersCount
  privacyControllersCount
  authorsCount
  authorRoles
  owners {
    ...BasicUserFields
    ...OrganizationFields
    ...EmailFields
  }
  authors {
    ...BasicUserFields
    ...OrganizationFields
    ...EmailFields
  }
  permissions
  isLifetime
  privacyRoles
  notifications {
    ...NotificationFields
  }
  analysis {
    status
    data {
      stems {
        breakdown {
          name
          url
          sheet {
            url
            preview
          }
        }
        amplitudeUrl
      }
      lyrics {
        preview {
          lyric
          timestamp
        }
        url
      }
      markers {
        color
        shine
      }
      attributes {
        key
        value
      }
      sheetMusic {
        url
        preview
      }
      summary
    }
  }
  registrant {
    id
    name
  }
}
    ${BasicUserFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}
${EmailFieldsFragmentDoc}
${NotificationFieldsFragmentDoc}`;
export const PlanItemFieldsFragmentDoc = gql`
    fragment PlanItemFields on PlanItem {
  status
  productId
  nativeProductId
  nativePlanId
  maxUnits
  action
  prices {
    type
    details {
      billingCycleType
      amount
      suffix
      renderedPrice
      currency
    }
  }
  upsell {
    plan {
      id
      name
      headerText
      footerText
      benefits
      includes {
        text
        description
        separator
        link {
          text
          url
        }
      }
      description
      priceCallout
      showExtraSpacing
      error
    }
    planItem {
      status
      productId
      nativeProductId
      nativePlanId
      maxUnits
      action
      prices {
        type
        details {
          billingCycleType
          amount
          suffix
          renderedPrice
          currency
        }
      }
    }
    text
    ctaText
    pillText
  }
}
    `;
export const PlanFieldsFragmentDoc = gql`
    fragment PlanFields on Plan {
  id
  name
  headerText
  footerText
  benefits
  includes {
    text
    description
    separator
    link {
      text
      url
    }
  }
  description
  priceCallout
  showExtraSpacing
  items {
    ...PlanItemFields
  }
  error
}
    ${PlanItemFieldsFragmentDoc}`;
export const BillingFieldsFragmentDoc = gql`
    fragment BillingFields on BillingResponse {
  plan {
    id
    type
    name
    description
    status
    prices {
      type
      description
      details {
        amount
        suffix
        currency
      }
    }
    dateInfo {
      date
      prefix
    }
    details {
      prices {
        type
        description
        details {
          suffix
          amount
          currency
        }
      }
      upcomingBilling {
        currency
        date
        total
        tax
        currency
        breakdown {
          outstanding
        }
      }
    }
    subscriptionCycle
    platform
  }
  billingAlert {
    type
    isActive
    description
    date
  }
  paymentMethod {
    card {
      type
      last4
    }
    requiresAction {
      clientSecret
    }
  }
  upcomingDetails {
    callout
    prices {
      type
      description
      details {
        suffix
        amount
        currency
      }
    }
    upcomingBilling {
      title
      description
      total
      tax
      date
      currency
      breakdown {
        amount
        quantity
        outstanding
        description {
          text
          subtext
        }
      }
    }
  }
  currentDetails {
    callout
    prices {
      type
      description
      details {
        suffix
        amount
        currency
      }
    }
    upcomingBilling {
      title
      description
      total
      tax
      date
      currency
      breakdown {
        amount
        quantity
        outstanding
        description {
          text
          subtext
        }
      }
    }
  }
  invoices {
    invoices {
      id
      date
      total
      description
      status
      currency
    }
    next
  }
  upsell {
    plan {
      ...PlanFields
    }
    planItem {
      ...PlanItemFields
    }
    text
    ctaText
    pillText
  }
}
    ${PlanFieldsFragmentDoc}
${PlanItemFieldsFragmentDoc}`;
export const SignInDocument = gql`
    mutation SignIn($email: String!, $password: String!) {
  signin(email: $email, password: $password) {
    accessToken
    refreshToken
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSignInMutation({
 *   variables: {
 *     email: // value for 'email'
 *     password: // value for 'password'
 *   },
 * });
 */
export function useSignInMutation(options: VueApolloComposable.UseMutationOptions<SignInMutation, SignInMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SignInMutation, SignInMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
}
export type SignInMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SignInMutation, SignInMutationVariables>;
export const SignUpDocument = gql`
    mutation SignUp($input: SignupInput!) {
  signup(input: $input) {
    accessToken
    refreshToken
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSignUpMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSignUpMutation(options: VueApolloComposable.UseMutationOptions<SignUpMutation, SignUpMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SignUpMutation, SignUpMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
}
export type SignUpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SignUpMutation, SignUpMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($email: String!) {
  forgotPassword(email: $email)
}
    `;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useForgotPasswordMutation({
 *   variables: {
 *     email: // value for 'email'
 *   },
 * });
 */
export function useForgotPasswordMutation(options: VueApolloComposable.UseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
}
export type ForgotPasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ValidateResetPasswordTokenDocument = gql`
    mutation ValidateResetPasswordToken($token: String!) {
  validateResetPasswordToken(token: $token)
}
    `;

/**
 * __useValidateResetPasswordTokenMutation__
 *
 * To run a mutation, you first call `useValidateResetPasswordTokenMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useValidateResetPasswordTokenMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useValidateResetPasswordTokenMutation({
 *   variables: {
 *     token: // value for 'token'
 *   },
 * });
 */
export function useValidateResetPasswordTokenMutation(options: VueApolloComposable.UseMutationOptions<ValidateResetPasswordTokenMutation, ValidateResetPasswordTokenMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ValidateResetPasswordTokenMutation, ValidateResetPasswordTokenMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ValidateResetPasswordTokenMutation, ValidateResetPasswordTokenMutationVariables>(ValidateResetPasswordTokenDocument, options);
}
export type ValidateResetPasswordTokenMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ValidateResetPasswordTokenMutation, ValidateResetPasswordTokenMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($newPassword: String!, $token: String!) {
  resetPassword(newPassword: $newPassword, token: $token)
}
    `;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResetPasswordMutation({
 *   variables: {
 *     newPassword: // value for 'newPassword'
 *     token: // value for 'token'
 *   },
 * });
 */
export function useResetPasswordMutation(options: VueApolloComposable.UseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
}
export type ResetPasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const RefreshTokensDocument = gql`
    mutation RefreshTokens($refreshToken: String!) {
  refreshAccessToken(refreshToken: $refreshToken) {
    accessToken
    refreshToken
  }
}
    `;

/**
 * __useRefreshTokensMutation__
 *
 * To run a mutation, you first call `useRefreshTokensMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokensMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRefreshTokensMutation({
 *   variables: {
 *     refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshTokensMutation(options: VueApolloComposable.UseMutationOptions<RefreshTokensMutation, RefreshTokensMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RefreshTokensMutation, RefreshTokensMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RefreshTokensMutation, RefreshTokensMutationVariables>(RefreshTokensDocument, options);
}
export type RefreshTokensMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RefreshTokensMutation, RefreshTokensMutationVariables>;
export const CreateUploadUrlDocument = gql`
    mutation CreateUploadUrl($fileName: String!, $parentFolderId: String!, $title: String, $description: String) {
  createUploadUrl(
    fileName: $fileName
    parentFolderId: $parentFolderId
    title: $title
    description: $description
  ) {
    headers {
      bucket
      key
      Policy
      X_Amz_Algorithm
      X_Amz_Credential
      X_Amz_Date
      x_amz_meta_userid
      X_Amz_Security_Token
      X_Amz_Signature
      Content_Type
    }
    url
    title
    description
  }
}
    `;

/**
 * __useCreateUploadUrlMutation__
 *
 * To run a mutation, you first call `useCreateUploadUrlMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateUploadUrlMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateUploadUrlMutation({
 *   variables: {
 *     fileName: // value for 'fileName'
 *     parentFolderId: // value for 'parentFolderId'
 *     title: // value for 'title'
 *     description: // value for 'description'
 *   },
 * });
 */
export function useCreateUploadUrlMutation(options: VueApolloComposable.UseMutationOptions<CreateUploadUrlMutation, CreateUploadUrlMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateUploadUrlMutation, CreateUploadUrlMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateUploadUrlMutation, CreateUploadUrlMutationVariables>(CreateUploadUrlDocument, options);
}
export type CreateUploadUrlMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateUploadUrlMutation, CreateUploadUrlMutationVariables>;
export const CreateAvatarUploadUrlDocument = gql`
    mutation CreateAvatarUploadUrl($fileName: String!) {
  createAvatarUploadUrl(fileName: $fileName) {
    headers {
      bucket
      Content_Type
      key
      Policy
      X_Amz_Algorithm
      X_Amz_Credential
      X_Amz_Date
      x_amz_meta_userid
      X_Amz_Security_Token
      X_Amz_Signature
    }
    url
  }
}
    `;

/**
 * __useCreateAvatarUploadUrlMutation__
 *
 * To run a mutation, you first call `useCreateAvatarUploadUrlMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAvatarUploadUrlMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAvatarUploadUrlMutation({
 *   variables: {
 *     fileName: // value for 'fileName'
 *   },
 * });
 */
export function useCreateAvatarUploadUrlMutation(options: VueApolloComposable.UseMutationOptions<CreateAvatarUploadUrlMutation, CreateAvatarUploadUrlMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateAvatarUploadUrlMutation, CreateAvatarUploadUrlMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateAvatarUploadUrlMutation, CreateAvatarUploadUrlMutationVariables>(CreateAvatarUploadUrlDocument, options);
}
export type CreateAvatarUploadUrlMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateAvatarUploadUrlMutation, CreateAvatarUploadUrlMutationVariables>;
export const CreateAgreementUploadUrlDocument = gql`
    mutation CreateAgreementUploadUrl($fileName: String!, $copyrightId: ID!) {
  createAgreementUploadUrl(fileName: $fileName, copyrightId: $copyrightId) {
    uploadPresignedData {
      headers {
        bucket
        Content_Type
        key
        Policy
        X_Amz_Algorithm
        X_Amz_Credential
        X_Amz_Date
        x_amz_meta_userid
        X_Amz_Security_Token
        X_Amz_Signature
      }
      url
    }
    content
    previewUrl
  }
}
    `;

/**
 * __useCreateAgreementUploadUrlMutation__
 *
 * To run a mutation, you first call `useCreateAgreementUploadUrlMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgreementUploadUrlMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAgreementUploadUrlMutation({
 *   variables: {
 *     fileName: // value for 'fileName'
 *     copyrightId: // value for 'copyrightId'
 *   },
 * });
 */
export function useCreateAgreementUploadUrlMutation(options: VueApolloComposable.UseMutationOptions<CreateAgreementUploadUrlMutation, CreateAgreementUploadUrlMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateAgreementUploadUrlMutation, CreateAgreementUploadUrlMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateAgreementUploadUrlMutation, CreateAgreementUploadUrlMutationVariables>(CreateAgreementUploadUrlDocument, options);
}
export type CreateAgreementUploadUrlMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateAgreementUploadUrlMutation, CreateAgreementUploadUrlMutationVariables>;
export const AddFolderDocument = gql`
    mutation AddFolder($folderName: String!, $parentId: String!) {
  createFolder(folderName: $folderName, parentId: $parentId) {
    id
    name
    timestamp
  }
}
    `;

/**
 * __useAddFolderMutation__
 *
 * To run a mutation, you first call `useAddFolderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddFolderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddFolderMutation({
 *   variables: {
 *     folderName: // value for 'folderName'
 *     parentId: // value for 'parentId'
 *   },
 * });
 */
export function useAddFolderMutation(options: VueApolloComposable.UseMutationOptions<AddFolderMutation, AddFolderMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddFolderMutation, AddFolderMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddFolderMutation, AddFolderMutationVariables>(AddFolderDocument, options);
}
export type AddFolderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddFolderMutation, AddFolderMutationVariables>;
export const RenameFolderDocument = gql`
    mutation RenameFolder($id: ID!, $newFolderName: String!) {
  renameFolder(id: $id, newFolderName: $newFolderName) {
    id
    name
  }
}
    `;

/**
 * __useRenameFolderMutation__
 *
 * To run a mutation, you first call `useRenameFolderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRenameFolderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRenameFolderMutation({
 *   variables: {
 *     id: // value for 'id'
 *     newFolderName: // value for 'newFolderName'
 *   },
 * });
 */
export function useRenameFolderMutation(options: VueApolloComposable.UseMutationOptions<RenameFolderMutation, RenameFolderMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RenameFolderMutation, RenameFolderMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RenameFolderMutation, RenameFolderMutationVariables>(RenameFolderDocument, options);
}
export type RenameFolderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RenameFolderMutation, RenameFolderMutationVariables>;
export const DeleteFoldersDocument = gql`
    mutation DeleteFolders($folderIds: [ID!]!) {
  deleteFolders(folderIds: $folderIds)
}
    `;

/**
 * __useDeleteFoldersMutation__
 *
 * To run a mutation, you first call `useDeleteFoldersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFoldersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteFoldersMutation({
 *   variables: {
 *     folderIds: // value for 'folderIds'
 *   },
 * });
 */
export function useDeleteFoldersMutation(options: VueApolloComposable.UseMutationOptions<DeleteFoldersMutation, DeleteFoldersMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteFoldersMutation, DeleteFoldersMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteFoldersMutation, DeleteFoldersMutationVariables>(DeleteFoldersDocument, options);
}
export type DeleteFoldersMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteFoldersMutation, DeleteFoldersMutationVariables>;
export const MoveItemsDocument = gql`
    mutation MoveItems($sourceIds: [ID!]!, $to: String!) {
  moveItems(sourceIds: $sourceIds, to: $to) {
    asyncProcess
  }
}
    `;

/**
 * __useMoveItemsMutation__
 *
 * To run a mutation, you first call `useMoveItemsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMoveItemsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMoveItemsMutation({
 *   variables: {
 *     sourceIds: // value for 'sourceIds'
 *     to: // value for 'to'
 *   },
 * });
 */
export function useMoveItemsMutation(options: VueApolloComposable.UseMutationOptions<MoveItemsMutation, MoveItemsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<MoveItemsMutation, MoveItemsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<MoveItemsMutation, MoveItemsMutationVariables>(MoveItemsDocument, options);
}
export type MoveItemsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<MoveItemsMutation, MoveItemsMutationVariables>;
export const ArchiveFilesDocument = gql`
    mutation ArchiveFiles($fileIds: [ID!]!) {
  archiveFiles(fileIds: $fileIds) {
    asyncProcess
  }
}
    `;

/**
 * __useArchiveFilesMutation__
 *
 * To run a mutation, you first call `useArchiveFilesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useArchiveFilesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useArchiveFilesMutation({
 *   variables: {
 *     fileIds: // value for 'fileIds'
 *   },
 * });
 */
export function useArchiveFilesMutation(options: VueApolloComposable.UseMutationOptions<ArchiveFilesMutation, ArchiveFilesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ArchiveFilesMutation, ArchiveFilesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ArchiveFilesMutation, ArchiveFilesMutationVariables>(ArchiveFilesDocument, options);
}
export type ArchiveFilesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ArchiveFilesMutation, ArchiveFilesMutationVariables>;
export const UpdateFileSettingsDocument = gql`
    mutation UpdateFileSettings($input: UpdateFileSettingsInput!) {
  updateFileSettings(input: $input) {
    id
    vanityName
    description
    isPrivate
    isDownloadAvailable
  }
}
    `;

/**
 * __useUpdateFileSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateFileSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateFileSettingsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFileSettingsMutation(options: VueApolloComposable.UseMutationOptions<UpdateFileSettingsMutation, UpdateFileSettingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateFileSettingsMutation, UpdateFileSettingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateFileSettingsMutation, UpdateFileSettingsMutationVariables>(UpdateFileSettingsDocument, options);
}
export type UpdateFileSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateFileSettingsMutation, UpdateFileSettingsMutationVariables>;
export const CreateSubscriptionDocument = gql`
    mutation CreateSubscription($paymentMethodId: ID, $productId: ID!, $platform: PlatformType!) {
  createSubscription(
    paymentMethodId: $paymentMethodId
    productId: $productId
    platform: $platform
  ) {
    failedMessage
    isScheduled
    requiresAction {
      clientSecret
    }
    plan {
      id
      name
      description
      status
      subscriptionCycle
      platform
      prices {
        type
        description
        details {
          amount
          currency
          suffix
        }
      }
      dateInfo {
        date
        prefix
      }
      details {
        prices {
          type
          description
          details {
            suffix
            amount
            currency
          }
        }
        upcomingBilling {
          date
          total
          tax
          currency
          registrationTotal
          outstandingTotal
          breakdown {
            outstanding
            amount
            description {
              text
              subtext
            }
          }
        }
      }
      type
    }
  }
}
    `;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSubscriptionMutation({
 *   variables: {
 *     paymentMethodId: // value for 'paymentMethodId'
 *     productId: // value for 'productId'
 *     platform: // value for 'platform'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(options: VueApolloComposable.UseMutationOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(CreateSubscriptionDocument, options);
}
export type CreateSubscriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const UpdateBillingInformationDocument = gql`
    mutation UpdateBillingInformation($paymentMethodId: ID!) {
  updateBillingInformation(paymentMethodId: $paymentMethodId) {
    paymentMethod {
      card {
        type
        last4
      }
      requiresAction {
        clientSecret
      }
    }
  }
}
    `;

/**
 * __useUpdateBillingInformationMutation__
 *
 * To run a mutation, you first call `useUpdateBillingInformationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingInformationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateBillingInformationMutation({
 *   variables: {
 *     paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useUpdateBillingInformationMutation(options: VueApolloComposable.UseMutationOptions<UpdateBillingInformationMutation, UpdateBillingInformationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateBillingInformationMutation, UpdateBillingInformationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateBillingInformationMutation, UpdateBillingInformationMutationVariables>(UpdateBillingInformationDocument, options);
}
export type UpdateBillingInformationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateBillingInformationMutation, UpdateBillingInformationMutationVariables>;
export const UpdateAccountNameDocument = gql`
    mutation UpdateAccountName($firstName: String!, $lastName: String!) {
  updateAccountName(firstName: $firstName, lastName: $lastName) {
    id
    firstName
    lastName
    name
  }
}
    `;

/**
 * __useUpdateAccountNameMutation__
 *
 * To run a mutation, you first call `useUpdateAccountNameMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountNameMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAccountNameMutation({
 *   variables: {
 *     firstName: // value for 'firstName'
 *     lastName: // value for 'lastName'
 *   },
 * });
 */
export function useUpdateAccountNameMutation(options: VueApolloComposable.UseMutationOptions<UpdateAccountNameMutation, UpdateAccountNameMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateAccountNameMutation, UpdateAccountNameMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateAccountNameMutation, UpdateAccountNameMutationVariables>(UpdateAccountNameDocument, options);
}
export type UpdateAccountNameMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateAccountNameMutation, UpdateAccountNameMutationVariables>;
export const UpdateAccountEmailDocument = gql`
    mutation UpdateAccountEmail($newEmail: String!) {
  updateAccountEmail(newEmail: $newEmail) {
    email
    id
  }
}
    `;

/**
 * __useUpdateAccountEmailMutation__
 *
 * To run a mutation, you first call `useUpdateAccountEmailMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountEmailMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAccountEmailMutation({
 *   variables: {
 *     newEmail: // value for 'newEmail'
 *   },
 * });
 */
export function useUpdateAccountEmailMutation(options: VueApolloComposable.UseMutationOptions<UpdateAccountEmailMutation, UpdateAccountEmailMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateAccountEmailMutation, UpdateAccountEmailMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateAccountEmailMutation, UpdateAccountEmailMutationVariables>(UpdateAccountEmailDocument, options);
}
export type UpdateAccountEmailMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateAccountEmailMutation, UpdateAccountEmailMutationVariables>;
export const UpdateAccountUsernameDocument = gql`
    mutation UpdateAccountUsername($username: String!) {
  updateAccountUsername(username: $username) {
    id
    username
  }
}
    `;

/**
 * __useUpdateAccountUsernameMutation__
 *
 * To run a mutation, you first call `useUpdateAccountUsernameMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountUsernameMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAccountUsernameMutation({
 *   variables: {
 *     username: // value for 'username'
 *   },
 * });
 */
export function useUpdateAccountUsernameMutation(options: VueApolloComposable.UseMutationOptions<UpdateAccountUsernameMutation, UpdateAccountUsernameMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateAccountUsernameMutation, UpdateAccountUsernameMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateAccountUsernameMutation, UpdateAccountUsernameMutationVariables>(UpdateAccountUsernameDocument, options);
}
export type UpdateAccountUsernameMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateAccountUsernameMutation, UpdateAccountUsernameMutationVariables>;
export const UpdateAccountTitleDocument = gql`
    mutation UpdateAccountTitle($title: String!) {
  updateAccountTitle(title: $title) {
    id
    title
  }
}
    `;

/**
 * __useUpdateAccountTitleMutation__
 *
 * To run a mutation, you first call `useUpdateAccountTitleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountTitleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAccountTitleMutation({
 *   variables: {
 *     title: // value for 'title'
 *   },
 * });
 */
export function useUpdateAccountTitleMutation(options: VueApolloComposable.UseMutationOptions<UpdateAccountTitleMutation, UpdateAccountTitleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateAccountTitleMutation, UpdateAccountTitleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateAccountTitleMutation, UpdateAccountTitleMutationVariables>(UpdateAccountTitleDocument, options);
}
export type UpdateAccountTitleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateAccountTitleMutation, UpdateAccountTitleMutationVariables>;
export const UpdateAccountBioDocument = gql`
    mutation UpdateAccountBio($bio: String!) {
  updateAccountBio(bio: $bio) {
    id
    bio
  }
}
    `;

/**
 * __useUpdateAccountBioMutation__
 *
 * To run a mutation, you first call `useUpdateAccountBioMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountBioMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAccountBioMutation({
 *   variables: {
 *     bio: // value for 'bio'
 *   },
 * });
 */
export function useUpdateAccountBioMutation(options: VueApolloComposable.UseMutationOptions<UpdateAccountBioMutation, UpdateAccountBioMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateAccountBioMutation, UpdateAccountBioMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateAccountBioMutation, UpdateAccountBioMutationVariables>(UpdateAccountBioDocument, options);
}
export type UpdateAccountBioMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateAccountBioMutation, UpdateAccountBioMutationVariables>;
export const UpdateAccountDateFormatDocument = gql`
    mutation UpdateAccountDateFormat($dateFormat: String!) {
  updateAccountDateFormat(dateFormat: $dateFormat) {
    id
    dateFormat
  }
}
    `;

/**
 * __useUpdateAccountDateFormatMutation__
 *
 * To run a mutation, you first call `useUpdateAccountDateFormatMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountDateFormatMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAccountDateFormatMutation({
 *   variables: {
 *     dateFormat: // value for 'dateFormat'
 *   },
 * });
 */
export function useUpdateAccountDateFormatMutation(options: VueApolloComposable.UseMutationOptions<UpdateAccountDateFormatMutation, UpdateAccountDateFormatMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateAccountDateFormatMutation, UpdateAccountDateFormatMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateAccountDateFormatMutation, UpdateAccountDateFormatMutationVariables>(UpdateAccountDateFormatDocument, options);
}
export type UpdateAccountDateFormatMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateAccountDateFormatMutation, UpdateAccountDateFormatMutationVariables>;
export const UpdateAccountTimezoneDocument = gql`
    mutation UpdateAccountTimezone($timezone: TimezoneInput) {
  updateAccountTimezone(timezone: $timezone) {
    id
    timezone {
      country
      name
    }
  }
}
    `;

/**
 * __useUpdateAccountTimezoneMutation__
 *
 * To run a mutation, you first call `useUpdateAccountTimezoneMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountTimezoneMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAccountTimezoneMutation({
 *   variables: {
 *     timezone: // value for 'timezone'
 *   },
 * });
 */
export function useUpdateAccountTimezoneMutation(options: VueApolloComposable.UseMutationOptions<UpdateAccountTimezoneMutation, UpdateAccountTimezoneMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateAccountTimezoneMutation, UpdateAccountTimezoneMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateAccountTimezoneMutation, UpdateAccountTimezoneMutationVariables>(UpdateAccountTimezoneDocument, options);
}
export type UpdateAccountTimezoneMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateAccountTimezoneMutation, UpdateAccountTimezoneMutationVariables>;
export const UpdateAccountDefaultFilePrivacyDocument = gql`
    mutation UpdateAccountDefaultFilePrivacy($isPrivate: Boolean!) {
  updateAccountDefaultFilePrivacy(isPrivate: $isPrivate) {
    id
    defaultFilePrivacy
  }
}
    `;

/**
 * __useUpdateAccountDefaultFilePrivacyMutation__
 *
 * To run a mutation, you first call `useUpdateAccountDefaultFilePrivacyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountDefaultFilePrivacyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAccountDefaultFilePrivacyMutation({
 *   variables: {
 *     isPrivate: // value for 'isPrivate'
 *   },
 * });
 */
export function useUpdateAccountDefaultFilePrivacyMutation(options: VueApolloComposable.UseMutationOptions<UpdateAccountDefaultFilePrivacyMutation, UpdateAccountDefaultFilePrivacyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateAccountDefaultFilePrivacyMutation, UpdateAccountDefaultFilePrivacyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateAccountDefaultFilePrivacyMutation, UpdateAccountDefaultFilePrivacyMutationVariables>(UpdateAccountDefaultFilePrivacyDocument, options);
}
export type UpdateAccountDefaultFilePrivacyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateAccountDefaultFilePrivacyMutation, UpdateAccountDefaultFilePrivacyMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($newPassword: String!, $oldPassword: String!) {
  changePassword(newPassword: $newPassword, oldPassword: $oldPassword)
}
    `;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useChangePasswordMutation({
 *   variables: {
 *     newPassword: // value for 'newPassword'
 *     oldPassword: // value for 'oldPassword'
 *   },
 * });
 */
export function useChangePasswordMutation(options: VueApolloComposable.UseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
}
export type ChangePasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const ConnectWalletDocument = gql`
    mutation ConnectWallet($input: ConnectWalletInput!) {
  connectWallet(input: $input) {
    anyTokensToSync
    anyTokensToTransfer
    transferringTokens
    syncingTokens
    user {
      id
    }
  }
}
    `;

/**
 * __useConnectWalletMutation__
 *
 * To run a mutation, you first call `useConnectWalletMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConnectWalletMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConnectWalletMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useConnectWalletMutation(options: VueApolloComposable.UseMutationOptions<ConnectWalletMutation, ConnectWalletMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConnectWalletMutation, ConnectWalletMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ConnectWalletMutation, ConnectWalletMutationVariables>(ConnectWalletDocument, options);
}
export type ConnectWalletMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConnectWalletMutation, ConnectWalletMutationVariables>;
export const DisconnectWalletDocument = gql`
    mutation DisconnectWallet($input: DisconnectWalletInput!) {
  disconnectWallet(input: $input) {
    id
    wallet {
      address
      type
    }
  }
}
    `;

/**
 * __useDisconnectWalletMutation__
 *
 * To run a mutation, you first call `useDisconnectWalletMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectWalletMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisconnectWalletMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDisconnectWalletMutation(options: VueApolloComposable.UseMutationOptions<DisconnectWalletMutation, DisconnectWalletMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DisconnectWalletMutation, DisconnectWalletMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DisconnectWalletMutation, DisconnectWalletMutationVariables>(DisconnectWalletDocument, options);
}
export type DisconnectWalletMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DisconnectWalletMutation, DisconnectWalletMutationVariables>;
export const DeactivateAccountDocument = gql`
    mutation DeactivateAccount {
  deactiveAccount {
    requiresAction {
      clientSecret
    }
  }
}
    `;

/**
 * __useDeactivateAccountMutation__
 *
 * To run a mutation, you first call `useDeactivateAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeactivateAccountMutation();
 */
export function useDeactivateAccountMutation(options: VueApolloComposable.UseMutationOptions<DeactivateAccountMutation, DeactivateAccountMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeactivateAccountMutation, DeactivateAccountMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeactivateAccountMutation, DeactivateAccountMutationVariables>(DeactivateAccountDocument, options);
}
export type DeactivateAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeactivateAccountMutation, DeactivateAccountMutationVariables>;
export const CancelSubscriptionDocument = gql`
    mutation CancelSubscription {
  cancelSubscription {
    paymentMethod {
      card {
        type
        last4
      }
      requiresAction {
        clientSecret
      }
    }
  }
}
    `;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelSubscriptionMutation();
 */
export function useCancelSubscriptionMutation(options: VueApolloComposable.UseMutationOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
}
export type CancelSubscriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const DeleteAccountDocument = gql`
    mutation DeleteAccount {
  deleteAccount {
    requiresAction {
      clientSecret
    }
  }
}
    `;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAccountMutation();
 */
export function useDeleteAccountMutation(options: VueApolloComposable.UseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
}
export type DeleteAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const SyncTokensToWalletDocument = gql`
    mutation SyncTokensToWallet($walletAddress: String!) {
  syncTokensToWallet(walletAddress: $walletAddress)
}
    `;

/**
 * __useSyncTokensToWalletMutation__
 *
 * To run a mutation, you first call `useSyncTokensToWalletMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSyncTokensToWalletMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSyncTokensToWalletMutation({
 *   variables: {
 *     walletAddress: // value for 'walletAddress'
 *   },
 * });
 */
export function useSyncTokensToWalletMutation(options: VueApolloComposable.UseMutationOptions<SyncTokensToWalletMutation, SyncTokensToWalletMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SyncTokensToWalletMutation, SyncTokensToWalletMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SyncTokensToWalletMutation, SyncTokensToWalletMutationVariables>(SyncTokensToWalletDocument, options);
}
export type SyncTokensToWalletMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SyncTokensToWalletMutation, SyncTokensToWalletMutationVariables>;
export const TransferTokensToAcccountDocument = gql`
    mutation TransferTokensToAcccount($walletAddress: String!) {
  transferTokensToAccount(walletAddress: $walletAddress)
}
    `;

/**
 * __useTransferTokensToAcccountMutation__
 *
 * To run a mutation, you first call `useTransferTokensToAcccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTransferTokensToAcccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTransferTokensToAcccountMutation({
 *   variables: {
 *     walletAddress: // value for 'walletAddress'
 *   },
 * });
 */
export function useTransferTokensToAcccountMutation(options: VueApolloComposable.UseMutationOptions<TransferTokensToAcccountMutation, TransferTokensToAcccountMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TransferTokensToAcccountMutation, TransferTokensToAcccountMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TransferTokensToAcccountMutation, TransferTokensToAcccountMutationVariables>(TransferTokensToAcccountDocument, options);
}
export type TransferTokensToAcccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TransferTokensToAcccountMutation, TransferTokensToAcccountMutationVariables>;
export const IssueLicenseDocument = gql`
    mutation IssueLicense($input: IssueLicenseInput!) {
  issueLicense(input: $input)
}
    `;

/**
 * __useIssueLicenseMutation__
 *
 * To run a mutation, you first call `useIssueLicenseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useIssueLicenseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useIssueLicenseMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useIssueLicenseMutation(options: VueApolloComposable.UseMutationOptions<IssueLicenseMutation, IssueLicenseMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IssueLicenseMutation, IssueLicenseMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IssueLicenseMutation, IssueLicenseMutationVariables>(IssueLicenseDocument, options);
}
export type IssueLicenseMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IssueLicenseMutation, IssueLicenseMutationVariables>;
export const MarkAllNotificationsAsReadDocument = gql`
    mutation MarkAllNotificationsAsRead {
  markAllNotificationsAsRead {
    unread
  }
}
    `;

/**
 * __useMarkAllNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllNotificationsAsReadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllNotificationsAsReadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkAllNotificationsAsReadMutation();
 */
export function useMarkAllNotificationsAsReadMutation(options: VueApolloComposable.UseMutationOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>(MarkAllNotificationsAsReadDocument, options);
}
export type MarkAllNotificationsAsReadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;
export const DownloadDocument = gql`
    mutation Download($id: ID!) {
  download(id: $id)
}
    `;

/**
 * __useDownloadMutation__
 *
 * To run a mutation, you first call `useDownloadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDownloadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDownloadMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDownloadMutation(options: VueApolloComposable.UseMutationOptions<DownloadMutation, DownloadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DownloadMutation, DownloadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DownloadMutation, DownloadMutationVariables>(DownloadDocument, options);
}
export type DownloadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DownloadMutation, DownloadMutationVariables>;
export const MarkNotificationAsReadDocument = gql`
    mutation MarkNotificationAsRead($ids: [ID!]!) {
  markNotificationAsRead(ids: $ids) {
    unread
  }
}
    `;

/**
 * __useMarkNotificationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsReadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsReadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkNotificationAsReadMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useMarkNotificationAsReadMutation(options: VueApolloComposable.UseMutationOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>(MarkNotificationAsReadDocument, options);
}
export type MarkNotificationAsReadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;
export const AcceptInviteDocument = gql`
    mutation AcceptInvite($id: ID!) {
  acceptInvite(id: $id)
}
    `;

/**
 * __useAcceptInviteMutation__
 *
 * To run a mutation, you first call `useAcceptInviteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInviteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAcceptInviteMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useAcceptInviteMutation(options: VueApolloComposable.UseMutationOptions<AcceptInviteMutation, AcceptInviteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AcceptInviteMutation, AcceptInviteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AcceptInviteMutation, AcceptInviteMutationVariables>(AcceptInviteDocument, options);
}
export type AcceptInviteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AcceptInviteMutation, AcceptInviteMutationVariables>;
export const DeclineInviteDocument = gql`
    mutation DeclineInvite($id: ID!) {
  declineInvite(id: $id)
}
    `;

/**
 * __useDeclineInviteMutation__
 *
 * To run a mutation, you first call `useDeclineInviteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeclineInviteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeclineInviteMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeclineInviteMutation(options: VueApolloComposable.UseMutationOptions<DeclineInviteMutation, DeclineInviteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeclineInviteMutation, DeclineInviteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeclineInviteMutation, DeclineInviteMutationVariables>(DeclineInviteDocument, options);
}
export type DeclineInviteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeclineInviteMutation, DeclineInviteMutationVariables>;
export const RemoveFileOwnerAccessDocument = gql`
    mutation RemoveFileOwnerAccess($input: RemoveFileAccessInput!) {
  removeFileOwnerAccess(input: $input) {
    items {
      entity {
        ...BasicUserFields
        ...OrganizationFields
        ...EmailFields
      }
      statuses
    }
    next
  }
}
    ${BasicUserFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}
${EmailFieldsFragmentDoc}`;

/**
 * __useRemoveFileOwnerAccessMutation__
 *
 * To run a mutation, you first call `useRemoveFileOwnerAccessMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFileOwnerAccessMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveFileOwnerAccessMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRemoveFileOwnerAccessMutation(options: VueApolloComposable.UseMutationOptions<RemoveFileOwnerAccessMutation, RemoveFileOwnerAccessMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveFileOwnerAccessMutation, RemoveFileOwnerAccessMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RemoveFileOwnerAccessMutation, RemoveFileOwnerAccessMutationVariables>(RemoveFileOwnerAccessDocument, options);
}
export type RemoveFileOwnerAccessMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveFileOwnerAccessMutation, RemoveFileOwnerAccessMutationVariables>;
export const RemoveFilePrivacyAccessDocument = gql`
    mutation RemoveFilePrivacyAccess($input: RemoveFileAccessInput!) {
  removeFilePrivacyAccess(input: $input) {
    items {
      entity {
        ...BasicUserFields
        ...OrganizationFields
        ...EmailFields
      }
      statuses
      isDownloadAvailable
    }
    next
  }
}
    ${BasicUserFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}
${EmailFieldsFragmentDoc}`;

/**
 * __useRemoveFilePrivacyAccessMutation__
 *
 * To run a mutation, you first call `useRemoveFilePrivacyAccessMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFilePrivacyAccessMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveFilePrivacyAccessMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRemoveFilePrivacyAccessMutation(options: VueApolloComposable.UseMutationOptions<RemoveFilePrivacyAccessMutation, RemoveFilePrivacyAccessMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveFilePrivacyAccessMutation, RemoveFilePrivacyAccessMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RemoveFilePrivacyAccessMutation, RemoveFilePrivacyAccessMutationVariables>(RemoveFilePrivacyAccessDocument, options);
}
export type RemoveFilePrivacyAccessMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveFilePrivacyAccessMutation, RemoveFilePrivacyAccessMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateUserMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(options: VueApolloComposable.UseMutationOptions<CreateUserMutation, CreateUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateUserMutation, CreateUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
}
export type CreateUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateUserMutation, CreateUserMutationVariables>;
export const AcceptTermsDocument = gql`
    mutation AcceptTerms {
  acceptTerms {
    id
    showUpdatedTerms
  }
}
    `;

/**
 * __useAcceptTermsMutation__
 *
 * To run a mutation, you first call `useAcceptTermsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTermsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAcceptTermsMutation();
 */
export function useAcceptTermsMutation(options: VueApolloComposable.UseMutationOptions<AcceptTermsMutation, AcceptTermsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AcceptTermsMutation, AcceptTermsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AcceptTermsMutation, AcceptTermsMutationVariables>(AcceptTermsDocument, options);
}
export type AcceptTermsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AcceptTermsMutation, AcceptTermsMutationVariables>;
export const RequestFilePrivacyAccessDocument = gql`
    mutation RequestFilePrivacyAccess($input: RequestFilePrivacyAccessInput!) {
  requestFilePrivacyAccess(input: $input) {
    items {
      entity {
        ...BasicUserFields
        ...OrganizationFields
        ...EmailFields
      }
      statuses
      isDownloadAvailable
    }
    next
  }
}
    ${BasicUserFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}
${EmailFieldsFragmentDoc}`;

/**
 * __useRequestFilePrivacyAccessMutation__
 *
 * To run a mutation, you first call `useRequestFilePrivacyAccessMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRequestFilePrivacyAccessMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRequestFilePrivacyAccessMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRequestFilePrivacyAccessMutation(options: VueApolloComposable.UseMutationOptions<RequestFilePrivacyAccessMutation, RequestFilePrivacyAccessMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RequestFilePrivacyAccessMutation, RequestFilePrivacyAccessMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RequestFilePrivacyAccessMutation, RequestFilePrivacyAccessMutationVariables>(RequestFilePrivacyAccessDocument, options);
}
export type RequestFilePrivacyAccessMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RequestFilePrivacyAccessMutation, RequestFilePrivacyAccessMutationVariables>;
export const RequestFileOwnerAccessDocument = gql`
    mutation RequestFileOwnerAccess($input: RequestFileOwnerAccessInput!) {
  requestFileOwnerAccess(input: $input) {
    items {
      entity {
        ...BasicUserFields
        ...OrganizationFields
        ...EmailFields
      }
      statuses
    }
    next
  }
}
    ${BasicUserFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}
${EmailFieldsFragmentDoc}`;

/**
 * __useRequestFileOwnerAccessMutation__
 *
 * To run a mutation, you first call `useRequestFileOwnerAccessMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRequestFileOwnerAccessMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRequestFileOwnerAccessMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRequestFileOwnerAccessMutation(options: VueApolloComposable.UseMutationOptions<RequestFileOwnerAccessMutation, RequestFileOwnerAccessMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RequestFileOwnerAccessMutation, RequestFileOwnerAccessMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RequestFileOwnerAccessMutation, RequestFileOwnerAccessMutationVariables>(RequestFileOwnerAccessDocument, options);
}
export type RequestFileOwnerAccessMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RequestFileOwnerAccessMutation, RequestFileOwnerAccessMutationVariables>;
export const CreateBatchUploadUrlDocument = gql`
    mutation CreateBatchUploadUrl($input: BatchUploadInput!) {
  createBatchUploadUrl(input: $input) {
    uploads {
      headers {
        bucket
        key
        Policy
        X_Amz_Algorithm
        X_Amz_Credential
        X_Amz_Date
        x_amz_meta_userid
        X_Amz_Security_Token
        X_Amz_Signature
        Content_Type
      }
      url
      title
      description
    }
  }
}
    `;

/**
 * __useCreateBatchUploadUrlMutation__
 *
 * To run a mutation, you first call `useCreateBatchUploadUrlMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateBatchUploadUrlMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateBatchUploadUrlMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateBatchUploadUrlMutation(options: VueApolloComposable.UseMutationOptions<CreateBatchUploadUrlMutation, CreateBatchUploadUrlMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateBatchUploadUrlMutation, CreateBatchUploadUrlMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateBatchUploadUrlMutation, CreateBatchUploadUrlMutationVariables>(CreateBatchUploadUrlDocument, options);
}
export type CreateBatchUploadUrlMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateBatchUploadUrlMutation, CreateBatchUploadUrlMutationVariables>;
export const AddCopyrightOwnerDocument = gql`
    mutation AddCopyrightOwner($name: String!, $type: CopyrightOwnerType!, $autoSelect: Boolean) {
  addCopyrightOwnerNew(name: $name, type: $type, autoSelect: $autoSelect) {
    id
    name
    avatarUrl
    isSelected
    type
    owner {
      ...BasicUserFields
    }
  }
}
    ${BasicUserFieldsFragmentDoc}`;

/**
 * __useAddCopyrightOwnerMutation__
 *
 * To run a mutation, you first call `useAddCopyrightOwnerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddCopyrightOwnerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddCopyrightOwnerMutation({
 *   variables: {
 *     name: // value for 'name'
 *     type: // value for 'type'
 *     autoSelect: // value for 'autoSelect'
 *   },
 * });
 */
export function useAddCopyrightOwnerMutation(options: VueApolloComposable.UseMutationOptions<AddCopyrightOwnerMutation, AddCopyrightOwnerMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddCopyrightOwnerMutation, AddCopyrightOwnerMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddCopyrightOwnerMutation, AddCopyrightOwnerMutationVariables>(AddCopyrightOwnerDocument, options);
}
export type AddCopyrightOwnerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddCopyrightOwnerMutation, AddCopyrightOwnerMutationVariables>;
export const UpdateCopyrightOwnerDocument = gql`
    mutation UpdateCopyrightOwner($id: ID!, $name: String!) {
  updateCopyrightOwnerNew(id: $id, name: $name) {
    id
    name
    avatarUrl
    isSelected
    type
    owner {
      ...BasicUserFields
    }
  }
}
    ${BasicUserFieldsFragmentDoc}`;

/**
 * __useUpdateCopyrightOwnerMutation__
 *
 * To run a mutation, you first call `useUpdateCopyrightOwnerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCopyrightOwnerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCopyrightOwnerMutation({
 *   variables: {
 *     id: // value for 'id'
 *     name: // value for 'name'
 *   },
 * });
 */
export function useUpdateCopyrightOwnerMutation(options: VueApolloComposable.UseMutationOptions<UpdateCopyrightOwnerMutation, UpdateCopyrightOwnerMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCopyrightOwnerMutation, UpdateCopyrightOwnerMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateCopyrightOwnerMutation, UpdateCopyrightOwnerMutationVariables>(UpdateCopyrightOwnerDocument, options);
}
export type UpdateCopyrightOwnerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCopyrightOwnerMutation, UpdateCopyrightOwnerMutationVariables>;
export const DeleteCopyrightOwnerDocument = gql`
    mutation DeleteCopyrightOwner($id: ID!) {
  deleteCopyrightOwner(id: $id)
}
    `;

/**
 * __useDeleteCopyrightOwnerMutation__
 *
 * To run a mutation, you first call `useDeleteCopyrightOwnerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCopyrightOwnerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCopyrightOwnerMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCopyrightOwnerMutation(options: VueApolloComposable.UseMutationOptions<DeleteCopyrightOwnerMutation, DeleteCopyrightOwnerMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteCopyrightOwnerMutation, DeleteCopyrightOwnerMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteCopyrightOwnerMutation, DeleteCopyrightOwnerMutationVariables>(DeleteCopyrightOwnerDocument, options);
}
export type DeleteCopyrightOwnerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteCopyrightOwnerMutation, DeleteCopyrightOwnerMutationVariables>;
export const SelectCopyrightOwnerDocument = gql`
    mutation SelectCopyrightOwner($id: ID!) {
  selectCopyrightOwner(id: $id)
}
    `;

/**
 * __useSelectCopyrightOwnerMutation__
 *
 * To run a mutation, you first call `useSelectCopyrightOwnerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSelectCopyrightOwnerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSelectCopyrightOwnerMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useSelectCopyrightOwnerMutation(options: VueApolloComposable.UseMutationOptions<SelectCopyrightOwnerMutation, SelectCopyrightOwnerMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SelectCopyrightOwnerMutation, SelectCopyrightOwnerMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SelectCopyrightOwnerMutation, SelectCopyrightOwnerMutationVariables>(SelectCopyrightOwnerDocument, options);
}
export type SelectCopyrightOwnerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SelectCopyrightOwnerMutation, SelectCopyrightOwnerMutationVariables>;
export const UpdateFilePrivacyDownloadStatusDocument = gql`
    mutation UpdateFilePrivacyDownloadStatus($input: UpdateFilePrivacyDownloadStatusInput!) {
  updateFilePrivacyDownloadStatus(input: $input)
}
    `;

/**
 * __useUpdateFilePrivacyDownloadStatusMutation__
 *
 * To run a mutation, you first call `useUpdateFilePrivacyDownloadStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFilePrivacyDownloadStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateFilePrivacyDownloadStatusMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFilePrivacyDownloadStatusMutation(options: VueApolloComposable.UseMutationOptions<UpdateFilePrivacyDownloadStatusMutation, UpdateFilePrivacyDownloadStatusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateFilePrivacyDownloadStatusMutation, UpdateFilePrivacyDownloadStatusMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateFilePrivacyDownloadStatusMutation, UpdateFilePrivacyDownloadStatusMutationVariables>(UpdateFilePrivacyDownloadStatusDocument, options);
}
export type UpdateFilePrivacyDownloadStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateFilePrivacyDownloadStatusMutation, UpdateFilePrivacyDownloadStatusMutationVariables>;
export const RemoveFileAuthorAccessDocument = gql`
    mutation RemoveFileAuthorAccess($input: RemoveFileAccessInput!) {
  removeFileAuthorAccess(input: $input) {
    items {
      entity {
        ...BasicUserFields
        ...OrganizationFields
        ...EmailFields
      }
      statuses
    }
    next
  }
}
    ${BasicUserFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}
${EmailFieldsFragmentDoc}`;

/**
 * __useRemoveFileAuthorAccessMutation__
 *
 * To run a mutation, you first call `useRemoveFileAuthorAccessMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFileAuthorAccessMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveFileAuthorAccessMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRemoveFileAuthorAccessMutation(options: VueApolloComposable.UseMutationOptions<RemoveFileAuthorAccessMutation, RemoveFileAuthorAccessMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RemoveFileAuthorAccessMutation, RemoveFileAuthorAccessMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RemoveFileAuthorAccessMutation, RemoveFileAuthorAccessMutationVariables>(RemoveFileAuthorAccessDocument, options);
}
export type RemoveFileAuthorAccessMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RemoveFileAuthorAccessMutation, RemoveFileAuthorAccessMutationVariables>;
export const RequestFileAuthorAccessDocument = gql`
    mutation RequestFileAuthorAccess($input: RequestFileAuthorAccessInput!) {
  requestFileAuthorAccess(input: $input) {
    items {
      entity {
        ...BasicUserFields
        ...OrganizationFields
        ...EmailFields
      }
      statuses
    }
    next
  }
}
    ${BasicUserFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}
${EmailFieldsFragmentDoc}`;

/**
 * __useRequestFileAuthorAccessMutation__
 *
 * To run a mutation, you first call `useRequestFileAuthorAccessMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRequestFileAuthorAccessMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRequestFileAuthorAccessMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRequestFileAuthorAccessMutation(options: VueApolloComposable.UseMutationOptions<RequestFileAuthorAccessMutation, RequestFileAuthorAccessMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RequestFileAuthorAccessMutation, RequestFileAuthorAccessMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RequestFileAuthorAccessMutation, RequestFileAuthorAccessMutationVariables>(RequestFileAuthorAccessDocument, options);
}
export type RequestFileAuthorAccessMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RequestFileAuthorAccessMutation, RequestFileAuthorAccessMutationVariables>;
export const AddCopyrightOwnerEntityDocument = gql`
    mutation AddCopyrightOwnerEntity($input: EntityInput!, $autoSelect: Boolean) {
  addCopyrightOwnerEntityNew(input: $input, autoSelect: $autoSelect) {
    id
    name
    type
    avatarUrl
    isSelected
    owner {
      ...BasicUserFields
    }
  }
}
    ${BasicUserFieldsFragmentDoc}`;

/**
 * __useAddCopyrightOwnerEntityMutation__
 *
 * To run a mutation, you first call `useAddCopyrightOwnerEntityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddCopyrightOwnerEntityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddCopyrightOwnerEntityMutation({
 *   variables: {
 *     input: // value for 'input'
 *     autoSelect: // value for 'autoSelect'
 *   },
 * });
 */
export function useAddCopyrightOwnerEntityMutation(options: VueApolloComposable.UseMutationOptions<AddCopyrightOwnerEntityMutation, AddCopyrightOwnerEntityMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddCopyrightOwnerEntityMutation, AddCopyrightOwnerEntityMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddCopyrightOwnerEntityMutation, AddCopyrightOwnerEntityMutationVariables>(AddCopyrightOwnerEntityDocument, options);
}
export type AddCopyrightOwnerEntityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddCopyrightOwnerEntityMutation, AddCopyrightOwnerEntityMutationVariables>;
export const SignoutDocument = gql`
    mutation Signout {
  signout
}
    `;

/**
 * __useSignoutMutation__
 *
 * To run a mutation, you first call `useSignoutMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSignoutMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSignoutMutation();
 */
export function useSignoutMutation(options: VueApolloComposable.UseMutationOptions<SignoutMutation, SignoutMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SignoutMutation, SignoutMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SignoutMutation, SignoutMutationVariables>(SignoutDocument, options);
}
export type SignoutMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SignoutMutation, SignoutMutationVariables>;
export const PayDocument = gql`
    mutation Pay($reactivateAccount: Boolean) {
  pay(reactivateAccount: $reactivateAccount) {
    ...BillingFields
  }
}
    ${BillingFieldsFragmentDoc}`;

/**
 * __usePayMutation__
 *
 * To run a mutation, you first call `usePayMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePayMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePayMutation({
 *   variables: {
 *     reactivateAccount: // value for 'reactivateAccount'
 *   },
 * });
 */
export function usePayMutation(options: VueApolloComposable.UseMutationOptions<PayMutation, PayMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PayMutation, PayMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<PayMutation, PayMutationVariables>(PayDocument, options);
}
export type PayMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PayMutation, PayMutationVariables>;
export const UpdateFilePrivacyDocument = gql`
    mutation UpdateFilePrivacy($fileIds: [ID!]!, $isPrivate: Boolean!) {
  updateFilePrivacy(fileIds: $fileIds, isPrivate: $isPrivate) {
    asyncProcess
  }
}
    `;

/**
 * __useUpdateFilePrivacyMutation__
 *
 * To run a mutation, you first call `useUpdateFilePrivacyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFilePrivacyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateFilePrivacyMutation({
 *   variables: {
 *     fileIds: // value for 'fileIds'
 *     isPrivate: // value for 'isPrivate'
 *   },
 * });
 */
export function useUpdateFilePrivacyMutation(options: VueApolloComposable.UseMutationOptions<UpdateFilePrivacyMutation, UpdateFilePrivacyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateFilePrivacyMutation, UpdateFilePrivacyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateFilePrivacyMutation, UpdateFilePrivacyMutationVariables>(UpdateFilePrivacyDocument, options);
}
export type UpdateFilePrivacyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateFilePrivacyMutation, UpdateFilePrivacyMutationVariables>;
export const ValidateOtpDocument = gql`
    mutation ValidateOTP($code: String!) {
  validateOTP(code: $code) {
    validated
  }
}
    `;

/**
 * __useValidateOtpMutation__
 *
 * To run a mutation, you first call `useValidateOtpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useValidateOtpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useValidateOtpMutation({
 *   variables: {
 *     code: // value for 'code'
 *   },
 * });
 */
export function useValidateOtpMutation(options: VueApolloComposable.UseMutationOptions<ValidateOtpMutation, ValidateOtpMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ValidateOtpMutation, ValidateOtpMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ValidateOtpMutation, ValidateOtpMutationVariables>(ValidateOtpDocument, options);
}
export type ValidateOtpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ValidateOtpMutation, ValidateOtpMutationVariables>;
export const UpdateGuidanceDocument = gql`
    mutation UpdateGuidance($input: GuidanceStateInput!) {
  guidance(input: $input) {
    states {
      id
      state {
        state
      }
    }
  }
}
    `;

/**
 * __useUpdateGuidanceMutation__
 *
 * To run a mutation, you first call `useUpdateGuidanceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGuidanceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateGuidanceMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGuidanceMutation(options: VueApolloComposable.UseMutationOptions<UpdateGuidanceMutation, UpdateGuidanceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateGuidanceMutation, UpdateGuidanceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateGuidanceMutation, UpdateGuidanceMutationVariables>(UpdateGuidanceDocument, options);
}
export type UpdateGuidanceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateGuidanceMutation, UpdateGuidanceMutationVariables>;
export const TrackEventDocument = gql`
    mutation TrackEvent($name: String!, $data: String!) {
  trackEvent(name: $name, data: $data)
}
    `;

/**
 * __useTrackEventMutation__
 *
 * To run a mutation, you first call `useTrackEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTrackEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTrackEventMutation({
 *   variables: {
 *     name: // value for 'name'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useTrackEventMutation(options: VueApolloComposable.UseMutationOptions<TrackEventMutation, TrackEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TrackEventMutation, TrackEventMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TrackEventMutation, TrackEventMutationVariables>(TrackEventDocument, options);
}
export type TrackEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TrackEventMutation, TrackEventMutationVariables>;
export const CompleteStepDocument = gql`
    mutation CompleteStep($step: Int!, $question: String, $answers: [String]) {
  completeOnboardingStep(step: $step, question: $question, answers: $answers)
}
    `;

/**
 * __useCompleteStepMutation__
 *
 * To run a mutation, you first call `useCompleteStepMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteStepMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteStepMutation({
 *   variables: {
 *     step: // value for 'step'
 *     question: // value for 'question'
 *     answers: // value for 'answers'
 *   },
 * });
 */
export function useCompleteStepMutation(options: VueApolloComposable.UseMutationOptions<CompleteStepMutation, CompleteStepMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CompleteStepMutation, CompleteStepMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CompleteStepMutation, CompleteStepMutationVariables>(CompleteStepDocument, options);
}
export type CompleteStepMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CompleteStepMutation, CompleteStepMutationVariables>;
export const CompleteOnboardingDocument = gql`
    mutation CompleteOnboarding {
  completeOnboarding
}
    `;

/**
 * __useCompleteOnboardingMutation__
 *
 * To run a mutation, you first call `useCompleteOnboardingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteOnboardingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteOnboardingMutation();
 */
export function useCompleteOnboardingMutation(options: VueApolloComposable.UseMutationOptions<CompleteOnboardingMutation, CompleteOnboardingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CompleteOnboardingMutation, CompleteOnboardingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CompleteOnboardingMutation, CompleteOnboardingMutationVariables>(CompleteOnboardingDocument, options);
}
export type CompleteOnboardingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CompleteOnboardingMutation, CompleteOnboardingMutationVariables>;
export const PingDocument = gql`
    query Ping {
  ping
}
    `;

/**
 * __usePingQuery__
 *
 * To run a query within a Vue component, call `usePingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePingQuery();
 */
export function usePingQuery(options: VueApolloComposable.UseQueryOptions<PingQuery, PingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PingQuery, PingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PingQuery, PingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PingQuery, PingQueryVariables>(PingDocument, {}, options);
}
export function usePingLazyQuery(options: VueApolloComposable.UseQueryOptions<PingQuery, PingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PingQuery, PingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PingQuery, PingQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PingQuery, PingQueryVariables>(PingDocument, {}, options);
}
export type PingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PingQuery, PingQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a Vue component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMeQuery();
 */
export function useMeQuery(options: VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MeQuery, MeQueryVariables>(MeDocument, {}, options);
}
export function useMeLazyQuery(options: VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, {}, options);
}
export type MeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MeQuery, MeQueryVariables>;
export const StatsDocument = gql`
    query Stats {
  stats {
    totalFiles
    pendingLicenses
    pendingSales
    pendingTransfers
    totalFilesLimit
    hasUploadedFileAsAPro
  }
}
    `;

/**
 * __useStatsQuery__
 *
 * To run a query within a Vue component, call `useStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useStatsQuery();
 */
export function useStatsQuery(options: VueApolloComposable.UseQueryOptions<StatsQuery, StatsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<StatsQuery, StatsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<StatsQuery, StatsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<StatsQuery, StatsQueryVariables>(StatsDocument, {}, options);
}
export function useStatsLazyQuery(options: VueApolloComposable.UseQueryOptions<StatsQuery, StatsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<StatsQuery, StatsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<StatsQuery, StatsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<StatsQuery, StatsQueryVariables>(StatsDocument, {}, options);
}
export type StatsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<StatsQuery, StatsQueryVariables>;
export const InvoicePdfDocument = gql`
    query InvoicePdf($invoiceId: ID!) {
  invoicePdf(invoiceId: $invoiceId) {
    status
    url
  }
}
    `;

/**
 * __useInvoicePdfQuery__
 *
 * To run a query within a Vue component, call `useInvoicePdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicePdfQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useInvoicePdfQuery({
 *   invoiceId: // value for 'invoiceId'
 * });
 */
export function useInvoicePdfQuery(variables: InvoicePdfQueryVariables | VueCompositionApi.Ref<InvoicePdfQueryVariables> | ReactiveFunction<InvoicePdfQueryVariables>, options: VueApolloComposable.UseQueryOptions<InvoicePdfQuery, InvoicePdfQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<InvoicePdfQuery, InvoicePdfQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<InvoicePdfQuery, InvoicePdfQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<InvoicePdfQuery, InvoicePdfQueryVariables>(InvoicePdfDocument, variables, options);
}
export function useInvoicePdfLazyQuery(variables?: InvoicePdfQueryVariables | VueCompositionApi.Ref<InvoicePdfQueryVariables> | ReactiveFunction<InvoicePdfQueryVariables>, options: VueApolloComposable.UseQueryOptions<InvoicePdfQuery, InvoicePdfQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<InvoicePdfQuery, InvoicePdfQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<InvoicePdfQuery, InvoicePdfQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<InvoicePdfQuery, InvoicePdfQueryVariables>(InvoicePdfDocument, variables, options);
}
export type InvoicePdfQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<InvoicePdfQuery, InvoicePdfQueryVariables>;
export const AgreementUrlDocument = gql`
    query AgreementUrl($content: String!) {
  agreementUrl(content: $content) {
    url
  }
}
    `;

/**
 * __useAgreementUrlQuery__
 *
 * To run a query within a Vue component, call `useAgreementUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgreementUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAgreementUrlQuery({
 *   content: // value for 'content'
 * });
 */
export function useAgreementUrlQuery(variables: AgreementUrlQueryVariables | VueCompositionApi.Ref<AgreementUrlQueryVariables> | ReactiveFunction<AgreementUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<AgreementUrlQuery, AgreementUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AgreementUrlQuery, AgreementUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AgreementUrlQuery, AgreementUrlQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AgreementUrlQuery, AgreementUrlQueryVariables>(AgreementUrlDocument, variables, options);
}
export function useAgreementUrlLazyQuery(variables?: AgreementUrlQueryVariables | VueCompositionApi.Ref<AgreementUrlQueryVariables> | ReactiveFunction<AgreementUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<AgreementUrlQuery, AgreementUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AgreementUrlQuery, AgreementUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AgreementUrlQuery, AgreementUrlQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AgreementUrlQuery, AgreementUrlQueryVariables>(AgreementUrlDocument, variables, options);
}
export type AgreementUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AgreementUrlQuery, AgreementUrlQueryVariables>;
export const FolderByPathDocument = gql`
    query FolderByPath($path: String!, $sortBy: SearchSort, $next: [Any]) {
  __typename
  folderByPath(path: $path, sortBy: $sortBy, next: $next) {
    __typename
    id
    items {
      __typename
      file {
        ...FileFields
      }
      id
      name
      parentFolderId
      parentPath
      timestamp
      numberOfItems
      type
    }
    name
    numberOfItems
    parentPath
    parentFolderId
    timestamp
    next
    sortBy
  }
}
    ${FileFieldsFragmentDoc}`;

/**
 * __useFolderByPathQuery__
 *
 * To run a query within a Vue component, call `useFolderByPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderByPathQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFolderByPathQuery({
 *   path: // value for 'path'
 *   sortBy: // value for 'sortBy'
 *   next: // value for 'next'
 * });
 */
export function useFolderByPathQuery(variables: FolderByPathQueryVariables | VueCompositionApi.Ref<FolderByPathQueryVariables> | ReactiveFunction<FolderByPathQueryVariables>, options: VueApolloComposable.UseQueryOptions<FolderByPathQuery, FolderByPathQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FolderByPathQuery, FolderByPathQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FolderByPathQuery, FolderByPathQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FolderByPathQuery, FolderByPathQueryVariables>(FolderByPathDocument, variables, options);
}
export function useFolderByPathLazyQuery(variables?: FolderByPathQueryVariables | VueCompositionApi.Ref<FolderByPathQueryVariables> | ReactiveFunction<FolderByPathQueryVariables>, options: VueApolloComposable.UseQueryOptions<FolderByPathQuery, FolderByPathQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FolderByPathQuery, FolderByPathQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FolderByPathQuery, FolderByPathQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FolderByPathQuery, FolderByPathQueryVariables>(FolderByPathDocument, variables, options);
}
export type FolderByPathQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FolderByPathQuery, FolderByPathQueryVariables>;
export const FolderDocument = gql`
    query Folder($id: ID!, $sortBy: SearchSort, $next: [Any]) {
  folder(id: $id, sortBy: $sortBy, next: $next) {
    id
    items {
      __typename
      file {
        ...FileFields
      }
      id
      name
      parentFolderId
      parentPath
      timestamp
      numberOfItems
      type
    }
    name
    numberOfItems
    parentPath
    parentFolderId
    timestamp
    next
  }
}
    ${FileFieldsFragmentDoc}`;

/**
 * __useFolderQuery__
 *
 * To run a query within a Vue component, call `useFolderQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFolderQuery({
 *   id: // value for 'id'
 *   sortBy: // value for 'sortBy'
 *   next: // value for 'next'
 * });
 */
export function useFolderQuery(variables: FolderQueryVariables | VueCompositionApi.Ref<FolderQueryVariables> | ReactiveFunction<FolderQueryVariables>, options: VueApolloComposable.UseQueryOptions<FolderQuery, FolderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FolderQuery, FolderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FolderQuery, FolderQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FolderQuery, FolderQueryVariables>(FolderDocument, variables, options);
}
export function useFolderLazyQuery(variables?: FolderQueryVariables | VueCompositionApi.Ref<FolderQueryVariables> | ReactiveFunction<FolderQueryVariables>, options: VueApolloComposable.UseQueryOptions<FolderQuery, FolderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FolderQuery, FolderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FolderQuery, FolderQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FolderQuery, FolderQueryVariables>(FolderDocument, variables, options);
}
export type FolderQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FolderQuery, FolderQueryVariables>;
export const CheckUsernameAvailabilityDocument = gql`
    query CheckUsernameAvailability($username: String!) {
  checkUsernameAvailability(username: $username)
}
    `;

/**
 * __useCheckUsernameAvailabilityQuery__
 *
 * To run a query within a Vue component, call `useCheckUsernameAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUsernameAvailabilityQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCheckUsernameAvailabilityQuery({
 *   username: // value for 'username'
 * });
 */
export function useCheckUsernameAvailabilityQuery(variables: CheckUsernameAvailabilityQueryVariables | VueCompositionApi.Ref<CheckUsernameAvailabilityQueryVariables> | ReactiveFunction<CheckUsernameAvailabilityQueryVariables>, options: VueApolloComposable.UseQueryOptions<CheckUsernameAvailabilityQuery, CheckUsernameAvailabilityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CheckUsernameAvailabilityQuery, CheckUsernameAvailabilityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CheckUsernameAvailabilityQuery, CheckUsernameAvailabilityQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CheckUsernameAvailabilityQuery, CheckUsernameAvailabilityQueryVariables>(CheckUsernameAvailabilityDocument, variables, options);
}
export function useCheckUsernameAvailabilityLazyQuery(variables?: CheckUsernameAvailabilityQueryVariables | VueCompositionApi.Ref<CheckUsernameAvailabilityQueryVariables> | ReactiveFunction<CheckUsernameAvailabilityQueryVariables>, options: VueApolloComposable.UseQueryOptions<CheckUsernameAvailabilityQuery, CheckUsernameAvailabilityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CheckUsernameAvailabilityQuery, CheckUsernameAvailabilityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CheckUsernameAvailabilityQuery, CheckUsernameAvailabilityQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CheckUsernameAvailabilityQuery, CheckUsernameAvailabilityQueryVariables>(CheckUsernameAvailabilityDocument, variables, options);
}
export type CheckUsernameAvailabilityQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CheckUsernameAvailabilityQuery, CheckUsernameAvailabilityQueryVariables>;
export const FileDocument = gql`
    query File($id: ID!, $accessToken: ID) {
  file(id: $id, accessToken: $accessToken) {
    ...FileFields
  }
}
    ${FileFieldsFragmentDoc}`;

/**
 * __useFileQuery__
 *
 * To run a query within a Vue component, call `useFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFileQuery({
 *   id: // value for 'id'
 *   accessToken: // value for 'accessToken'
 * });
 */
export function useFileQuery(variables: FileQueryVariables | VueCompositionApi.Ref<FileQueryVariables> | ReactiveFunction<FileQueryVariables>, options: VueApolloComposable.UseQueryOptions<FileQuery, FileQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FileQuery, FileQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FileQuery, FileQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FileQuery, FileQueryVariables>(FileDocument, variables, options);
}
export function useFileLazyQuery(variables?: FileQueryVariables | VueCompositionApi.Ref<FileQueryVariables> | ReactiveFunction<FileQueryVariables>, options: VueApolloComposable.UseQueryOptions<FileQuery, FileQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FileQuery, FileQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FileQuery, FileQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FileQuery, FileQueryVariables>(FileDocument, variables, options);
}
export type FileQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FileQuery, FileQueryVariables>;
export const ArchivedFilesDocument = gql`
    query ArchivedFiles($sortBy: SearchSort, $next: [Any]) {
  archivedFiles(sortBy: $sortBy, next: $next) {
    next
    items {
      id
      archivedAt
      status
      size
      type
      friendlyType
      fileName
      imageUrl
      transactions {
        timestamp
        from {
          ...BasicUserFields
          ...OrganizationFields
        }
        to {
          ...BasicUserFields
          ...OrganizationFields
        }
        price {
          value
        }
        status
        hash
      }
    }
    total
  }
}
    ${BasicUserFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}`;

/**
 * __useArchivedFilesQuery__
 *
 * To run a query within a Vue component, call `useArchivedFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useArchivedFilesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useArchivedFilesQuery({
 *   sortBy: // value for 'sortBy'
 *   next: // value for 'next'
 * });
 */
export function useArchivedFilesQuery(variables: ArchivedFilesQueryVariables | VueCompositionApi.Ref<ArchivedFilesQueryVariables> | ReactiveFunction<ArchivedFilesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ArchivedFilesQuery, ArchivedFilesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ArchivedFilesQuery, ArchivedFilesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ArchivedFilesQuery, ArchivedFilesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ArchivedFilesQuery, ArchivedFilesQueryVariables>(ArchivedFilesDocument, variables, options);
}
export function useArchivedFilesLazyQuery(variables: ArchivedFilesQueryVariables | VueCompositionApi.Ref<ArchivedFilesQueryVariables> | ReactiveFunction<ArchivedFilesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ArchivedFilesQuery, ArchivedFilesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ArchivedFilesQuery, ArchivedFilesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ArchivedFilesQuery, ArchivedFilesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ArchivedFilesQuery, ArchivedFilesQueryVariables>(ArchivedFilesDocument, variables, options);
}
export type ArchivedFilesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ArchivedFilesQuery, ArchivedFilesQueryVariables>;
export const ConfigDocument = gql`
    query Config {
  config {
    wallets {
      dacrAddress
      licenseAddress
    }
    contracts {
      dacr {
        contractAddress
        royalty {
          feeNumerator
          feeDenominator
        }
      }
      license {
        contractAddress
        royalty {
          feeNumerator
          feeDenominator
        }
      }
    }
  }
}
    `;

/**
 * __useConfigQuery__
 *
 * To run a query within a Vue component, call `useConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useConfigQuery();
 */
export function useConfigQuery(options: VueApolloComposable.UseQueryOptions<ConfigQuery, ConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ConfigQuery, ConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ConfigQuery, ConfigQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ConfigQuery, ConfigQueryVariables>(ConfigDocument, {}, options);
}
export function useConfigLazyQuery(options: VueApolloComposable.UseQueryOptions<ConfigQuery, ConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ConfigQuery, ConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ConfigQuery, ConfigQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ConfigQuery, ConfigQueryVariables>(ConfigDocument, {}, options);
}
export type ConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ConfigQuery, ConfigQueryVariables>;
export const SearchDocument = gql`
    query Search($query: String!) {
  search(query: $query) {
    ... on CombinedSearchResult {
      items {
        __typename
        file {
          ...FileFields
        }
        id
        name
        parentFolderId
        parentPath
        timestamp
        numberOfItems
        type
      }
      files {
        id
        name
        filename
        type
        status
        timestamp
        imageUrl
        copyrightType
      }
      token {
        id
        name
        filename
        type
        status
        timestamp
        imageUrl
      }
    }
  }
}
    ${FileFieldsFragmentDoc}`;

/**
 * __useSearchQuery__
 *
 * To run a query within a Vue component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchQuery({
 *   query: // value for 'query'
 * });
 */
export function useSearchQuery(variables: SearchQueryVariables | VueCompositionApi.Ref<SearchQueryVariables> | ReactiveFunction<SearchQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchQuery, SearchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchQuery, SearchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchQuery, SearchQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, variables, options);
}
export function useSearchLazyQuery(variables?: SearchQueryVariables | VueCompositionApi.Ref<SearchQueryVariables> | ReactiveFunction<SearchQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchQuery, SearchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchQuery, SearchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchQuery, SearchQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, variables, options);
}
export type SearchQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchQuery, SearchQueryVariables>;
export const NotificationsDocument = gql`
    query Notifications($next: [Any]) {
  notifications(next: $next) {
    next
    unreadNotifications
    notifications {
      ...NotificationFields
    }
  }
}
    ${NotificationFieldsFragmentDoc}`;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a Vue component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useNotificationsQuery({
 *   next: // value for 'next'
 * });
 */
export function useNotificationsQuery(variables: NotificationsQueryVariables | VueCompositionApi.Ref<NotificationsQueryVariables> | ReactiveFunction<NotificationsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, variables, options);
}
export function useNotificationsLazyQuery(variables: NotificationsQueryVariables | VueCompositionApi.Ref<NotificationsQueryVariables> | ReactiveFunction<NotificationsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, variables, options);
}
export type NotificationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<NotificationsQuery, NotificationsQueryVariables>;
export const SearchItemsDocument = gql`
    query SearchItems($query: String!, $sortBy: SearchSort, $next: [Any]) {
  searchItems(query: $query, sortBy: $sortBy, next: $next) {
    total
    files {
      id
      type
      name
      timestamp
      parentPath
      file {
        ...FileFields
      }
    }
    next
  }
}
    ${FileFieldsFragmentDoc}`;

/**
 * __useSearchItemsQuery__
 *
 * To run a query within a Vue component, call `useSearchItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchItemsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchItemsQuery({
 *   query: // value for 'query'
 *   sortBy: // value for 'sortBy'
 *   next: // value for 'next'
 * });
 */
export function useSearchItemsQuery(variables: SearchItemsQueryVariables | VueCompositionApi.Ref<SearchItemsQueryVariables> | ReactiveFunction<SearchItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchItemsQuery, SearchItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchItemsQuery, SearchItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchItemsQuery, SearchItemsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchItemsQuery, SearchItemsQueryVariables>(SearchItemsDocument, variables, options);
}
export function useSearchItemsLazyQuery(variables?: SearchItemsQueryVariables | VueCompositionApi.Ref<SearchItemsQueryVariables> | ReactiveFunction<SearchItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchItemsQuery, SearchItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchItemsQuery, SearchItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchItemsQuery, SearchItemsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SearchItemsQuery, SearchItemsQueryVariables>(SearchItemsDocument, variables, options);
}
export type SearchItemsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchItemsQuery, SearchItemsQueryVariables>;
export const SearchFilesDocument = gql`
    query SearchFiles($query: String!, $filterBy: [FileCategory!], $sortBy: SearchSort, $next: [Any]) {
  searchFiles(query: $query, filterBy: $filterBy, sortBy: $sortBy, next: $next) {
    total
    files {
      id
      name
      filename
      type
      status
      imageUrl
      category
      timestamp
      owner {
        ...BasicUserFields
        ...OrganizationFields
      }
    }
    next
  }
}
    ${BasicUserFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}`;

/**
 * __useSearchFilesQuery__
 *
 * To run a query within a Vue component, call `useSearchFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFilesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchFilesQuery({
 *   query: // value for 'query'
 *   filterBy: // value for 'filterBy'
 *   sortBy: // value for 'sortBy'
 *   next: // value for 'next'
 * });
 */
export function useSearchFilesQuery(variables: SearchFilesQueryVariables | VueCompositionApi.Ref<SearchFilesQueryVariables> | ReactiveFunction<SearchFilesQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchFilesQuery, SearchFilesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchFilesQuery, SearchFilesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchFilesQuery, SearchFilesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchFilesQuery, SearchFilesQueryVariables>(SearchFilesDocument, variables, options);
}
export function useSearchFilesLazyQuery(variables?: SearchFilesQueryVariables | VueCompositionApi.Ref<SearchFilesQueryVariables> | ReactiveFunction<SearchFilesQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchFilesQuery, SearchFilesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchFilesQuery, SearchFilesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchFilesQuery, SearchFilesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SearchFilesQuery, SearchFilesQueryVariables>(SearchFilesDocument, variables, options);
}
export type SearchFilesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchFilesQuery, SearchFilesQueryVariables>;
export const SearchUsersDocument = gql`
    query SearchUsers($query: String!, $withConnectedWallets: Boolean, $next: [Any]) {
  searchUsers(
    query: $query
    withConnectedWallets: $withConnectedWallets
    next: $next
  ) {
    users {
      id
      name
      avatarUrl
      username
    }
    next
  }
}
    `;

/**
 * __useSearchUsersQuery__
 *
 * To run a query within a Vue component, call `useSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchUsersQuery({
 *   query: // value for 'query'
 *   withConnectedWallets: // value for 'withConnectedWallets'
 *   next: // value for 'next'
 * });
 */
export function useSearchUsersQuery(variables: SearchUsersQueryVariables | VueCompositionApi.Ref<SearchUsersQueryVariables> | ReactiveFunction<SearchUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchUsersQuery, SearchUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchUsersQuery, SearchUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchUsersQuery, SearchUsersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, variables, options);
}
export function useSearchUsersLazyQuery(variables?: SearchUsersQueryVariables | VueCompositionApi.Ref<SearchUsersQueryVariables> | ReactiveFunction<SearchUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchUsersQuery, SearchUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchUsersQuery, SearchUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchUsersQuery, SearchUsersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, variables, options);
}
export type SearchUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchUsersQuery, SearchUsersQueryVariables>;
export const SearchEntitiesDocument = gql`
    query SearchEntities($query: String!, $filterBy: EntityType, $showOwnEntity: Boolean, $next: [Any]) {
  searchEntities(
    query: $query
    filterBy: $filterBy
    showOwnEntity: $showOwnEntity
    next: $next
  ) {
    entities {
      ...BasicUserFields
      ...OrganizationFields
    }
    next
  }
}
    ${BasicUserFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}`;

/**
 * __useSearchEntitiesQuery__
 *
 * To run a query within a Vue component, call `useSearchEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEntitiesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchEntitiesQuery({
 *   query: // value for 'query'
 *   filterBy: // value for 'filterBy'
 *   showOwnEntity: // value for 'showOwnEntity'
 *   next: // value for 'next'
 * });
 */
export function useSearchEntitiesQuery(variables: SearchEntitiesQueryVariables | VueCompositionApi.Ref<SearchEntitiesQueryVariables> | ReactiveFunction<SearchEntitiesQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchEntitiesQuery, SearchEntitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchEntitiesQuery, SearchEntitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchEntitiesQuery, SearchEntitiesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchEntitiesQuery, SearchEntitiesQueryVariables>(SearchEntitiesDocument, variables, options);
}
export function useSearchEntitiesLazyQuery(variables?: SearchEntitiesQueryVariables | VueCompositionApi.Ref<SearchEntitiesQueryVariables> | ReactiveFunction<SearchEntitiesQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchEntitiesQuery, SearchEntitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchEntitiesQuery, SearchEntitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchEntitiesQuery, SearchEntitiesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SearchEntitiesQuery, SearchEntitiesQueryVariables>(SearchEntitiesDocument, variables, options);
}
export type SearchEntitiesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchEntitiesQuery, SearchEntitiesQueryVariables>;
export const FoldersDocument = gql`
    query Folders($id: ID!, $next: [Any]) {
  folders(id: $id, next: $next) {
    id
    name
    parentFolderId
    next
    items {
      name
      id
      type
      parentPath
    }
  }
}
    `;

/**
 * __useFoldersQuery__
 *
 * To run a query within a Vue component, call `useFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoldersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFoldersQuery({
 *   id: // value for 'id'
 *   next: // value for 'next'
 * });
 */
export function useFoldersQuery(variables: FoldersQueryVariables | VueCompositionApi.Ref<FoldersQueryVariables> | ReactiveFunction<FoldersQueryVariables>, options: VueApolloComposable.UseQueryOptions<FoldersQuery, FoldersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FoldersQuery, FoldersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FoldersQuery, FoldersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FoldersQuery, FoldersQueryVariables>(FoldersDocument, variables, options);
}
export function useFoldersLazyQuery(variables?: FoldersQueryVariables | VueCompositionApi.Ref<FoldersQueryVariables> | ReactiveFunction<FoldersQueryVariables>, options: VueApolloComposable.UseQueryOptions<FoldersQuery, FoldersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FoldersQuery, FoldersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FoldersQuery, FoldersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FoldersQuery, FoldersQueryVariables>(FoldersDocument, variables, options);
}
export type FoldersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FoldersQuery, FoldersQueryVariables>;
export const CopyrightTransactionsDocument = gql`
    query CopyrightTransactions($type: CopyrightTransactionQueryType!, $sortBy: SearchSort, $next: [Any]) {
  copyrightTransactions(type: $type, sortBy: $sortBy, next: $next) {
    next
    copyrightTransactions {
      tokenId
      contractAddress
      status
      type
      timestamp
      file {
        ...FileFields
      }
      transaction {
        hash
        url
        chain {
          id
        }
      }
      wallet {
        address
        type
      }
      owner {
        ...BasicUserFields
        ...OrganizationFields
      }
      sender {
        ...BasicUserFields
        ...OrganizationFields
      }
      receiver {
        ...BasicUserFields
        ...OrganizationFields
      }
      receiverAddress
      price {
        value
        currency
        decimalDigits
      }
      royaltyDacr {
        feeNumerator
        feeDenominator
      }
      royaltyOwner {
        feeNumerator
        feeDenominator
      }
      licenseAction {
        status
        fromAddress
        toAddress
        tokenId
        startsAt
        endsAt
        type
        referenceId
        contractAddress
        allowSellOrTransfer
        agreement {
          type
          content
          isPublic
        }
        licenseToOthers {
          agreement {
            type
            content
            isPublic
          }
          currentSaleQuantity
          saleQuantity
          startsAt
          endsAt
        }
        total {
          value
          currency
          decimalDigits
        }
        royaltyOwnerAmount {
          value
          currency
          decimalDigits
        }
        royaltyDacrAmount {
          value
          currency
          decimalDigits
        }
        royaltyDacr {
          feeNumerator
          feeDenominator
        }
        royaltyOwner {
          feeNumerator
          feeDenominator
        }
      }
    }
  }
}
    ${FileFieldsFragmentDoc}
${BasicUserFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}`;

/**
 * __useCopyrightTransactionsQuery__
 *
 * To run a query within a Vue component, call `useCopyrightTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCopyrightTransactionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCopyrightTransactionsQuery({
 *   type: // value for 'type'
 *   sortBy: // value for 'sortBy'
 *   next: // value for 'next'
 * });
 */
export function useCopyrightTransactionsQuery(variables: CopyrightTransactionsQueryVariables | VueCompositionApi.Ref<CopyrightTransactionsQueryVariables> | ReactiveFunction<CopyrightTransactionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<CopyrightTransactionsQuery, CopyrightTransactionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CopyrightTransactionsQuery, CopyrightTransactionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CopyrightTransactionsQuery, CopyrightTransactionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CopyrightTransactionsQuery, CopyrightTransactionsQueryVariables>(CopyrightTransactionsDocument, variables, options);
}
export function useCopyrightTransactionsLazyQuery(variables?: CopyrightTransactionsQueryVariables | VueCompositionApi.Ref<CopyrightTransactionsQueryVariables> | ReactiveFunction<CopyrightTransactionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<CopyrightTransactionsQuery, CopyrightTransactionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CopyrightTransactionsQuery, CopyrightTransactionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CopyrightTransactionsQuery, CopyrightTransactionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CopyrightTransactionsQuery, CopyrightTransactionsQueryVariables>(CopyrightTransactionsDocument, variables, options);
}
export type CopyrightTransactionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CopyrightTransactionsQuery, CopyrightTransactionsQueryVariables>;
export const ExchangeRateDocument = gql`
    query ExchangeRate {
  exchangeRate
}
    `;

/**
 * __useExchangeRateQuery__
 *
 * To run a query within a Vue component, call `useExchangeRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useExchangeRateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExchangeRateQuery();
 */
export function useExchangeRateQuery(options: VueApolloComposable.UseQueryOptions<ExchangeRateQuery, ExchangeRateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExchangeRateQuery, ExchangeRateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExchangeRateQuery, ExchangeRateQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExchangeRateQuery, ExchangeRateQueryVariables>(ExchangeRateDocument, {}, options);
}
export function useExchangeRateLazyQuery(options: VueApolloComposable.UseQueryOptions<ExchangeRateQuery, ExchangeRateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExchangeRateQuery, ExchangeRateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExchangeRateQuery, ExchangeRateQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExchangeRateQuery, ExchangeRateQueryVariables>(ExchangeRateDocument, {}, options);
}
export type ExchangeRateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExchangeRateQuery, ExchangeRateQueryVariables>;
export const PlansQueryDocument = gql`
    query PlansQuery($accessToken: ID) {
  plans(accessToken: $accessToken) {
    activeBillingCycleType
    defaultBillingCycleType
    groupByBillingCycle {
      billingCycleType
      billingCycleDescription
      billingCycleCallout
      plans {
        ...PlanFields
      }
    }
  }
}
    ${PlanFieldsFragmentDoc}`;

/**
 * __usePlansQueryQuery__
 *
 * To run a query within a Vue component, call `usePlansQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlansQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePlansQueryQuery({
 *   accessToken: // value for 'accessToken'
 * });
 */
export function usePlansQueryQuery(variables: PlansQueryQueryVariables | VueCompositionApi.Ref<PlansQueryQueryVariables> | ReactiveFunction<PlansQueryQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<PlansQueryQuery, PlansQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PlansQueryQuery, PlansQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PlansQueryQuery, PlansQueryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PlansQueryQuery, PlansQueryQueryVariables>(PlansQueryDocument, variables, options);
}
export function usePlansQueryLazyQuery(variables: PlansQueryQueryVariables | VueCompositionApi.Ref<PlansQueryQueryVariables> | ReactiveFunction<PlansQueryQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<PlansQueryQuery, PlansQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PlansQueryQuery, PlansQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PlansQueryQuery, PlansQueryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PlansQueryQuery, PlansQueryQueryVariables>(PlansQueryDocument, variables, options);
}
export type PlansQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PlansQueryQuery, PlansQueryQueryVariables>;
export const MyPlanQueryDocument = gql`
    query MyPlanQuery {
  myPlan {
    activeBillingCycleType
    defaultBillingCycleType
    groupByBillingCycle {
      billingCycleType
      billingCycleDescription
      billingCycleCallout
      plans {
        ...PlanFields
      }
    }
  }
}
    ${PlanFieldsFragmentDoc}`;

/**
 * __useMyPlanQueryQuery__
 *
 * To run a query within a Vue component, call `useMyPlanQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPlanQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMyPlanQueryQuery();
 */
export function useMyPlanQueryQuery(options: VueApolloComposable.UseQueryOptions<MyPlanQueryQuery, MyPlanQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MyPlanQueryQuery, MyPlanQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MyPlanQueryQuery, MyPlanQueryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MyPlanQueryQuery, MyPlanQueryQueryVariables>(MyPlanQueryDocument, {}, options);
}
export function useMyPlanQueryLazyQuery(options: VueApolloComposable.UseQueryOptions<MyPlanQueryQuery, MyPlanQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MyPlanQueryQuery, MyPlanQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MyPlanQueryQuery, MyPlanQueryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MyPlanQueryQuery, MyPlanQueryQueryVariables>(MyPlanQueryDocument, {}, options);
}
export type MyPlanQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MyPlanQueryQuery, MyPlanQueryQueryVariables>;
export const BillingQueryDocument = gql`
    query BillingQuery($nextInvoice: Any) {
  billing(nextInvoice: $nextInvoice) {
    ...BillingFields
  }
}
    ${BillingFieldsFragmentDoc}`;

/**
 * __useBillingQueryQuery__
 *
 * To run a query within a Vue component, call `useBillingQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBillingQueryQuery({
 *   nextInvoice: // value for 'nextInvoice'
 * });
 */
export function useBillingQueryQuery(variables: BillingQueryQueryVariables | VueCompositionApi.Ref<BillingQueryQueryVariables> | ReactiveFunction<BillingQueryQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<BillingQueryQuery, BillingQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BillingQueryQuery, BillingQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BillingQueryQuery, BillingQueryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BillingQueryQuery, BillingQueryQueryVariables>(BillingQueryDocument, variables, options);
}
export function useBillingQueryLazyQuery(variables: BillingQueryQueryVariables | VueCompositionApi.Ref<BillingQueryQueryVariables> | ReactiveFunction<BillingQueryQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<BillingQueryQuery, BillingQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BillingQueryQuery, BillingQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BillingQueryQuery, BillingQueryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BillingQueryQuery, BillingQueryQueryVariables>(BillingQueryDocument, variables, options);
}
export type BillingQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BillingQueryQuery, BillingQueryQueryVariables>;
export const InvoicesDocument = gql`
    query Invoices($nextInvoice: Any) {
  invoices(nextInvoice: $nextInvoice) {
    invoices {
      id
      description
      date
      total
      currency
      status
    }
    next
  }
}
    `;

/**
 * __useInvoicesQuery__
 *
 * To run a query within a Vue component, call `useInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useInvoicesQuery({
 *   nextInvoice: // value for 'nextInvoice'
 * });
 */
export function useInvoicesQuery(variables: InvoicesQueryVariables | VueCompositionApi.Ref<InvoicesQueryVariables> | ReactiveFunction<InvoicesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<InvoicesQuery, InvoicesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<InvoicesQuery, InvoicesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<InvoicesQuery, InvoicesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, variables, options);
}
export function useInvoicesLazyQuery(variables: InvoicesQueryVariables | VueCompositionApi.Ref<InvoicesQueryVariables> | ReactiveFunction<InvoicesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<InvoicesQuery, InvoicesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<InvoicesQuery, InvoicesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<InvoicesQuery, InvoicesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, variables, options);
}
export type InvoicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<InvoicesQuery, InvoicesQueryVariables>;
export const FilePrivacyControllersDocument = gql`
    query FilePrivacyControllers($id: ID!, $next: [Any]) {
  filePrivacyControllers(id: $id, next: $next) {
    id
    items {
      entity {
        ...BasicUserFields
        ...OrganizationFields
        ...EmailFields
      }
      statuses
      isDownloadAvailable
    }
    next
  }
}
    ${BasicUserFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}
${EmailFieldsFragmentDoc}`;

/**
 * __useFilePrivacyControllersQuery__
 *
 * To run a query within a Vue component, call `useFilePrivacyControllersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilePrivacyControllersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFilePrivacyControllersQuery({
 *   id: // value for 'id'
 *   next: // value for 'next'
 * });
 */
export function useFilePrivacyControllersQuery(variables: FilePrivacyControllersQueryVariables | VueCompositionApi.Ref<FilePrivacyControllersQueryVariables> | ReactiveFunction<FilePrivacyControllersQueryVariables>, options: VueApolloComposable.UseQueryOptions<FilePrivacyControllersQuery, FilePrivacyControllersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FilePrivacyControllersQuery, FilePrivacyControllersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FilePrivacyControllersQuery, FilePrivacyControllersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FilePrivacyControllersQuery, FilePrivacyControllersQueryVariables>(FilePrivacyControllersDocument, variables, options);
}
export function useFilePrivacyControllersLazyQuery(variables?: FilePrivacyControllersQueryVariables | VueCompositionApi.Ref<FilePrivacyControllersQueryVariables> | ReactiveFunction<FilePrivacyControllersQueryVariables>, options: VueApolloComposable.UseQueryOptions<FilePrivacyControllersQuery, FilePrivacyControllersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FilePrivacyControllersQuery, FilePrivacyControllersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FilePrivacyControllersQuery, FilePrivacyControllersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FilePrivacyControllersQuery, FilePrivacyControllersQueryVariables>(FilePrivacyControllersDocument, variables, options);
}
export type FilePrivacyControllersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FilePrivacyControllersQuery, FilePrivacyControllersQueryVariables>;
export const FileOwnersDocument = gql`
    query FileOwners($id: ID!, $next: [Any]) {
  fileOwners(id: $id, next: $next) {
    items {
      entity {
        ...BasicUserFields
        ...OrganizationFields
        ...EmailFields
      }
      statuses
    }
    next
  }
}
    ${BasicUserFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}
${EmailFieldsFragmentDoc}`;

/**
 * __useFileOwnersQuery__
 *
 * To run a query within a Vue component, call `useFileOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileOwnersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFileOwnersQuery({
 *   id: // value for 'id'
 *   next: // value for 'next'
 * });
 */
export function useFileOwnersQuery(variables: FileOwnersQueryVariables | VueCompositionApi.Ref<FileOwnersQueryVariables> | ReactiveFunction<FileOwnersQueryVariables>, options: VueApolloComposable.UseQueryOptions<FileOwnersQuery, FileOwnersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FileOwnersQuery, FileOwnersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FileOwnersQuery, FileOwnersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FileOwnersQuery, FileOwnersQueryVariables>(FileOwnersDocument, variables, options);
}
export function useFileOwnersLazyQuery(variables?: FileOwnersQueryVariables | VueCompositionApi.Ref<FileOwnersQueryVariables> | ReactiveFunction<FileOwnersQueryVariables>, options: VueApolloComposable.UseQueryOptions<FileOwnersQuery, FileOwnersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FileOwnersQuery, FileOwnersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FileOwnersQuery, FileOwnersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FileOwnersQuery, FileOwnersQueryVariables>(FileOwnersDocument, variables, options);
}
export type FileOwnersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FileOwnersQuery, FileOwnersQueryVariables>;
export const FileAuthorsDocument = gql`
    query FileAuthors($id: ID!, $next: [Any]) {
  fileAuthors(id: $id, next: $next) {
    id
    items {
      entity {
        ...BasicUserFields
        ...OrganizationFields
        ...EmailFields
      }
      statuses
    }
    next
  }
}
    ${BasicUserFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}
${EmailFieldsFragmentDoc}`;

/**
 * __useFileAuthorsQuery__
 *
 * To run a query within a Vue component, call `useFileAuthorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileAuthorsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFileAuthorsQuery({
 *   id: // value for 'id'
 *   next: // value for 'next'
 * });
 */
export function useFileAuthorsQuery(variables: FileAuthorsQueryVariables | VueCompositionApi.Ref<FileAuthorsQueryVariables> | ReactiveFunction<FileAuthorsQueryVariables>, options: VueApolloComposable.UseQueryOptions<FileAuthorsQuery, FileAuthorsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FileAuthorsQuery, FileAuthorsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FileAuthorsQuery, FileAuthorsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FileAuthorsQuery, FileAuthorsQueryVariables>(FileAuthorsDocument, variables, options);
}
export function useFileAuthorsLazyQuery(variables?: FileAuthorsQueryVariables | VueCompositionApi.Ref<FileAuthorsQueryVariables> | ReactiveFunction<FileAuthorsQueryVariables>, options: VueApolloComposable.UseQueryOptions<FileAuthorsQuery, FileAuthorsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FileAuthorsQuery, FileAuthorsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FileAuthorsQuery, FileAuthorsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FileAuthorsQuery, FileAuthorsQueryVariables>(FileAuthorsDocument, variables, options);
}
export type FileAuthorsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FileAuthorsQuery, FileAuthorsQueryVariables>;
export const LicensedToOthersDocument = gql`
    query LicensedToOthers($copyrightId: ID, $sortBy: SearchLicenseSort, $next: [Any]) {
  licensedToOthers(copyrightId: $copyrightId, sortBy: $sortBy, next: $next) {
    items {
      file {
        ...FileFields
      }
      id
      name
      parentFolderId
      parentPath
      timestamp
      numberOfItems
      type
    }
    next
  }
}
    ${FileFieldsFragmentDoc}`;

/**
 * __useLicensedToOthersQuery__
 *
 * To run a query within a Vue component, call `useLicensedToOthersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLicensedToOthersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLicensedToOthersQuery({
 *   copyrightId: // value for 'copyrightId'
 *   sortBy: // value for 'sortBy'
 *   next: // value for 'next'
 * });
 */
export function useLicensedToOthersQuery(variables: LicensedToOthersQueryVariables | VueCompositionApi.Ref<LicensedToOthersQueryVariables> | ReactiveFunction<LicensedToOthersQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<LicensedToOthersQuery, LicensedToOthersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LicensedToOthersQuery, LicensedToOthersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LicensedToOthersQuery, LicensedToOthersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LicensedToOthersQuery, LicensedToOthersQueryVariables>(LicensedToOthersDocument, variables, options);
}
export function useLicensedToOthersLazyQuery(variables: LicensedToOthersQueryVariables | VueCompositionApi.Ref<LicensedToOthersQueryVariables> | ReactiveFunction<LicensedToOthersQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<LicensedToOthersQuery, LicensedToOthersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LicensedToOthersQuery, LicensedToOthersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LicensedToOthersQuery, LicensedToOthersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LicensedToOthersQuery, LicensedToOthersQueryVariables>(LicensedToOthersDocument, variables, options);
}
export type LicensedToOthersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LicensedToOthersQuery, LicensedToOthersQueryVariables>;
export const LicensedToMeDocument = gql`
    query LicensedToMe($sortBy: SearchLicenseSort, $next: [Any]) {
  licensedToMe(sortBy: $sortBy, next: $next) {
    items {
      file {
        ...FileFields
      }
      id
      name
      parentFolderId
      parentPath
      timestamp
      numberOfItems
      type
    }
    next
  }
}
    ${FileFieldsFragmentDoc}`;

/**
 * __useLicensedToMeQuery__
 *
 * To run a query within a Vue component, call `useLicensedToMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLicensedToMeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLicensedToMeQuery({
 *   sortBy: // value for 'sortBy'
 *   next: // value for 'next'
 * });
 */
export function useLicensedToMeQuery(variables: LicensedToMeQueryVariables | VueCompositionApi.Ref<LicensedToMeQueryVariables> | ReactiveFunction<LicensedToMeQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<LicensedToMeQuery, LicensedToMeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LicensedToMeQuery, LicensedToMeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LicensedToMeQuery, LicensedToMeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LicensedToMeQuery, LicensedToMeQueryVariables>(LicensedToMeDocument, variables, options);
}
export function useLicensedToMeLazyQuery(variables: LicensedToMeQueryVariables | VueCompositionApi.Ref<LicensedToMeQueryVariables> | ReactiveFunction<LicensedToMeQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<LicensedToMeQuery, LicensedToMeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LicensedToMeQuery, LicensedToMeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LicensedToMeQuery, LicensedToMeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LicensedToMeQuery, LicensedToMeQueryVariables>(LicensedToMeDocument, variables, options);
}
export type LicensedToMeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LicensedToMeQuery, LicensedToMeQueryVariables>;
export const CopyrightOwnersDocument = gql`
    query CopyrightOwners($next: [Any]) {
  copyrightOwners(next: $next) {
    total
    items {
      id
      name
      avatarUrl
      isSelected
      type
    }
    next
  }
}
    `;

/**
 * __useCopyrightOwnersQuery__
 *
 * To run a query within a Vue component, call `useCopyrightOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCopyrightOwnersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCopyrightOwnersQuery({
 *   next: // value for 'next'
 * });
 */
export function useCopyrightOwnersQuery(variables: CopyrightOwnersQueryVariables | VueCompositionApi.Ref<CopyrightOwnersQueryVariables> | ReactiveFunction<CopyrightOwnersQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<CopyrightOwnersQuery, CopyrightOwnersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CopyrightOwnersQuery, CopyrightOwnersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CopyrightOwnersQuery, CopyrightOwnersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CopyrightOwnersQuery, CopyrightOwnersQueryVariables>(CopyrightOwnersDocument, variables, options);
}
export function useCopyrightOwnersLazyQuery(variables: CopyrightOwnersQueryVariables | VueCompositionApi.Ref<CopyrightOwnersQueryVariables> | ReactiveFunction<CopyrightOwnersQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<CopyrightOwnersQuery, CopyrightOwnersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CopyrightOwnersQuery, CopyrightOwnersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CopyrightOwnersQuery, CopyrightOwnersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CopyrightOwnersQuery, CopyrightOwnersQueryVariables>(CopyrightOwnersDocument, variables, options);
}
export type CopyrightOwnersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CopyrightOwnersQuery, CopyrightOwnersQueryVariables>;
export const CopyrightOwnersNewDocument = gql`
    query CopyrightOwnersNew($next: [Any]) {
  copyrightOwnersNew(next: $next) {
    total
    items {
      id
      name
      avatarUrl
      isSelected
      type
      owner {
        ...BasicUserFields
      }
    }
    next
  }
}
    ${BasicUserFieldsFragmentDoc}`;

/**
 * __useCopyrightOwnersNewQuery__
 *
 * To run a query within a Vue component, call `useCopyrightOwnersNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCopyrightOwnersNewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCopyrightOwnersNewQuery({
 *   next: // value for 'next'
 * });
 */
export function useCopyrightOwnersNewQuery(variables: CopyrightOwnersNewQueryVariables | VueCompositionApi.Ref<CopyrightOwnersNewQueryVariables> | ReactiveFunction<CopyrightOwnersNewQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<CopyrightOwnersNewQuery, CopyrightOwnersNewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CopyrightOwnersNewQuery, CopyrightOwnersNewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CopyrightOwnersNewQuery, CopyrightOwnersNewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CopyrightOwnersNewQuery, CopyrightOwnersNewQueryVariables>(CopyrightOwnersNewDocument, variables, options);
}
export function useCopyrightOwnersNewLazyQuery(variables: CopyrightOwnersNewQueryVariables | VueCompositionApi.Ref<CopyrightOwnersNewQueryVariables> | ReactiveFunction<CopyrightOwnersNewQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<CopyrightOwnersNewQuery, CopyrightOwnersNewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CopyrightOwnersNewQuery, CopyrightOwnersNewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CopyrightOwnersNewQuery, CopyrightOwnersNewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CopyrightOwnersNewQuery, CopyrightOwnersNewQueryVariables>(CopyrightOwnersNewDocument, variables, options);
}
export type CopyrightOwnersNewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CopyrightOwnersNewQuery, CopyrightOwnersNewQueryVariables>;
export const OnboardingDocument = gql`
    query Onboarding {
  onboarding {
    step
    completed
  }
}
    `;

/**
 * __useOnboardingQuery__
 *
 * To run a query within a Vue component, call `useOnboardingQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useOnboardingQuery();
 */
export function useOnboardingQuery(options: VueApolloComposable.UseQueryOptions<OnboardingQuery, OnboardingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OnboardingQuery, OnboardingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OnboardingQuery, OnboardingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<OnboardingQuery, OnboardingQueryVariables>(OnboardingDocument, {}, options);
}
export function useOnboardingLazyQuery(options: VueApolloComposable.UseQueryOptions<OnboardingQuery, OnboardingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OnboardingQuery, OnboardingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OnboardingQuery, OnboardingQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<OnboardingQuery, OnboardingQueryVariables>(OnboardingDocument, {}, options);
}
export type OnboardingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<OnboardingQuery, OnboardingQueryVariables>;
export const ReportDocument = gql`
    query Report($id: ID!) {
  report(id: $id) {
    status
    data {
      id
      summary
      createdAt
      matchScore
      attributes {
        key
        value
      }
      originalFile {
        id
        name
        type
        width
        height
        previewImageUrl
      }
      infringingFile {
        id
        name
        type
        width
        height
        previewImageUrl
      }
      matchQuantity
      matches {
        original {
          id
          matchScore
          matchType
          file {
            id
            name
            type
            width
            height
            previewImageUrl
          }
          matchType
          coords
          location
          imageUrl
          description
        }
        infringing {
          id
          matchScore
          matchType
          file {
            id
            name
            type
            width
            height
            previewImageUrl
          }
          matchType
          coords
          location
          imageUrl
          description
        }
      }
    }
  }
}
    `;

/**
 * __useReportQuery__
 *
 * To run a query within a Vue component, call `useReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReportQuery({
 *   id: // value for 'id'
 * });
 */
export function useReportQuery(variables: ReportQueryVariables | VueCompositionApi.Ref<ReportQueryVariables> | ReactiveFunction<ReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<ReportQuery, ReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReportQuery, ReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReportQuery, ReportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ReportQuery, ReportQueryVariables>(ReportDocument, variables, options);
}
export function useReportLazyQuery(variables?: ReportQueryVariables | VueCompositionApi.Ref<ReportQueryVariables> | ReactiveFunction<ReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<ReportQuery, ReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReportQuery, ReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReportQuery, ReportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ReportQuery, ReportQueryVariables>(ReportDocument, variables, options);
}
export type ReportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ReportQuery, ReportQueryVariables>;